// Copyright (c) 2024 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect, useDispatch } from 'react-redux'
import debounce from 'lodash/debounce'
// import throttle from 'lodash/throttle'
import { Card, Col, Container, Form, Image, InputGroup, ListGroup, Row } from 'react-bootstrap'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
// FormLabel
import { EMPTY_ARRAY, EMPTY_OBJECT, getSvgIcon, getWalletScriptUrl, validPhone } from '../../constants/globalConstants'
import { Controller, useForm } from 'react-hook-form'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { Link, useParams, useNavigate, useSearchParams, useLocation } from 'react-router-dom'
// import DatePicker from 'react-mobile-datepicker'
// import DatePicker from 'react-datepicker'
import { getFaciltyData, postCardPaymentDetails, fetchRateBands, fetchRateDetailData } from '../../redux/actions/transientAction'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
import 'react-toastify/dist/ReactToastify.css'
import {
    encryptionHandler,
    getFormattedTime,
    getCardIcon, getFieldValue, getHoursForRateBand, isPermissionExist, isPromoValidateButton, loggedInUserData,
    priceGreaterOrNot,
    sortPortalPermissionByKey,
    TimeConversion,
    getConvertedDate,
    // convertTimeToDoubleDig,
    TimeConversionInHours,
    timeValidationConversion,
    // restrictInValidCharPassword,
    restrictInValidCharLicense,
    getHoursIndayFormat,
    getbase64EncodedString,
    isVehicleLimitExceeded,
    getDeviceType,
    showhideWalletButton,
    isHtmlRenderingVisibleContent,
    // isBase64
    // getDeviceType
} from '../../utils/helper'
import URL from '../../constants/urls'
import './Trans.scss'
import Loader from '../../global/Loader'
// import Footer from '../../components/global/Footer'
import NoData from '../../components/NoData'
import MiniHeader from '../../components/global/MiniHeader'
import { errorMessage } from '../../constants/errorMessage'
import { getStartDateByAPI, getTicketDetails } from '../../redux/actions/userDetails'
import PaymentGateDc from './PaymentGatwayDc'
// import axios from 'axios'
import UpperHeader from '../../components/global/UpperHeader'
import AmountPaid from '../../components/global/AmountPaid'
// import DownloadApp from '../../components/global/DownloadApp'
import PromoCode from '../../components/global/PromoCode'
import PaymentBreakUpDetails from '../../components/global/PaymentBreakUpDetails'
import { getVehilceData, getVehicleModelList } from '../../redux/actions/VehicleAction'
import VehicleHod from '../vehicle/VehicleHod'
import { getCardLists } from '../../redux/actions/PaymentAction'
import PaymentModal from '../../components/global/Payment/PaymentModal'
// import { Circles } from 'react-loader-spinner'
import { checkActiveSession } from '../../redux/actions/ReceiptsAction'
import ConfirmationTerms from '../../global/ConfirmationTerms'
import CommonListModal from '../../global/CommonListModal'
// rate band
import { getCardListsAuto } from '../../redux/actions/PaymentAction'

import RateBandDropDownList from '../../global/RateBandDropDownModal'
// 
// import carImage from '../../assets/img/vehicle.png'
// import card_top_image from '../../assets/img/card_top.png'
import ReactMobiltySpinner from '../../global/ReactMobiltySpinner'
import moment from 'moment-timezone'
import ParkingSchModal from '../../global/ParkingSchModal'
import { Circles } from 'react-loader-spinner'
import ScrollCalendar from '../scrollCalendar/ScrollCalendar'
// import ActiveSession from '../../components/global/ActiveSession'
import { getConfigDetails } from '../../services/config'
import ReservationWithID from '../../components/global/ReservationWithID'
import RateDetailsModal from '../../components/global/RateBand/RateDetailsModal'
import WalletButtons from '../../components/walletButtons'
import { addScript } from '../../utils/addScript'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
import PastDatePicker from '../../global/DateSelect'
import { formatExpiryDate } from '../../utils/helper'

import ConfirmationModalCommon from '../../global/ConfirmationModalCommon'
// import SupportButton from '../../components/global/Support/SupportButton'
// import { data } from 'jquery'



function TransientForm(props) {
    const { register, unregister, handleSubmit, clearErrors, formState: { errors }, control, setValue, reset, getValues, setFocus, trigger, setError, } = useForm({
        shouldUnregister: true
    })
    const [faciltyData, setFaciltyData] = useState(EMPTY_OBJECT)
    const [timeDuration, setTimeDuration] = useState({ days: '0', hours: '0', minutes: '0' })
    const [totalHoursLength, setTotalHoursLength] = useState('0.00')
    const [stateList, setStateList] = useState(EMPTY_ARRAY)
    const [checkInData, setCheckInData] = useState(EMPTY_OBJECT)
    const [ticketDetails, setTicketDetails] = useState(EMPTY_OBJECT)
    const [localTicket, setLocalTicket] = useState(null)
    const [isReloadRates, setIsReloadRates] = useState({
        check: false,
        modal: false
    })
    const [errorMessageLocal, setErrorMessageLocal] = useState('')
    const [checkPromo, setCheckPromo] = useState(0)
    const [isTokenApiStarts, setIsTokenApiStart] = useState(false)
    const [loginData, setLoginData] = useState(EMPTY_OBJECT)
    const [isDisplayDetails, setIsDisplayDetails] = useState(false)
    const [isVehicleModalOpen, setIsVehicleModalOpen] = useState(false)
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)
    const [isCheckingActiveSession, setIsCheckingActiveSession] = useState(true)
    const [isConfimationModalOpen, setIsConfimationModalOpen] = useState(false)
    const [formData, setFormData] = useState(EMPTY_OBJECT)
    const [cardData, setCardData] = useState(EMPTY_ARRAY)
    const [vehicleData, setVehicleData] = useState(EMPTY_ARRAY)
    const [isCommonModalOpen, setCommonModal] = useState(false)
    const [currentSelVehicle, setCurrentVehicle] = useState(EMPTY_OBJECT)
    const [currentSelCard, setCurrentCard] = useState(EMPTY_OBJECT)
    const [selOptionFlag, setSelOptionFlag] = useState('')
    // 
    const [warningMessageSchdule, setWarningPark] = useState(false)
    const [avalablityAlert, setAvalablityAlertIsOpen] = useState(false)
    const [availabilityMessage, setAvalablityMessage] = useState('')
    const [warningMessage, setWarningMessage] = useState('')
    const [hoursOfOper, setHoursOfOper] = useState(EMPTY_ARRAY)
    const [midnighNote, setShowMidnightNote] = useState(false)
    const [isSubmittingForm, setIsSubmittingForm] = useState(false)
    const [onSubmitData, setOnSubmitData] = useState(EMPTY_OBJECT)
    // const [currentRateBand, setCurrentRateBand] = useState(EMPTY_OBJECT)

    // rate Band 
    const [isDisplayRateBand, setIsDisplayRateBand] = useState(false)
    const [isRateBandModalOpen, setIsRateBandModalOpen] = useState(false)
    const [rateBandData, setRateBandData] = useState(EMPTY_ARRAY)
    const [events, setEvents] = useState(EMPTY_ARRAY)
    const [bandMsge, setBandMsge] = useState('')
    const [eventMessage, setEventMessage] = useState('')
    const [selectedEv, setSelectedEv] = useState(null)
    const [rateBands, setRateBands] = useState(EMPTY_ARRAY)
    const [seletedRateBand, setSeletedRateBand] = useState('')
    const [isValidPartner, setIsValidPartner] = useState(true)
    const [partnerdetails, setPartnerDetails] = useState(EMPTY_OBJECT)
    const [isScrollCalendarModal, setIsScrollCalendarModal] = useState(false)
    const [vehicleDetailsList, setVehicleDetailsList] = useState(EMPTY_ARRAY)
    const [vehicleModel, setvehicleModel] = useState(EMPTY_ARRAY)
    const [vehicleMakeList, setVehicleMakeList] = useState(EMPTY_ARRAY)
    const [vehicleModelList, setvehicleModelList] = useState(EMPTY_ARRAY)
    const [othermake, SetOtherMake] = useState(false)
    const [othermodel, SetOtherModel] = useState(false)
    const [verifyDetails, setVerifyDetails] = useState(true)
    const [isPriceZero, setIsPriceZero] = useState(true)
    const [isIOSDevice, setIsIOSdevice] = useState(false)
    const [rateToRefresh, setRateToRefresh] = useState(false)
    const [isModalFastTrackOpen, setIsModalFastTrackOpen] = useState(false)
    const [cardToken, setCardToken] = useState('')

    // IF NEED TO DISPLAY THE TIMER OF ACTIVE CHECKIN
    // const [activeSessionData, setActiveSessionData] = useState(EMPTY_OBJECT)
    const [selctedDateTime, setselctedDateTime] = useState({
        active: false,
        price: null,
        daysHrs: null,
        dateUntill: null,
        bandActive: false,
    })
    const [rateDetailModal, setRateDetailModal] = useState({
        modal: false,
        details: null
    })
    const [reservationData, setReservationData] = useState({
        reservationID: null,
        license_plate: null
    })
    const [isResetModalOpen, setResetModalOpen] = useState(false)
    const [rateObj, setRateObj] = useState({
        loader: false,
        data: null
    })
    const [indexForCalc, setIndexForCalc] = useState({
        eventsIndex: null,
        bandIndex: 0,
    })
    const [updatedFacilityDate, setUpdatedFacilityDate] = useState(EMPTY_OBJECT)
    const [resetPromo, setResetPromo] = useState(false)
    const toggle = () => setResetModalOpen(!isResetModalOpen)
    const toggleRevisedPrice = () => setIsReloadRates({ ...isReloadRates, modal: false })

    // to show conditional events or rate band or both 
    const [is_rate_or_event_show, setIsRateOrEventShow] = useState(0)
    const [warningState, setWarningState] = useState(false)
    // end


    const zoneList = [{ val: 'A', name: 'A' }, { val: 'B', name: 'B' }, { val: 'C', name: 'C' }]

    const custDispatch = useDispatch()
    const timeRoundOff = (date) => {
        const start = moment(new Date(date))
        const remainder = 5 - (start.minute() % 5)
        return moment(start).add(remainder, 'minutes').format('MM-DD-YYYY hh:mm A')
    }
    // const d2 = moment(new Date().toLocaleString('en-US', { timeZone: facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York' })).format('MM-DD-YYYY hh:mm A')
    // for pass date selecter calender
    const defaultDate = moment().format('YYYY-MM-DD hh:mm:ss')
    const [pastCalenderOpen, setPastCalenderOpen] = useState(false)
    const [selectedPastDate, setSelectedPastDate] = useState(null)
    const [entryDateTime, setEntryDateTime] = useState(defaultDate)
    const [isRateBandSelected, setIsRateBandSelected] = useState(false)
    const [isRateMisMatch, setIsRateMisMatch] = useState(false)
    const [mismatchRateError, setMismatchRateError] = useState('')
    const [rateFetchPayload, setRateFetchPayload] = useState(EMPTY_OBJECT)
    const [qrcodeId, setQrcodeId] = useState(null)
    const [customeLoaderForRateBand, setCustomeLoaderForRateBand] = useState(false)
    const [pageOnLoad, setPageOnLoad] = useState(true)
    const [facilityLocData, setFacilityLocData] = useState(EMPTY_OBJECT)
    //const [exitDateTime,setExitDateTime] = useState(new Date())

    const [promoCode, setPromoCode] = useState('')
    const [isRateChangedWithPromo, setIsRateChangedWithPromo] = useState(false)
    const [activesessionMessage, setActivesessionMessage] = useState('')
    const [isPromoCodeAppiled, setIsPromoCodeApplied] = useState(false)
    const [durationSelector, setDurationSelector] = useState(1)
    const [passEntryCheck, setPassEntryCheck] = useState({
        type: null,
        pass_code: '',
        pass_code_phone: ''
    })


    const isOversizedVehicleRef = useRef(null)

    const targetRef = useRef(null)
    const passcodeRef = useRef(null)
    const permitcodeRef = useRef(null)
    const selectedPastDateRef = useRef(null)
    const [walletButtonShow, setWalletButtonShow] = useState(null)
    const applePaySessionRef = useRef(null)

    const [isFastTrackChecked, setIsFastTrackChecked] = useState(false)
    const [isFastTrackCard, setIsFastTrackCard] = useState(true)
    const [firstTimeFastTrackEnable, setFirstTimeFastTrackEnable] = useState(false)


    // params 
    // let { facility, partner, route } = useParams()

    // UPBL-122
    let { encFacility, partner, route } = useParams()
    // const urlArray = window?.location?.toString()?.split('/')
    // const urlArrayLength = urlArray?.length
    // const encryptFacility = urlArray?.[urlArrayLength - 1]
    // UPBL-122


    let queryUrl = useLocation().search
    const { dispatch, loader, notify, vehicleDataList, cards, isFetchingPartner, partnerDetails, facility_loaded, priceBandLoad, fetchRateLoader, isWelcomePopup } = props
    const { ref } = register('phone')
    const navigate = useNavigate()
    const loaded = useRef(false)
    const localTicketRef = useRef(localTicket)
    const getfacilityAPI = useRef(0)
    const [termsAndCondition, setTermsAndCondion] = useState(true)
    const handleChangeReq = useRef(0)
    const partnerDetailsRef = useRef(partnerDetails)

    const startDateAPIRes = useRef(null)

    // UPBL-122
    let facility = encFacility ? encFacility : partnerDetails?.facility?.encrypted_key ? partnerDetails?.facility?.encrypted_key : getbase64EncodedString(partnerDetails?.request_param)

    const [searchParams] = useSearchParams()
    const queryLicensePlate = searchParams.get('license_plate')
    const queryMobilePhone = searchParams.get('mobile_phone')
    const [resetBand, setresetBand] = useState(null)
    const [resetDuration, setResetDuration] = useState(null)
    const [fastTrackData, setFastTrackData] = useState(EMPTY_OBJECT)

    useEffect(() => {
        getDetailsFronQuery(false)
    }, [EMPTY_ARRAY, queryLicensePlate, queryMobilePhone])

    const phoneRef = useRef('')
    const bandRef = useRef([])
    const isDefaultFastTrackDisableRef = useRef(false)
    const isDefaultFastTrackEnabledRef = useRef(false)
    const curRateBandRef = useRef(null)
    const [oversizeLoader, setOversizeLoader] = useState(false)
    const [disableRates, setDisableRates] = useState(false)
    const [phoneEmailError, setPhoneEmailError] = useState(false)

    useEffect(() => {
        setVerifyDetails(true)
        setTermsAndCondion(false)
        setValue('termsnconds', false)
        const deviceType = getDeviceType()
        setIsIOSdevice(deviceType)
        setFocus('phone')
    }, [setFocus])

    useEffect(() => {
        localTicketRef.current = localTicket
    }, [localTicket])

    useEffect(() => {
        const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
        setFacilityLocData(facilityLocData)

    }, [EMPTY_ARRAY])

    useEffect(() => {
        if (durationSelector == 0 || !isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Enable Name Fields - Transient')) {
            unregister('first_name')
            unregister('last_name')
            clearErrors(['first_name', 'last_name'])
        }
    }, [durationSelector])

    useEffect(() => {
        if (faciltyData?.facility) {
            const d2 = new Date(getConvertedDate(moment(new Date()).tz(faciltyData?.facility?.timezone ? faciltyData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
            localStorage.removeItem('seletedRateBand')
            // localStorage.removeItem('faclityData')
            // localStorage.removeItem('partnerData')
            // localStorage.removeItem('local_ticket')
            setLocalTicket(null)
            setEntryDateTime(d2)
            setWalletButtonShow(showhideWalletButton(faciltyData?.facility ? faciltyData?.facility : facilityLocData?.facility))
            if (((faciltyData?.facility?.facility_configuration?.terms_condition_content && faciltyData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '')) && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox')) {
                setTermsAndCondion(false)
                setValue('termsnconds', false)
            }
            if (isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Display Desired Start Date - Ungated')) {
                setSelectedPastDate(moment(getConvertedDate(new Date())).tz(faciltyData?.facility?.timezone ? faciltyData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss'))
            }
        }

    }, [faciltyData?.facility?.id])

    useEffect(() => {
        if (facility == 'undefined' && route == 'undefined') {
            setTimeout(() => {
                navigate(`/${partner}`)
            }, 800)
        }
    }, [])

    useEffect(() => {
        if (isFastTrackChecked && isFastTrackCard && fastTrackData && Object.keys(fastTrackData).length == 0) {
            setFirstTimeFastTrackEnable(true)
        } else {
            setFirstTimeFastTrackEnable(false)
        }
    }, [isFastTrackChecked, isFastTrackCard, fastTrackData])



    useEffect(() => {
        // window.scrollTo(0, 0)
        // localStorage.setItem('history', JSON.stringify({ route: route, facility: facility + (queryUrl ? queryUrl : '') }))
        if (route != 'not-found' && route != 'undefined') {
            localStorage.setItem('history', JSON.stringify({ route: route, facility: facility + (queryUrl ? queryUrl : '') }))
        }
        const loginData = loggedInUserData()
        const facilityLocHost = JSON.parse(localStorage.getItem('faclityData'))
        const localFacilityID = facilityLocHost?.facility?.id ? facilityLocHost.facility.id : null
        setLoginData(loginData)

        // get partner by slug
        if (partner) {
            // dispatch(getPartnerDetailsBySLug(partner)).then((res) => {
            if (partnerDetails?.email) {
                dispatch(getVehicleModelList()).then((res) => {
                    getVehicle(res)
                })
                setPartnerDetails(partnerDetails)
                partnerDetailsRef.current = partnerDetails
                setIsValidPartner(true)

                localStorage.removeItem('partnerData')
                localStorage.setItem('partnerData', JSON.stringify(partnerDetails))
                const partnerData = partnerDetails

                const color = partnerData?.brand_setting?.color
                const rgb = JSON.parse(partnerData?.brand_setting?.rgb_color)
                if (color) {
                    document.documentElement.style.setProperty('--bs-primary', color)
                    document.documentElement.style.setProperty('base-color', color)
                    document.documentElement.style.setProperty('primary', color)
                    document.documentElement.style.setProperty('textcolor', color)
                    document.documentElement.style.setProperty('--bs-btn-bg', color)
                    document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
                    document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
                    document.documentElement.style.setProperty('--bs-list-group-active-color', color)
                    document.documentElement.style.setProperty('--bs-list-group-active-bg', color)

                    if (facility && facility != undefined && facility != 'undefined') {
                        resetBandDurations()
                        const finalPayload = { 'encrypt': facility }
                        // if (loginData?.access_token) {
                        //     finalPayload.user_id = loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : ''
                        // }
                        if (!loginData?.access_token) {
                            handlePostApiForUpdatedList(finalPayload, false, false, true, currentSelVehicle, facility_loaded, selectedPastDate, {}, false)
                        }
                    } else {
                        notify('error', 'Sorry something went wrong, Please refresh or try again.')
                        let errObject = {
                            payload: facility,
                            error: facility,
                            errorMessage: 'Sorry something went wrong, Please refresh or try again.'
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} handlePostApiForUpdatedList-TransientForm.js-259`))
                    }

                    // const d2 = moment(new Date().toLocaleString('en-US', { timeZone: facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York' })).format('MM-DD-YYYY hh:mm A')
                    const d2 = new Date(getConvertedDate(moment(new Date()).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
                    let dateTime = timeRoundOff(d2)
                    let dateTimeStart = new Date(dateTime)
                    setValue('entry_time', dateTimeStart)
                    // setEntryDateTime(d2)
                }

            } else {
                if (partnerDetails) {
                    setIsValidPartner(true)
                } else {
                    setIsValidPartner(false)
                }
                localStorage.removeItem('partnerData')
            }
        }





        // IF NEED TO DISPLAY THE TIMER OF ACTIVE CHECKIN
        // if (loggedInUserData()?.access_token) {
        //     getUserActiveCheckins()
        // }

        if (loginData?.access_token) {

            dispatch(getVehilceData()).then((res) => {
                setVehicleData(res?.data?.data)
                // const filterobj = res?.data?.data?.filter((item) => item?.is_default == '1')
                // reset(formValues => ({ ...formValues, 'vehicle_id': filterobj.length > 0 ? filterobj?.[0]?.id : res?.data?.data?.[0]?.id }))
                // setCurrentVehicle(filterobj.length > 0 ? filterobj?.[0] : res?.data?.data?.[0])
                getDetailsFronQuery(true, res?.data?.data)
            }).catch((err) => {
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                let errObject = {
                    payload: '',
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getVehilceData-TransientForm.js-291`))
            })
            // if (localFacilityID) {
            dispatch(getCardLists()).then((res) => {
                setCardData(res?.data?.payments)
                let defaultCard = res?.data?.payments?.filter((item) => {
                    return item.is_default == '1'
                })
                reset(formValues => ({ ...formValues, 'card_id': defaultCard?.length > 0 ? defaultCard?.[0]?.payment_profile_id : res?.data?.payments?.[0]?.card_holder_id }))
                setCurrentCard(defaultCard?.length > 0 ? defaultCard?.[0] : res?.data?.payments?.[0])
            }).catch((err) => {

                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                let errObject = {
                    payload: localFacilityID,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getCardLists-TransientForm.js-306`))
            })
            // }
        }

    }, [EMPTY_ARRAY, partnerDetails])

    useEffect(() => {
        if (loginData?.access_token) {
            const curLicense = vehicleData?.filter((item) => {
                return item?.is_default == '1'
            })
            const finalPayload = { 'encrypt': facility }
            if (loginData?.access_token) {
                finalPayload.user_id = loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : ''
            }
            if (curRateBandRef?.current) {
                finalPayload.band_rate = curRateBandRef?.current?.price
                finalPayload.rate_band_id = curRateBandRef?.current?.id
            }
            if (Object.hasOwn(checkInData, 'is_vehicle_oversize')) { // Changes for firefox issue
                finalPayload.is_vehicle_oversize = checkInData?.is_vehicle_oversize ? 0 : 1
                oversizeChangeModule(faciltyData, curLicense?.length > 0 ? curLicense[0]?.license_plate_number : currentSelVehicle?.license_plate_number, checkInData?.phone ? checkInData?.phone : '', selectedPastDate, finalPayload, '', true)
            } else {
                handlePostApiForUpdatedList(finalPayload, false, false, true, curLicense?.length > 0 ? curLicense[0] : currentSelVehicle, facility_loaded, selectedPastDate, {}, false)
            }

        }
    }, [vehicleData])


    useEffect(() => {
        if (facility != undefined || route != undefined) {
            const facilityLocHost = JSON.parse(localStorage.getItem('faclityData'))
            const localFacilityID = facilityLocHost?.facility?.id ? facilityLocHost.facility.id : null
            if (loginData?.access_token) {
                if ((cards?.length != cardData?.length)) {
                    dispatch(getCardListsAuto(localFacilityID)).then((res) => {

                        setCardData(res?.data?.payments)
                        let defaultCard = res?.data?.payments?.filter((item) => {
                            return item.is_default == '1'
                        })
                        reset(formValues => ({ ...formValues, 'card_id': defaultCard?.length > 0 ? defaultCard?.[0]?.payment_profile_id : res?.data?.payments?.[0]?.card_holder_id }))
                        setCurrentCard(defaultCard?.length > 0 ? defaultCard?.[0] : res?.data?.payments?.[0])
                    }).catch((err) => {

                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        let errObject = {
                            payload: localFacilityID,
                            error: err,
                            errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getCardLists-TransientForm.js-331`))
                    })
                }
                if (vehicleDataList?.length != vehicleData?.length) {
                    dispatch(getVehilceData()).then((res) => {
                        setVehicleData(res?.data?.data)
                        // const filterobj = res?.data?.data?.filter((item) => item?.is_default == '1')
                        // reset(formValues => ({ ...formValues, 'vehicle_id': filterobj.length > 0 ? filterobj?.[0]?.id : res?.data?.data?.[0]?.id }))
                        // setCurrentVehicle(filterobj.length > 0 ? filterobj?.[0] : res?.data?.data?.[0])
                        getDetailsFronQuery(true, res?.data?.data)
                    }).catch((err) => {
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        let errObject = {
                            payload: '',
                            error: err,
                            errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getVehicleData-TransientForm.js-347`))
                    })
                }
            }
        }
    }, [EMPTY_ARRAY, cards, vehicleDataList])

    useEffect(() => {
        if (reservationData?.license_plate) {
            reset(formValues => ({ ...formValues, 'license_plate': reservationData.license_plate, state: '' }))
        }
    }, [reservationData])

    useEffect(() => {
        if (faciltyData?.facility?.facility_configuration?.enable_fast_track == '1' && faciltyData?.facility?.facility_configuration?.enable_fast_track_by_default == '1') {
            const checked = true
            setIsFastTrackChecked(checked)
            isDefaultFastTrackEnabledRef.current = true

            setWalletButtonShow(false)//enable/disable fast-track behaviour

        }
    }, [faciltyData?.facility?.facility_configuration?.enable_fast_track_by_default])

    useEffect(() => {

        // if (faciltyData?.promo_category_id && faciltyData?.facility?.is_price_band == '1') {
        if (faciltyData?.promo_category_id) {
            setIndexForCalc({
                eventsIndex: null,
                bandIndex: 0,
            })
            setSeletedRateBand('')
            localStorage.removeItem('seletedRateBand')
            const license_plate = (loggedInUserData()?.user?.id) ? currentSelVehicle?.license_plate_number : getValues('license_plate')
            const phone = phoneRef?.current ? phoneRef?.current : getValues('phone')
            // FETCH RATE BANDS API DETAILS

            const payload = {
                facility_id: faciltyData?.facility?.id,
                user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                license_plate: license_plate?.trim(),
                phone: phone,
                promo_category_id: faciltyData?.promo_category_id
            }
            if (faciltyData?.promo_category_id && faciltyData?.promo_category_id != '') {
                payload.promo_category_id = faciltyData?.promo_category_id
            }

            if (selectedPastDate) {
                payload.start_date = selectedPastDate
            }

            dispatch(fetchRateBands(payload)).then((res) => {
                setRateToRefresh(true)
                setCustomeLoaderForRateBand(false)
                if (res?.data) {
                    if (faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                        if (res?.data?.ongoing_events?.length === 0 && res?.data?.price_band?.length === 0) {
                            setBandMsge(res?.data?.error_msg ? res?.data?.error_msg : '')
                        } else {
                            setBandMsge('')
                        }
                    }
                    let responsData = JSON.stringify(res?.data)
                    // SET Events if exists
                    if (res?.data?.ongoing_events?.length > 0) {
                        setEvents(res?.data?.ongoing_events)
                        if (res?.data?.ongoing_events?.length > 1) {
                            setEventMessage('')
                        }
                    } else {
                        setEvents(EMPTY_ARRAY)
                        setEventMessage('')
                    }
                    if (faciltyData?.facility?.is_price_band == '1') {
                        // SET RATE BAND TRUE
                        let local_ticket = localTicketRef?.current ? localTicketRef?.current : localTicket
                        setIsDisplayRateBand(true)
                        if (local_ticket?.is_checkin == '0' && local_ticket?.is_checkout == '0') {
                            // setIsRateBandSelected(false)
                            const currentTime = new Date(getConvertedDate(moment(new Date()).tz(local_ticket?.facility?.timezone ? local_ticket?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
                            const checkinTime = new Date(getConvertedDate(moment(new Date(local_ticket?.checkin_time)).format('YYYY-MM-DD HH:mm:ss')))
                            const totalHours = moment(currentTime).diff(checkinTime, 'minutes')
                            const timeRemain = TimeConversionInHours(totalHours)
                            let correctRates = JSON.parse(responsData).price_band.filter((item) => {
                                if (Number(item.max_stay) > Number(timeRemain)) {
                                    return true
                                }
                                return false
                            })
                            if (!correctRates?.length) {
                                correctRates = res?.data?.price_band
                            }
                            setRateBandData(correctRates)
                            const rateBandsForSelection = correctRates.map((item) => item?.rate_band_description)
                            const priceForRateBrands = correctRates.map((item) => item?.price)
                            // const defaultRateBand = [
                            //     'Select Rate Band'
                            // ]
                            const rateBandsRef = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                            setRateBands(rateBandsRef)
                            setIsReloadRates({ ...isReloadRates, check: true })
                        } else {
                            // SET RATE BANDS DATA
                            setRateBandData(res?.data?.price_band)
                            const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                            const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                            // const defaultRateBand = [
                            //     'Select Rate Band'
                            // ]
                            const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                            setRateBands(rateBands)
                        }
                        let localFacData = faciltyData
                        localFacData.payable_amount = 0
                        localFacData.is_price_applicable = '0'
                        localFacData.parking_amount = 0
                        localFacData.processing_fee = 0
                        localFacData.tax_rate = 0
                        localFacData.discount_amount = 0
                        localFacData.discount_hours = 0
                        if (faciltyData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1') {
                            localFacData.surcharge_fee = 0
                        }
                        setFaciltyData(localFacData)

                        // const finalPayload = { 'encrypt': facility , promocode: promoCode || ''}
                        // handlePostApiForUpdatedList(finalPayload, false, false, true, currentSelVehicle)
                    }

                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    if (faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                        setBandMsge(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                    let errObject = {
                        payload: payload,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-462`))
                }
            }).catch((err) => {
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                if (faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                    setBandMsge(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                }
                setCustomeLoaderForRateBand(false)
                let errObject = {
                    payload: payload,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-462`))
            })
        } else if (faciltyData?.facility?.id && rateToRefresh) {
            setIndexForCalc({
                eventsIndex: null,
                bandIndex: 0,
            })
            setSeletedRateBand('')
            localStorage.removeItem('seletedRateBand')
            const license_plate = (loggedInUserData()?.user?.id) ? currentSelVehicle?.license_plate_number : getValues('license_plate')
            const phone = phoneRef?.current ? phoneRef?.current : getValues('phone')
            // FETCH RATE BANDS API DETAILS
            const payload = {
                facility_id: faciltyData?.facility?.id,
                user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                license_plate: license_plate?.trim(),
                phone: phone,
            }
            if (faciltyData?.promo_category_id && faciltyData?.promo_category_id != '') {
                payload.promo_category_id = faciltyData?.promo_category_id
            }

            if (selectedPastDate) {
                payload.start_date = selectedPastDate
            }

            dispatch(fetchRateBands(payload)).then((res) => {
                setCustomeLoaderForRateBand(false)
                if (res?.data) {
                    if (faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                        if (res?.data?.ongoing_events?.length === 0 && res?.data?.price_band?.length === 0) {
                            setBandMsge(res?.data?.error_msg ? res?.data?.error_msg : '')
                        } else {
                            setBandMsge('')
                        }
                    }
                    let responsData = JSON.stringify(res?.data)
                    // SET Events if exists
                    if (res?.data?.ongoing_events?.length > 0) {
                        setEvents(res?.data?.ongoing_events)
                        if (res?.data?.ongoing_events?.length > 1) {
                            setEventMessage('')
                        }
                    } else {
                        setEvents(EMPTY_ARRAY)
                        setEventMessage('')
                    }
                    if (faciltyData?.facility?.is_price_band == '1') {
                        // SET RATE BAND TRUE
                        let local_ticket = localTicketRef?.current ? localTicketRef?.current : localTicket
                        setIsDisplayRateBand(true)
                        if (local_ticket?.is_checkin == '0' && local_ticket?.is_checkout == '0') {
                            // setIsRateBandSelected(false)
                            const currentTime = new Date(getConvertedDate(moment(new Date()).tz(local_ticket?.facility?.timezone ? local_ticket?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
                            const checkinTime = new Date(getConvertedDate(moment(new Date(local_ticket?.checkin_time)).format('YYYY-MM-DD HH:mm:ss')))
                            const totalHours = moment(currentTime).diff(checkinTime, 'minutes')
                            const timeRemain = TimeConversionInHours(totalHours)
                            let correctRates = JSON.parse(responsData).price_band.filter((item) => {
                                if (Number(item.max_stay) > Number(timeRemain)) {
                                    return true
                                }
                                return false
                            })
                            if (!correctRates?.length) {
                                correctRates = res?.data?.price_band
                            }
                            setRateBandData(correctRates)
                            const rateBandsForSelection = correctRates.map((item) => item?.rate_band_description)
                            const priceForRateBrands = correctRates.map((item) => item?.price)
                            // const defaultRateBand = [
                            //     'Select Rate Band'
                            // ]
                            const rateBandsRef = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                            setRateBands(rateBandsRef)
                            setIsReloadRates({ ...isReloadRates, check: true })
                        } else {
                            // SET RATE BANDS DATA
                            setRateBandData(res?.data?.price_band)
                            const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                            const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                            // const defaultRateBand = [
                            //     'Select Rate Band'
                            // ]
                            const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                            setRateBands(rateBands)
                        }

                        // const finalPayload = { 'encrypt': facility }
                        // handlePostApiForUpdatedList(finalPayload, false, false, true, currentSelVehicle)
                    }
                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    if (faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                        setBandMsge(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                    let errObject = {
                        payload: payload,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-462`))
                }
            }).catch((err) => {
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                if (faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                    setBandMsge(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                }
                setCustomeLoaderForRateBand(false)
                let errObject = {
                    payload: payload,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-462`))
            })
        }
    }, [faciltyData?.promo_category_id])

    useEffect(() => {
        if (checkInData?.pass_code) {
            passcodeRef.current = checkInData?.pass_code
        }
        if (checkInData?.permit_code) {
            permitcodeRef.current = checkInData?.permit_code
        }
    }, [checkInData?.pass_code, checkInData?.permit_code])

    useEffect(() => {
        // Load Wallet Payment Script
        const paymentGateway = faciltyData?.facility?.facility_payment_details?.facility_payment_type_id
        const applePayScript = getWalletScriptUrl(paymentGateway)
        Object.values(applePayScript)?.map((item) => {
            if (item) {
                addScript(loaded, item, '')
            }
        })
        // Load Wallet Payment Script
    }, [EMPTY_ARRAY, faciltyData?.facility?.facility_payment_details?.facility_payment_type_id])

    const termsChangeHandler = () => {
        setTermsAndCondion(!termsAndCondition)
        setValue('termsnconds', !termsAndCondition)
        setError('termsnconds', {
            type: 'manual',
            message: '',
        })
    }

    const handelFastracModel = () => {
        isDefaultFastTrackDisableRef.current = true
        setIsFastTrackChecked(false)
        setIsModalFastTrackOpen(false)
        setWalletButtonShow(showhideWalletButton(faciltyData?.facility ? faciltyData?.facility : facilityLocData?.facility))   //enable/disable fast-track behaviour  
    }


    const getDetailsFronQuery = (login = false, response = null) => {

        if (queryMobilePhone && queryLicensePlate) {
            if (login && response) {
                const filterobj = response?.filter((item) => item?.license_plate_number == queryLicensePlate)
                reset(formValues => ({ ...formValues, 'vehicle_id': filterobj.length > 0 ? filterobj?.[0]?.id : response?.[0]?.id }))
                setCurrentVehicle(filterobj.length > 0 ? filterobj?.[0] : response?.[0])
                if (filterobj?.length == 0) {
                    handleAddVehilce()
                }
                if (login && isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Display Desired Start Date - Ungated')) {
                    getStartDateByLicense(filterobj.length > 0 ? filterobj?.[0] : response?.[0], facilityLocData ? facilityLocData : faciltyData)
                }
            } else {
                let ph = queryMobilePhone.replace(/\D+/g, '')
                const updatedCheckinData = { ...checkInData }
                setResetPromo(true)
                const length = totalHoursLength
                handleChangeDeb('license_plate', currentSelVehicle, faciltyData, selectedPastDate, facility_loaded, events, length, selctedDateTime)
                updatedCheckinData['license_plate'] = restrictInValidCharLicense(queryLicensePlate)
                updatedCheckinData['phone'] = restrictInValidCharLicense(queryMobilePhone)
                setCheckInData(updatedCheckinData)
                setValue('license_plate', restrictInValidCharLicense(queryLicensePlate))
                setValue('phone', validPhone.test(ph) ? restrictInValidCharLicense(queryMobilePhone) : '')
                if (queryLicensePlate?.length > 10 || queryLicensePlate?.length < 2) {
                    setError('license_plate', {
                        type: 'manual',
                        message: 'Please enter a valid license plate',
                    })
                }
                if (!validPhone.test(ph)) {
                    setError('phone', {
                        type: 'manual',
                        message: 'Please enter valid number',
                    })
                }
            }
        } else if (response) {
            const filterobj = response?.filter((item) => item?.is_default == '1')
            reset(formValues => ({ ...formValues, 'vehicle_id': filterobj.length > 0 ? filterobj?.[0]?.id : response?.[0]?.id }))
            setCurrentVehicle(filterobj.length > 0 ? filterobj?.[0] : response?.[0])

            if (login && isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Display Desired Start Date - Ungated')) {
                getStartDateByLicense(filterobj.length > 0 ? filterobj?.[0]?.license_plate_number : response?.[0]?.license_plate_number, facilityLocData ? facilityLocData : faciltyData)
            }
            if (login) {
                handleActiveCheckInCheck(filterobj?.[0]?.license_plate_number || response?.[0]?.license_plate_number)
            }
        }
    }

    const getVehicle = (res) => {
        let makeList = res?.make
        makeList?.unshift({
            'id': 'Others',
            'name': 'Others',
            'mst_model': [{
                'id': 'Others',
                'make_id': 'Others',
                'name': 'Others'
            }]
        })
        setVehicleMakeList(makeList)
        setVehicleDetailsList(res)

    }

    const isWelcomePopupRef = useRef(isWelcomePopup)
    useEffect(() => {
        isWelcomePopupRef.current = isWelcomePopup
    }, [isWelcomePopup])

    const handlePostApiForUpdatedList = (finalPayload, fetchByRate, fromDatePicker = false, onPageload = false, currentSelVehicle, facility_loaded = false, selectedPastDate = null, selctedDateTime = {}, faciltyData = {}, throughOversize = false) => {
        // if(fromDatePicker) {
        //     setselctedDateTime({...selctedDateTime, bandActive: true})
        // }
        setPageOnLoad(onPageload)
        setDisableRates(true)
        let checkoutWithTime = false
        if (finalPayload.checkoutWithTime) {
            checkoutWithTime = true
            delete finalPayload.checkoutWithTime
        }
        finalPayload.fetchByRate = fetchByRate
        finalPayload.fromDatePicker = fromDatePicker
        const license_plate = (loggedInUserData()?.user?.id) ? currentSelVehicle?.license_plate_number : getValues('license_plate')
        finalPayload.license_plate = license_plate
        const phone = phoneRef?.current ? phoneRef?.current : getValues('phone')
        finalPayload.phone = phone

        if (isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Enable Email Fields - Transient')) {
            finalPayload.email = getValues('email')
        }

        setIsTokenApiStart(true)

        if (throughOversize && curRateBandRef?.current) {
            finalPayload.rate_band_id = curRateBandRef.current?.id
            finalPayload.band_rate = parseFloat(curRateBandRef.current?.price ? curRateBandRef.current?.price : 0)
        }

        const facilityDataPayload = { ...finalPayload }

        delete facilityDataPayload.fetchByRate
        delete facilityDataPayload.fromDatePicker
        setRateFetchPayload(facilityDataPayload)
        if (((promoCode && promoCode != '') || (facilityDataPayload?.promocode && facilityDataPayload?.promocode != '')) && ((facilityDataPayload?.rate_band_id && facilityDataPayload?.rate_band_id != '') || facilityDataPayload?.length)) {
            // setIsRateChangedWithPromo(prevState => {
            //     const newState = prevState ? prevState : true
            //     return newState
            // })
            setIsRateChangedWithPromo(prevState => {
                const newState = !prevState
                return newState
            })
            setDisableRates(false)
            // setCustomeLoaderForRateBand(false)
        } else {
            setIsRateChangedWithPromo(() => {
                return false
            })

            if (((promoCode && promoCode != '') || (facilityDataPayload?.promocode && facilityDataPayload?.promocode != '')) && isPromoCodeAppiled) {
                facilityDataPayload.promocode = promoCode || facilityDataPayload?.promocode
            }

            const isVehicleOversized = isOversizedVehicleRef.current
            facilityDataPayload.is_vehicle_oversize = isVehicleOversized ? 1 : 0

            if (finalPayload?.length && Number(finalPayload?.length) > 0) {
                facilityDataPayload.length = finalPayload?.length
            }

            if (selectedPastDate) {
                facilityDataPayload.start_date = selectedPastDate
            }
            if (passcodeRef?.current && isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Allow Entry for Valid Pass Holders')) {
                facilityDataPayload.pass_code = passcodeRef?.current
            }
            if (permitcodeRef.current && isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Allow Entry for Valid Pass Holders')) {
                facilityDataPayload.permit_code = permitcodeRef.current
            }
            const reqID = ++getfacilityAPI.current
            dispatch(getFaciltyData(facilityDataPayload)).then((res) => {
                setDisableRates(false)
                setIsTokenApiStart(false)
                if (res?.data) {
                    if (reqID == getfacilityAPI?.current) {
                        // Check availability
                        if (res?.data?.facility?.facility_configuration?.enable_facility_close == '1') {
                            setBandMsge(res?.data?.facility?.facility_configuration?.facility_close_msg)
                        } else if (res?.data?.facility && res?.data?.facility?.facility_configuration && res?.data?.facility?.facility_configuration?.enable_welcome_popup && res?.data?.facility?.facility_configuration?.enable_welcome_popup == '1' && isWelcomePopupRef.current == '0') {
                            custDispatch({ type: CONSTANTS.IS_WELCOME_POPUP, data: '1' })
                        }
                        if ((res?.data?.availability != null && res?.data?.availability_msg != null && Number(res?.data?.availability) === 0 && res?.data?.availability_msg !== '')) {
                            handleGarageInventory(res?.data)
                        } else {
                            custDispatch({ type: CONSTANTS.FACILITY_LOADED })
                            localStorage.setItem('faclityData', JSON.stringify(res?.data))
                            setFacilityLocData(res?.data)
                            setIsRateMisMatch(false)
                            setMismatchRateError('')
                            setUpdatedFacilityDate(res.data?.facility)
                            if ((res?.data?.permit_request_id && res?.data?.permit_request_id != '') || res?.data?.qrcode_id || (Object.hasOwn(res?.data, 'payable_amount') && Number(res?.data?.payable_amount) == 0)) {
                                setIsPriceZero(true)
                            } else {
                                setIsPriceZero(false)
                            }
                            if (res?.data?.qrcode_id) {
                                setQrcodeId(res.data.qrcode_id)
                            }

                            // if (res?.data?.is_fast_track_enabled == 1) {
                            //     setIsFastTrackChecked(true)
                            // } else {
                            //     setIsFastTrackChecked(false)
                            // }

                            // const listItem = [{ 'headerName': 'Parking Amount', 'val': `$${res?.data?.parking_amount ? res?.data?.parking_amount : '0.00'}` }, { 'headerName': 'Tax', 'val': `$${res?.data?.tax_rate ? res?.data?.tax_rate : '0.00'}` }, { 'headerName': 'Processing Fee', 'val': `$${res?.data?.processing_fee ? res?.data?.processing_fee : '0.00'}` }]
                            if (fromDatePicker || (res?.data?.facility?.facility_configuration?.is_facility_hotel_type == '1' && durationSelector == '1' && Number(res.data?.parking_amount) > 0)) {
                                setselctedDateTime({ ...selctedDateTime, bandActive: true, active: true, price: res.data?.parking_amount, dateUntill: res.data?.checkout_time, daysHrs: getHoursIndate(finalPayload.length) })
                            }
                            const data = res?.data
                            data.default_length = data?.default_length?.toString()
                            localStorage.setItem('faclityData', JSON.stringify(data))


                            const dcap = {
                                DATACAP_OTU_URL: data?.DATACAP_OTU_URL,
                                DATACAP_SCRIPT_URL: data?.DATACAP_SCRIPT_URL,
                                DATACAP_TOKEN: data?.DATACAP_TOKEN,
                            }
                            localStorage.setItem('dcap', JSON.stringify(dcap))
                            setStateList(res?.data?.states)

                            // rate band start 
                            if (fetchByRate) {
                                const rateDataFectched = { ...faciltyData, ...res?.data }
                                setFaciltyData(rateDataFectched)
                            } else {
                                setFaciltyData(res?.data)
                            }

                            // rate band end 
                            const geoState = res?.data?.facility?.geolocations?.state?.trim()
                            const filteredState = res?.data?.states?.filter((item) => (item?.state_code === geoState || item?.name === geoState) ? item : 0)

                            setValue('state', getValues('state') ? getValues('state') : filteredState[0]?.id ? filteredState[0]?.id : getValues('state'))
                            // if (ticketDetails && ticketDetails?.is_checkin != '0' && ticketDetails?.is_checkout != '0' && onPageload) {
                            if ((ticketDetails && ticketDetails?.is_checkin != '0' && ticketDetails?.is_checkout != '0' && onPageload) || ((fastTrackData && Object.keys(fastTrackData).length > 0 && isFastTrackChecked && isFastTrackCard) && onPageload)) {

                                // let local_ticket = JSON.parse(localStorage.getItem('local_ticket'))
                                let local_ticket = localTicketRef?.current ? localTicketRef?.current : localTicket
                                const license_plate = (loggedInUserData()?.user?.id) ? currentSelVehicle?.license_plate_number : getValues('license_plate')
                                const phone = phoneRef?.current ? phoneRef?.current : getValues('phone')
                                // FETCH RATE BANDS API DETAILS
                                const payload = {
                                    facility_id: res?.data?.facility?.id,
                                    user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                                    license_plate: license_plate?.trim(),
                                    phone: phone
                                }
                                if (res?.data?.promo_category_id && res?.data?.promo_category_id != '') {
                                    payload.promo_category_id = res?.data?.promo_category_id
                                }

                                if (selectedPastDate) {
                                    payload.start_date = selectedPastDate
                                }
                                if (finalPayload.is_vehicle_oversize) {
                                    payload.is_vehicle_oversize = finalPayload.is_vehicle_oversize
                                }
                                if (res?.data?.facility?.is_price_band == '1') {
                                    if (selctedDateTime?.bandActive && faciltyData?.facility) {
                                        const updDtTime = {
                                            ...selctedDateTime,
                                            active: false,
                                            bandActive: false,
                                        }
                                        if (faciltyData?.facility?.facility_configuration?.is_facility_hotel_type == '1') {
                                            updDtTime.price = null
                                        }
                                        setselctedDateTime(updDtTime)
                                        const faciData = faciltyData ? faciltyData : {}
                                        faciData.parking_amount = '0.00'
                                        faciData.CCFee = '0.00'
                                        faciData.processing_fee = '0.00'
                                        faciData.tax_rate = '0.00'
                                        faciData.paid_amount = '0.00'
                                        faciData.payable_amount = '0.00'
                                        faciData.display_msg = ''
                                        faciData.discount_amount = '0'
                                        faciData.discount_hours = '0'
                                        if (faciltyData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1') {
                                            faciData.surcharge_fee = '0'
                                        }
                                        setIsPriceZero(true)
                                        setFaciltyData(faciData)
                                        setSelectedEv(null)
                                        setTotalHoursLength('0.00')
                                    }
                                    if (!throughOversize || (throughOversize && curRateBandRef?.current == null)) {
                                        dispatch(fetchRateBands(payload)).then((res) => {
                                            setOversizeLoader(false)
                                            setCustomeLoaderForRateBand(false)
                                            if (res?.data) {
                                                if (res?.data?.facility?.facility_configuration?.enable_facility_close == '1') {
                                                    if (res?.data?.ongoing_events?.length === 0 && res?.data?.price_band?.length === 0) {
                                                        setBandMsge(res?.data?.error_msg ? res?.data?.error_msg : '')
                                                    } else {
                                                        setBandMsge('')
                                                    }
                                                }
                                                let responsData = JSON.stringify(res?.data)
                                                // SET Events if exists
                                                if (res?.data?.ongoing_events?.length > 0) {
                                                    setEvents(res?.data?.ongoing_events)
                                                    if (res?.data?.ongoing_events?.length > 1) {
                                                        setEventMessage('')
                                                    }
                                                } else {
                                                    setEvents(EMPTY_ARRAY)
                                                    setEventMessage('')
                                                }
                                                if (data?.facility?.is_price_band == '1') {
                                                    // SET RATE BAND TRUE
                                                    setIsDisplayRateBand(true)
                                                    if (local_ticket?.is_checkin == '0' && local_ticket?.is_checkout == '0') {
                                                        // setIsRateBandSelected(false)
                                                        const currentTime = new Date(getConvertedDate(moment(new Date()).tz(local_ticket?.facility?.timezone ? local_ticket?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
                                                        const checkinTime = new Date(getConvertedDate(moment(new Date(local_ticket?.checkin_time)).format('YYYY-MM-DD HH:mm:ss')))
                                                        const totalHours = moment(currentTime).diff(checkinTime, 'minutes')
                                                        const timeRemain = TimeConversionInHours(totalHours)
                                                        let correctRates = JSON.parse(responsData).price_band.filter((item) => {
                                                            if (Number(item.max_stay) > Number(timeRemain)) {
                                                                return true
                                                            }
                                                            return false
                                                        })
                                                        if (!correctRates?.length) {
                                                            correctRates = res?.data?.price_band
                                                        }
                                                        setRateBandData(correctRates)
                                                        const rateBandsForSelection = correctRates.map((item) => item?.rate_band_description)
                                                        const priceForRateBrands = correctRates.map((item) => item?.price)
                                                        // const defaultRateBand = [
                                                        //     'Select Rate Band'
                                                        // ]
                                                        const rateBandsRef = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                                                        setRateBands(rateBandsRef)
                                                        setIsReloadRates({ ...isReloadRates, check: true })
                                                    } else {
                                                        // SET RATE BANDS DATA
                                                        setRateBandData(res?.data?.price_band)
                                                        const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                                                        const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                                                        // const defaultRateBand = [
                                                        //     'Select Rate Band'
                                                        // ]
                                                        const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                                                        setRateBands(rateBands)
                                                    }
                                                }
                                            } else {
                                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                                if (res?.data?.facility?.facility_configuration?.enable_facility_close == '1') {
                                                    setBandMsge(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                                }
                                                let errObject = {
                                                    payload: payload,
                                                    error: res,
                                                    errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                                                }
                                                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-462`))
                                            }
                                        }).catch((err) => {
                                            setOversizeLoader(false)
                                            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                                            if (res?.data?.facility?.facility_configuration?.enable_facility_close == '1') {
                                                setBandMsge(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                                            }
                                            setCustomeLoaderForRateBand(false)
                                            let errObject = {
                                                payload: payload,
                                                error: err,
                                                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                                            }
                                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-462`))
                                        })
                                    }
                                } else {
                                    setCustomeLoaderForRateBand(false)
                                }
                            } else {
                                setCustomeLoaderForRateBand(false)
                            }

                            if (loggedInUserData()?.access_token) {
                                const payload = {
                                    facility_id: res?.data?.facility?.id,
                                    user_id: loggedInUserData()?.user?.id
                                }
                                if (!throughOversize) {
                                    setIsCheckingActiveSession(true)
                                }
                                dispatch(checkActiveSession(payload)).then((res) => {
                                    if ((res?.data?.checkin_details?.is_expired == '0' && !res?.data?.checkin_details?.is_expired)) {
                                        let paymentData = res?.data?.checkin_details
                                        if (res?.data?.checkin_details?.discount_amount && res?.data?.checkin_details?.discount_amount != '') {
                                            localStorage.setItem('isCouponApplied', true)
                                        }

                                        delete res?.data?.checkin_details
                                        const facility = res?.data
                                        const finalPaymentData = { ...paymentData, facility: facility }
                                        localStorage.removeItem('paymentRecipt')
                                        localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                                        if (finalPaymentData?.ticket_number && finalPaymentData?.ticket_number != '') {
                                            navigate(`/${partner}${URL?.CONFIRMATION}/${finalPaymentData?.ticket_number}`)
                                        }
                                        setIsCheckingActiveSession(false)
                                    } else {
                                        setIsTokenApiStart(false)
                                        setIsCheckingActiveSession(false)
                                    }
                                }).catch((err) => {
                                    setIsTokenApiStart(false)
                                    setIsCheckingActiveSession(false)
                                    let errObject = {
                                        payload: payload,
                                        error: err,
                                        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                                    }
                                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} checkActiveSession-TransientForm.js-536`))
                                    // notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                                })
                            } else {
                                setIsCheckingActiveSession(false)
                                setIsTokenApiStart(false)
                            }

                            if (checkoutWithTime) {
                                const currentTime = new Date(getConvertedDate(moment(res?.data?.current_time).format('YYYY-MM-DD HH:mm:ss')))
                                const checkoutTime = new Date(getConvertedDate(moment(res?.data?.checkout_time).format('YYYY-MM-DD HH:mm:ss')))
                                const totalHours = moment(checkoutTime).diff(currentTime, 'minutes')
                                const timeRemain = TimeConversionInHours(totalHours)
                                setTotalHoursLength(timeRemain)
                            }
                        }
                    }
                } else {
                    if (!facility_loaded) {
                        setFaciltyData(null)
                        setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    } else {
                        setCustomeLoaderForRateBand(false)
                    }
                    if (res?.status == 502) {
                        setCustomeLoaderForRateBand(false)
                        notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    } else {
                        setIsCheckingActiveSession(false)
                        setIsTokenApiStart(false)
                        // setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        if (res?.errors?.message == 'Garage is currently closed.') {
                            setAvalablityAlertIsOpen(true)
                            setAvalablityMessage(res?.errors?.message)
                        } else if (res?.errors?.message == 'The Facility is not operational at this moment.') {
                            setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            setIsCheckingActiveSession(false)
                        } else {
                            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                    }
                    let errObject = {
                        payload: finalPayload,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getFaciltyData-TransientForm.js-404`))
                }
            }).catch((err) => {
                setDisableRates(false)
                if (err?.status == 502) {
                    setCustomeLoaderForRateBand(false)
                    notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                } else {
                    setCustomeLoaderForRateBand(false)
                    if (!facility_loaded) {
                        setFaciltyData(null)
                        setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                    setIsCheckingActiveSession(false)
                    setIsTokenApiStart(false)
                    // setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    if (err?.errors?.message == 'Garage is currently closed.') {
                        setAvalablityAlertIsOpen(true)
                        setAvalablityMessage(err?.errors?.message)
                    } else if (err?.errors?.message == 'The Facility is not operational at this moment.') {
                        setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        setIsCheckingActiveSession(false)
                    } else {
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                }
                let errObject = {
                    payload: finalPayload,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getFaciltyData-TransientForm.js-404`))
            })
        }
    }

    const deb = useCallback(
        debounce((payload, fetchByRate, fromDatePicker, onPageload = false, currentSelVehicle, facility_loaded = false, selectedPastDate, selctedDateTime = {}) => {
            payload.promocode = promoCode
            if (loginData?.access_token) {
                payload.user_id = loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : ''
            }
            handlePostApiForUpdatedList(payload, fetchByRate, fromDatePicker, onPageload, currentSelVehicle, facility_loaded, selectedPastDate, selctedDateTime, {}, false)
        }, 300),
        [promoCode])

    const handleTimeLength = (e, license_plate = null, tmStart = null) => {
        setVerifyDetails(true)
        // if (isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox')) {
        //     setTermsAndCondion(false)
        // }
        // e?.preventDefault()
        const { value, name, key } = e.target
        let data = { ...timeDuration }
        if (name == 'day') {
            data['days'] = key == 'isStatic' ? 0 : value
            data['hours'] = key == 'isStatic' ? 0 : data['hours']
            setTimeDuration({ ...timeDuration, days: Number(key == 'isStatic' ? 0 : value) })
        } else if (name == 'hour') {
            data['hours'] = key == 'isStatic' ? 0 : value
            data['minutes'] = key == 'isStatic' ? 0 : data.minutes
            setTimeDuration({ ...timeDuration, hours: Number(key == 'isStatic' ? 0 : value), minutes: Number(key == 'isStatic' ? 0 : data['minutes']) })
        } else if (name == 'minute') {
            data['minutes'] = key == 'isStatic' ? 0 : value
            data['hours'] = key == 'isStatic' ? 0 : data['hours']
            setTimeDuration({ ...timeDuration, minutes: Number(key == 'isStatic' ? 0 : value), hours: Number(key == 'isStatic' ? 0 : data['hours']) })
        } else if (name == 'minute-up') {
            data['minutes'] = data.minutes + 15 <= 60 ? Number(data.minutes + 15) : 0
            setTimeDuration(prev => ({ ...timeDuration, minutes: prev.minutes + 15 <= 60 ? Number(prev.minutes + 15) : 0 }))
        } else if (name == 'minute-down') {
            data['minutes'] = data.minutes - 15 >= 0 ? Number(data.minutes - 15) : 60
            setTimeDuration(prev => ({ ...timeDuration, minutes: prev.minutes - 15 >= 0 ? Number(prev.minutes - 15) : 60 }))
        } else if (name == 'hour-up') {
            data['hours'] = data.hours + 1 <= 24 ? Number(data.hours + 1) : 0
            setTimeDuration(prev => ({ ...timeDuration, hours: prev.hours + 1 <= 24 ? Number(prev.hours + 1) : 0 }))
        } else if (name == 'hour-down') {
            data['hours'] = data.hours - 1 >= 0 ? Number(data.hours - 1) : 24
            setTimeDuration(prev => ({ ...timeDuration, hours: prev.hours - 1 >= 0 ? prev.hours - 1 : 24 }))
        } else if (name == 'day-up') {
            data['days'] = data.days + 1 <= 31 ? Number(data.days + 1) : 0
            setTimeDuration(prev => ({ ...timeDuration, days: prev.days + 1 <= 31 ? Number(prev.days + 1) : 0 }))
        } else if (name == 'day-down') {
            data['days'] = data.days - 1 >= 0 ? Number(data.days - 1) : 31
            setTimeDuration(prev => ({ ...timeDuration, days: prev.days - 1 >= 0 ? Number(prev.days - 1) : 31 }))
        }


        if (name === 'Hours') {
            data['hours'] = Number(value)
            setTimeDuration(data)
            let totalHours = TimeConversion(data).toFixed(2)
            if (totalHours == '0.00') {
                setTotalHoursLength('0')
            } else {
                setTotalHoursLength(totalHours)
            }
            // const payload = { 'encrypt': facility, length: totalHours === 0 ? 2 : totalHours }
            if (facility && facility != undefined && facility != 'undefined') {
                const payload = { 'encrypt': facility, length: totalHours }
                if (payload?.length != 0 && Number(payload?.length) > 0) {
                    deb(payload, false, false, false, license_plate ? { 'license_plate_number': license_plate } : currentSelVehicle, facility_loaded, tmStart ? tmStart : selectedPastDate, selctedDateTime)
                }
            } else {
                notify('error', 'Sorry something went wrong, Please refresh or try again.')
                let errObject = {
                    payload: facility,
                    error: facility,
                    errorMessage: 'Sorry something went wrong, Please refresh or try again.'
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} deb-TransientForm.js-676`))
            }
        } else if (name === 'events') {
            setSelectedEv(value)
            if (Number(totalHoursLength) === 0) {
                setTotalHoursLength('00.00')
            }
            const payload = { 'encrypt': facility, 'event_id': value, checkoutWithTime: true }
            deb(payload, false, false, false, currentSelVehicle, facility_loaded, tmStart ? tmStart : selectedPastDate, selctedDateTime)
        } else if ((name && name?.[0]) === 'rateBands') { // only for rate band 
            const { value } = e.target
            const seletedRateBand = rateBandData?.filter((item) => item?.rate_band_description == value[0])
            // for the rate hour 
            const rateBandHour = getHoursForRateBand(seletedRateBand)
            localStorage.setItem('seletedRateBand', JSON.stringify(seletedRateBand?.[0]))
            curRateBandRef.current = seletedRateBand?.[0]
            setSeletedRateBand(seletedRateBand)
            // to set hours duration
            data['hours'] = Number(rateBandHour)

            let totalHours = '0.00'

            if (seletedRateBand?.[0]?.max_stay) {
                const max_stay_time = seletedRateBand?.[0]?.max_stay?.split('.')
                const minutes = (Number(max_stay_time[1]) / 60)
                totalHours = Number(max_stay_time[0]) + Number(minutes)
            }

            if (totalHours == '0.00') {
                setTotalHoursLength('0')
            } else {
                setTotalHoursLength(totalHours)
            }
            // else if(value.length > 0 && value[0].toLowerCase()?.includes('checkoutWithTime')) {
            //     // setTotalHoursLength('0')
            // } else {
            //     setTotalHoursLength(totalHours)
            // }

            setTimeDuration(data)

            reset(formValues => ({ ...formValues, 'rate_band_id': seletedRateBand?.[0]?.id }))
            // FETCH FACILITYRATE
            if (facility && facility != undefined && facility != 'undefined') {
                const payload = {
                    promocode: '',
                    user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                    rate_band_id: seletedRateBand?.[0]?.id,
                    //facility_id: faciltyData?.facility?.id,
                    // length_of_stay: totalHoursLength,
                    band_rate: parseFloat(seletedRateBand?.[0]?.price ? seletedRateBand?.[0]?.price : 0),
                    'encrypt': facility,
                }
                payload.checkoutWithTime = true
                if ((Number(payload?.length) > 0 && payload?.length != 0) || payload?.length == undefined || payload?.length == 'undefined') {
                    deb(payload, false, false, false, currentSelVehicle, facility_loaded, tmStart ? tmStart : selectedPastDate, selctedDateTime)
                }
            } else {
                notify('error', 'Sorry something went wrong, Please refresh or try again.')
                let errObject = {
                    payload: facility,
                    error: facility,
                    errorMessage: 'Sorry something went wrong, Please refresh or try again.'
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} deb-TransientForm.js-761`))
            }
        } else {
            let totalHours = TimeConversion(data).toFixed(2)
            if (totalHours == '0.00') {
                setTotalHoursLength('0')
            } else {
                setTotalHoursLength(totalHours)
            }
            // const payload = { 'encrypt': facility, length: totalHours === 0 ? 2 : totalHours }
            if (facility && facility != undefined && facility != 'undefined') {
                const payload = { 'encrypt': facility, length: totalHours }
                // if (payload?.length != 0 && Number(payload?.length) > 0) {
                deb(payload, false, false, false, license_plate ? { 'license_plate_number': license_plate } : currentSelVehicle, facility_loaded, tmStart ? tmStart : selectedPastDate, selctedDateTime)
                // }
            } else {
                notify('error', 'Sorry something went wrong, Please refresh or try again.')
                let errObject = {
                    payload: facility,
                    error: facility,
                    errorMessage: 'Sorry something went wrong, Please refresh or try again.'
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} deb-TransientForm.js-704`))
            }
        }




    }

    const oversizeChangeModule = (faciltyData, license_plate, phone, selectedPastDate, finalPayload, selectedDate, isVehicle = false) => {
        const payload = {
            facility_id: faciltyData?.facility?.id,
            user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
            license_plate: license_plate?.trim(),
            phone: phone
        }
        if (faciltyData?.promo_category_id && faciltyData?.promo_category_id != '') {
            payload.promo_category_id = faciltyData?.promo_category_id
        }
        if (selectedPastDate) {
            payload.start_date = selectedPastDate
        }
        if (finalPayload.is_vehicle_oversize) {
            payload.is_vehicle_oversize = finalPayload.is_vehicle_oversize
        }
        dispatch(fetchRateBands(payload)).then((res) => {
            setOversizeLoader(false)
            if (res?.data?.price_band?.length > 0) {
                res?.data?.price_band.map((item) => {
                    if (item?.id == curRateBandRef?.current?.id) {
                        curRateBandRef.current = item
                    }
                })
            }
            if (res?.data) {
                if (res?.data?.facility?.facility_configuration?.enable_facility_close == '1') {
                    if (res?.data?.ongoing_events?.length === 0 && res?.data?.price_band?.length === 0) {
                        setBandMsge(res?.data?.error_msg ? res?.data?.error_msg : '')
                    } else {
                        setBandMsge('')
                    }
                }
                // SET Events if exists
                if (res?.data?.ongoing_events?.length > 0) {
                    setEvents(res?.data?.ongoing_events)
                    if (res?.data?.ongoing_events?.length > 1) {
                        setEventMessage('')
                    }
                } else {
                    setEvents(EMPTY_ARRAY)
                    setEventMessage('')
                }
                if (faciltyData?.facility?.is_price_band == '1') {
                    // SET RATE BAND TRUE
                    setIsDisplayRateBand(true)
                    // SET RATE BANDS DATA
                    setRateBandData(res?.data?.price_band)
                    const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                    const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                    // const defaultRateBand = [
                    //     'Select Rate Band'
                    // ]
                    const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                    setRateBands(rateBands)
                }
            } else {
                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                if (res?.data?.facility?.facility_configuration?.enable_facility_close == '1') {
                    setBandMsge(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                }
                let errObject = {
                    payload: payload,
                    error: res,
                    errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-462`))
            }
            // if(band_rate.length > 0) {
            //     curRateBandRef.current = band_rate[0]
            // }
            handlePostApiForUpdatedList(finalPayload, false, false, true, currentSelVehicle, facility_loaded, selectedDate, selctedDateTime, faciltyData, isVehicle ? false : true)
        }).catch((err) => {
            setOversizeLoader(false)
            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            if (faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                setBandMsge(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            }
            setCustomeLoaderForRateBand(false)
            let errObject = {
                payload: payload,
                error: err,
                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-462`))
        })
    }
    const handleChangeDeb = useCallback(debounce((name, currentSelVehicle, faciltyData, selectedDate, facility_loaded = false, events = [], length = '0', selctedDateTime = {}) => {
        let facility = encFacility ? encFacility : partnerDetailsRef?.current?.facility?.encrypted_key ? partnerDetailsRef?.current?.facility?.encrypted_key : getbase64EncodedString(partnerDetailsRef?.current?.request_param)
        handleChangeReq.current++
        setResetPromo(false)
        const isVehicleOversized = isOversizedVehicleRef.current
        const license_plate = (loggedInUserData()?.user?.id) ? currentSelVehicle?.license_plate_number : getValues('license_plate')
        const phone = (loggedInUserData()?.user?.id) ? loggedInUserData()?.user?.phone_number : phoneRef?.current ? phoneRef?.current : getValues('phone')
        const promocode = getValues('promo')
        if (name !== 'start_date' && (license_plate && license_plate.length > 1 && license_plate.length < 11)) {
            handleActiveCheckInCheck(license_plate, phone, name, faciltyData)
        }
        let facilityLocData = faciltyData
        if (((license_plate && license_plate.length > 1 && license_plate.length < 11)) || name == 'is_vehicle_oversize') {
            if (name != 'is_vehicle_oversize') {
                setIndexForCalc({
                    eventsIndex: null,
                    bandIndex: 0,
                })
                if (facilityLocData?.facility?.is_price_band == '1' || faciltyData?.is_price_band == '1' || facilityLocData?.is_price_band == '1' || (events?.length > 0)) {
                    setTotalHoursLength(() => {
                        return '0'
                    })
                }
                setIsRateBandSelected(() => {
                    return false
                })
                setSeletedRateBand(() => {
                    return null
                })
                localStorage.removeItem('seletedRateBand')
                setCustomeLoaderForRateBand(() => {
                    return true
                })
            }
            // REFRESH THE BREAKDOWN BY CALLING FACILITY WEB RATE API WITH DEFAULT PARAMS
            // if (facility && facility != undefined && facility != 'undefined') {
            if (facility && facility != undefined && facility != 'undefined' && (name == 'is_vehicle_oversize' || faciltyData?.facility?.is_price_band != '1')) {
                const finalPayload = { 'encrypt': facility, promocode: promocode }
                if (loginData?.access_token) {
                    finalPayload.user_id = loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : ''
                }
                finalPayload.is_vehicle_oversize = isVehicleOversized ? 1 : 0
                if (facilityLocData?.facility?.is_price_band == '1' || faciltyData?.is_price_band == '1' || facilityLocData?.is_price_band == '1' || (events?.length > 0) || (length && Number(length) == 0)) {

                    if (name != 'is_vehicle_oversize') {
                        setCustomeLoaderForRateBand(() => {
                            return false
                        })
                        finalPayload.length = 0

                        const faciData = faciltyData ? faciltyData : {}
                        if (Object.keys(faciData)?.length > 0) {
                            const updDtTime = {
                                ...selctedDateTime,
                                active: false,
                                bandActive: false,
                            }
                            setselctedDateTime(updDtTime)
                            faciData.parking_amount = '0.00'
                            faciData.CCFee = '0.00'
                            faciData.processing_fee = '0.00'
                            faciData.tax_rate = '0.00'
                            faciData.paid_amount = '0.00'
                            faciData.payable_amount = '0.00'
                            faciData.display_msg = ''
                            faciData.discount_amount = '0'
                            faciData.discount_hours = '0'
                            if (faciltyData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1') {
                                faciData.surcharge_fee = '0'
                            }
                        } else {
                            setFaciltyData(faciData)
                        }
                        setFaciltyData(faciData)
                        setIsPriceZero(true)
                        setSelectedEv(null)
                        setTotalHoursLength('0.00')
                        setIsTokenApiStart(false)
                    } else {
                        if (curRateBandRef?.current) {
                            oversizeChangeModule(faciltyData, license_plate, phone, selectedPastDate, finalPayload, selectedDate)
                        } else {
                            if (!curRateBandRef?.current) {
                                finalPayload.length = length
                            }
                            handlePostApiForUpdatedList(finalPayload, false, false, true, currentSelVehicle, facility_loaded, selectedDate, selctedDateTime, faciltyData, true)
                        }
                    }
                } else if (length && Number(length) > 0) {
                    finalPayload.length = length
                    finalPayload.is_vehicle_oversize = isVehicleOversized ? 1 : 0
                    handlePostApiForUpdatedList(finalPayload, false, false, true, currentSelVehicle, facility_loaded, selectedDate, selctedDateTime, faciltyData, false)
                }
            } else if (faciltyData?.facility?.is_price_band == '1') {
                const faciData = faciltyData ? faciltyData : {}
                faciData.parking_amount = '0.00'
                faciData.CCFee = '0.00'
                faciData.processing_fee = '0.00'
                faciData.tax_rate = '0.00'
                faciData.paid_amount = '0.00'
                faciData.payable_amount = '0.00'
                faciData.display_msg = ''
                faciData.discount_amount = '0'
                faciData.discount_hours = '0'
                if (faciltyData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1') {
                    faciData.surcharge_fee = '0'
                }
                setFaciltyData(faciData)
                setIsPriceZero(true)
                setSelectedEv(null)
                setTotalHoursLength('0.00')
                // Only refresh the rate bands and set price 0 without calling price API
                const payload = {
                    facility_id: faciltyData?.facility?.id,
                    user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                    license_plate: license_plate?.trim(),
                    phone: phone
                }
                if (isVehicleOversized) {
                    payload.is_vehicle_oversize = 1
                }
                if (faciltyData?.promo_category_id && faciltyData?.promo_category_id != '') {
                    payload.promo_category_id = faciltyData?.promo_category_id
                }
                if (selectedPastDate) {
                    payload.start_date = selectedPastDate
                }
                fetchBands(payload, false, handleChangeReq.current)
            }

        }
    }, 300), [])

    // const throttledHandleChange = throttle((e) => {
    const throttledHandleChange = (e) => {
        const { value, name } = e.target
        const updatedCheckinData = { ...checkInData }
        if (name == 'make') {
            let modelData = vehicleDetailsList?.make?.filter((v) => v.id == value)
            let modelList = (Object.values(modelData).length != 0 ? modelData?.[0]?.mst_model : [])
            modelList.unshift({
                'id': 'Others',
                'make_id': 'Others',
                'name': 'Others'
            })
            setvehicleModel(modelData[0]?.mst_model)
            setvehicleModelList(modelList)
            SetOtherMake(value == 'Others' ? true : false)
            updatedCheckinData[name] = value
            setCheckInData(updatedCheckinData)
            setValue(name, value)
            // vehicleData[name] = value
            // setVehicleData([...vehicleData])
        } else if (name == 'model') {
            SetOtherModel(value == 'Others' ? true : false)
            updatedCheckinData[name] = value
            setCheckInData(updatedCheckinData)
            setValue(name, value)
        } else if (name == 'license_plate') {
            setVerifyDetails(true)
            setResetPromo(true)
            const length = totalHoursLength
            handleChangeDeb(name, currentSelVehicle, faciltyData, selectedPastDate, facility_loaded, events, length, selctedDateTime)
            updatedCheckinData[name] = restrictInValidCharLicense(value)
            setCheckInData(updatedCheckinData)
            setValue(name, restrictInValidCharLicense(value))
        } else if (name == 'is_vehicle_oversize' && !checkInData?.disabled) {
            if (curRateBandRef?.current && isRateBandSelected) {
                setOversizeLoader(true)
            }
            const { checked } = e.target
            setResetPromo(true)
            const length = totalHoursLength
            handleChangeDeb(name, currentSelVehicle, faciltyData, selectedPastDate, facility_loaded, events, length, selctedDateTime)
            const updatedCheckinData = { ...checkInData }
            updatedCheckinData[name] = !checked
            setCheckInData(updatedCheckinData)
            isOversizedVehicleRef.current = checked
        } else if (name == 'is_fast_track_enabled') {
            const { checked } = e.target
            if (!checked) {
                setIsModalFastTrackOpen(true)
                setWalletButtonShow(showhideWalletButton(faciltyData?.facility ? faciltyData?.facility : facilityLocData?.facility))//enable/disable fast-track behaviour
            } else {
                setIsFastTrackChecked(checked)
                isDefaultFastTrackDisableRef.current = checked
                setIsModalFastTrackOpen(false)
                setWalletButtonShow(false)//enable/disable fast-track behaviour
                if (isFastTrackChecked && isFastTrackCard && fastTrackData && Object.keys(fastTrackData).length == 0) {
                    setFirstTimeFastTrackEnable(checked)
                } else {
                    setFirstTimeFastTrackEnable(false)
                }
            }

        } else {
            if (name == 'phone' && !checkInData?.disabled) {
                const length = totalHoursLength
                setResetPromo(true)
                handleChangeDeb(name, currentSelVehicle, faciltyData, selectedPastDate, facility_loaded, events, length, selctedDateTime)
                phoneRef.current = value.trim()
            }
            updatedCheckinData[name] = value.trim()
            setCheckInData(updatedCheckinData)
            setValue(name, value.trim())
        }

    }
    // }, 500)
    const handleChange = (event) => {
        throttledHandleChange(event) // Throttle the onChange
    }


    const handleActiveCheckInCheck = (license_plate, phone, name, faciltyData) => {
        // const { name } = e.target
        if ((license_plate) || (ticketDetails?.ticket_number) || (checkInData?.license_plate && ticketDetails?.ticket_number)) {
            const payload = {
                'ticket': '',
                'phone': phone ? phone : checkInData?.phone ? checkInData?.phone : '',
                'cardLast4': '',
                'cardExpiry': '',
                'license_plate': license_plate ? license_plate : checkInData?.license_plate ? checkInData?.license_plate : '',
                'facility_id': faciltyData?.facility?.id ? faciltyData?.facility?.id : ''
            }
            if (selectedEv) {
                payload.event_id = selectedEv
            }
            setIsPriceZero(true)
            if (isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Display Desired Start Date - Ungated')) {
                getStartDateByLicense(payload.license_plate, faciltyData)
            }
            dispatch(getTicketDetails(payload)).then((res) => {

                if (res?.status === 201 || res?.status === 200) {
                    // setIsConfimationModalOpen(true)
                    if (res?.data?.qrcode_id) {
                        setQrcodeId(res.data.qrcode_id)
                        handleTimeLength({ target: { 'name': 'events', 'value': selectedEv } })
                    }

                    if (Object.keys(res?.data?.fastTrackData)?.length > 0) {
                        setIsFastTrackChecked(true)
                        setIsFastTrackCard(true)
                        setWalletButtonShow(false)//enable/disable fast-track behaviour
                        setFastTrackData(res?.data?.fastTrackData)
                    } else {
                        setFastTrackData(EMPTY_OBJECT)
                        setIsFastTrackCard(false)
                        setIsFastTrackChecked(false)
                        setWalletButtonShow(showhideWalletButton(faciltyData?.facility ? faciltyData?.facility : facilityLocData?.facility))//enable/disable fast-track behaviour
                        setIsFastTrackCard(false)
                    }

                    if (((res?.data?.permit_request_id && res?.data?.permit_request_id != '') || res?.data?.qrcode_id) || (faciltyData?.payable_amount && Number(faciltyData?.payable_amount) == 0)) {
                        setIsPriceZero(true)
                    } else {
                        setIsPriceZero(false)
                    }
                    if (res?.data && res?.data != null && res?.data?.is_expired == '0') {
                        // SET Events if exists
                        if (res?.data?.ongoing_events?.length > 0) {
                            setEvents(res.data.ongoing_events)
                            if (res?.data?.ongoing_events?.length > 1) {
                                setEventMessage('')
                            }
                        } else {
                            setEvents(EMPTY_ARRAY)
                            setEventMessage('')
                        }
                        setIsRateBandSelected(false)
                        localStorage.removeItem('paymentRecipt')
                        localStorage.setItem('paymentRecipt', JSON.stringify(res?.data))
                        setTicketDetails(res?.data)
                        let localFacData = JSON.parse(localStorage.getItem('faclityData'))
                        localFacData.payable_amount = 0
                        localFacData.is_price_applicable = '0'
                        localFacData.parking_amount = 0
                        localFacData.processing_fee = 0
                        localFacData.tax_rate = 0
                        localFacData.discount_amount = 0
                        localFacData.discount_hours = 0
                        if (faciltyData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1') {
                            localFacData.surcharge_fee = 0
                        }
                        setFaciltyData(localFacData)
                        if (res?.data?.is_checkin == '0' && res?.data?.is_checkout == '0') {
                            // localStorage.setItem('local_ticket', JSON.stringify(res?.data))
                            setLocalTicket(res?.data)
                            const currentTime = new Date(getConvertedDate(moment(new Date()).tz(res?.data?.facility?.timezone ? res?.data?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
                            const checkinTime = new Date(getConvertedDate(moment(new Date(res?.data?.checkin_time)).format('YYYY-MM-DD HH:mm:ss')))
                            const totalHours = moment(currentTime).diff(checkinTime, 'minutes')
                            const timeRemain = TimeConversionInHours(totalHours)
                            let correctRates = bandRef?.current?.filter((item) => {
                                if (Number(item.max_stay) > Number(timeRemain)) {
                                    return true
                                }
                                return false
                            })
                            if (!correctRates?.length) {
                                correctRates = bandRef?.current
                            }

                            setRateBandData(correctRates)
                            const rateBandsForSelection = correctRates.map((item) => item?.rate_band_description)
                            const priceForRateBrands = correctRates.map((item) => item?.price)
                            // const defaultRateBand = [
                            //     'Select Rate Band'
                            // ]
                            const rateBandsRef = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                            setRateBands(rateBandsRef)
                            setIsReloadRates({ ...isReloadRates, modal: true, check: true })
                        } else {
                            setLocalTicket(null)
                            // localStorage.removeItem('local_ticket')
                            // if (isReloadRates.check || faciltyData?.display_msg) {
                            //     // FETCH RATE BANDS API DETAILS
                            //     const payload = {
                            //         facility_id: facilityLocData?.facility?.id,
                            //         user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                            //     }
                            //     dispatch(fetchRateBands(payload)).then((res) => {
                            //         if (res?.data) {
                            //             if(res?.data?.ongoing_events?.length === 0 && res?.data?.price_band?.length === 0) {
                            //                 setBandMsge(res?.data?.error_msg ? res?.data?.error_msg : '')
                            //             } else {
                            //                 setBandMsge('')
                            //             }
                            //             // SET Events if exists
                            //             if(res?.data?.ongoing_events?.length > 0) {
                            //                 setEvents(res?.data?.ongoing_events)
                            //             }
                            //             // SET RATE BANDS DATA
                            //             if(facilityLocData?.facility?.is_price_band == '1') {
                            //                 // SET RATE BAND TRUE
                            //                 setIsDisplayRateBand(true)
                            //                 setRateBandData(res?.data?.price_band)
                            //                 const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                            //                 const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                            //                 // const defaultRateBand = [
                            //                 //     'Select Rate Band'
                            //                 // ]
                            //                 const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                            //                 setRateBands(rateBands)
                            //             }
                            //         } else {
                            //             notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            //             setBandMsge(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            //         }
                            //     }).catch((err) => {
                            //         notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                            //         setBandMsge(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                            //     })
                            //     setIsReloadRates({ ...isReloadRates, check: false })
                            // }
                        }
                    } else {

                        setTicketDetails(EMPTY_OBJECT)
                        localStorage.setItem('paymentRecipt', '{}')
                        // notify('error', 'No record found')
                    }
                } else {
                    localStorage.removeItem('local_ticket')
                    setTicketDetails(EMPTY_OBJECT)

                    localStorage.setItem('paymentRecipt', '{}')
                    if (isDefaultFastTrackEnabledRef.current && !isDefaultFastTrackDisableRef.current) {
                        setIsFastTrackChecked(true)
                        setIsFastTrackCard(true)
                        setWalletButtonShow(false)//enable/disable fast-track behaviour
                    } else {
                        setIsFastTrackChecked(false)
                        setIsFastTrackCard(false)
                        setWalletButtonShow(showhideWalletButton(faciltyData?.facility ? faciltyData?.facility : facilityLocData?.facility))//enable/disable fast-track behaviour
                    }
                    setFastTrackData(EMPTY_OBJECT)                    // setError(res?.errors?.message)
                    // notify('error', res?.errors?.message)
                }
            }).catch((err) => {

                setIsRateBandSelected(false)
                setTicketDetails(EMPTY_OBJECT)
                if (isDefaultFastTrackEnabledRef.current && !isDefaultFastTrackDisableRef.current) {
                    setIsFastTrackChecked(true)
                    setIsFastTrackCard(true)
                    setWalletButtonShow(false)//enable/disable fast-track behaviour
                } else {
                    setIsFastTrackChecked(false)
                    setIsFastTrackCard(false)
                    setWalletButtonShow(showhideWalletButton(faciltyData?.facility ? faciltyData?.facility : facilityLocData?.facility))//enable/disable fast-track behaviour
                }
                setFastTrackData(EMPTY_OBJECT)
                localStorage.setItem('paymentRecipt', '{}')
                let errObject = {
                    payload: payload,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-TransientForm.js-955`))
                // notify('error', 'Something went wrong!')
            })
        }
        if ((name === 'license_plate' || name === 'phone') && faciltyData?.promocode_discount?.promocode?.promocode) {
            setCheckPromo(checkPromo + 1)
        }
    }
    // new code function  
    const detailsVerification = async () => {
        const isValid = await trigger(['last_name', 'first_name', 'color', 'modeltext', 'model', 'maketext', 'make', 'zone', 'state', 'license_plate', 'phone', 'termsnconds'])
        const email = getValues('email')
        const phone = phoneRef?.current || getValues('phone')
        if (isValid && ((email && email != '') || (phone && phone != '') || loggedInUserData()?.user?.phone_number)) {
            setPhoneEmailError(false)
            const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
            const minHours = facilityLocData?.minmum_length ? parseFloat(facilityLocData?.minmum_length) : 0
            const length_of_stay = seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.max_stay : totalHoursLength
            if ((totalHoursLength == '0' || totalHoursLength == '0:00' || totalHoursLength == '0.00')) {
                setIsSubmittingForm(false)
                notify('error', timeValidationConversion(updatedFacilityDate))
                setIsTokenApiStart(false)
            } else if (isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Display Desired Start Date - Ungated') && !selectedPastDate) {
                notify('error', errorMessage?.errorInStartDate)
            } else if (facilityLocData?.minmum_length && (minHours > parseFloat(length_of_stay))) {
                let timeToShow = getFormattedTime(facilityLocData?.minmum_length)
                setIsSubmittingForm(false)
                notify('error', 'Please select minimum duration ' + timeToShow + ' hours')
                setIsTokenApiStart(false)
            } else {
                const getFormData = getValues()
                getFormData.verify_prepay = 'post'
                onSubmit(getFormData)
            }
        } else {
            setPhoneEmailError(true)
        }
    }

    // new code function  
    const closeApplePaySession = (endsession) => {
        if (applePaySessionRef.current) {
            if (endsession === 'success') {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_SUCCESS)
            } else if (endsession === 'failed') {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_FAILURE)
            } else {
                applePaySessionRef.current.abort()
            }
        }
    }

    const getStartDateByLicense = (license_plate = '', faciltyData = {}, callAPI = false, durationSelector, e, hour, minute) => {
        const payload = {
            'partner_id': partnerDetailsRef?.current?.id,
            'license_plate': license_plate,
            'facility_id': faciltyData?.facility?.id
        }
        if (faciltyData?.facility?.id && faciltyData?.facility?.facility_configuration?.is_true_start == '1') {
            dispatch(getStartDateByAPI(payload)).then((res) => {
                let curTime = moment().tz(faciltyData?.facility?.timezone ? faciltyData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')
                if (res?.event_timestamp) {
                    if (res?.event_timestamp != null) {
                        setSelectedPastDate(res.event_timestamp)
                        setEntryDateTime(res.event_timestamp)
                        startDateAPIRes.current = res
                    } else {
                        setSelectedPastDate(curTime)
                        setEntryDateTime(curTime)
                        startDateAPIRes.current = null
                    }
                    let tmStart = res?.event_timestamp != null ? res?.event_timestamp : curTime

                    if (callAPI) {
                        if (durationSelector == '1') {
                            handleTimeLength(e, license_plate, tmStart)
                        } else if (durationSelector == '0') {
                            handleTimeLength(hour, license_plate, tmStart)
                            handleTimeLength(minute, license_plate, tmStart)
                        }
                    }
                } else {
                    setSelectedPastDate(curTime)
                    setEntryDateTime(curTime)
                    startDateAPIRes.current = null
                }
            })
        }
    }

    const onSubmit = async (data) => {
        const isValid = await trigger()
        if (isValid) {


            localStorage.removeItem('phone')
            if (reservationData.reservationID === null) {
                if (!isSubmittingForm) {
                    setIsSubmittingForm(true)
                    setOnSubmitData(data)
                    // setIsTokenApiStart(true)
                    const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
                    // const currArrivalTime = moment.utc(new Date()).subtract(210, 'm').format('DD-MM-YYYY HH:mm:ss')
                    const currArrivalTime = moment().tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')
                    const markerPayload = {
                        facility_id: facilityLocData?.facility?.id,
                        arrival_time: currArrivalTime,
                        length_of_stay: totalHoursLength ? totalHoursLength : seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.max_stay : '',
                        rate_band_id: seletedRateBand?.[0]?.id,
                        user_id: loginData?.user?.id ? loginData?.user?.id : 0
                    }
                    if (selectedPastDate) {
                        markerPayload.start_date = selectedPastDate
                    }
                    const minHours = facilityLocData?.minmum_length ? parseFloat(facilityLocData?.minmum_length) : 0
                    if ((totalHoursLength == '0' || totalHoursLength == '0:00' || totalHoursLength == '0.00')) {
                        setIsSubmittingForm(false)
                        setVerifyDetails(false)
                        // if (isDisplayRateBand) {
                        //     notify('error', 'Please select valid duration')
                        // } else {
                        if (rateBandData?.length == 0 && facilityLocData?.facility?.is_price_band == '1' && facilityLocData?.facility?.is_custom_picker_enabled == 0) {
                            notify('error', errorMessage?.rateBandnotAvailable) //Removed Facility Not Operation Message, Not relevant here.
                        } else {
                            notify('error', timeValidationConversion(updatedFacilityDate))
                        }
                        // }
                        setIsTokenApiStart(false)
                    } else if (facilityLocData?.minmum_length && (minHours > parseFloat(markerPayload.length_of_stay))) {
                        let timeToShow = getFormattedTime(facilityLocData?.minmum_length)
                        setIsSubmittingForm(false)
                        notify('error', 'Please select minimum duration ' + timeToShow + ' hours')
                        setIsTokenApiStart(false)
                        setVerifyDetails(false)
                    } else {
                        if (selectedPastDate) {
                            data.start_date = selectedPastDate
                        }
                        handleSubmitAction(data)
                    }
                }
            } else {
                if (loginData?.access_token) {
                    const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
                    let finalPayload = {}
                    if (data?.vehicle_id && data?.vehicle_id != '') {
                        finalPayload = {
                            facility_id: faciltyData?.facility?.id,
                            phone: loginData?.user?.phone_number,
                            email: loginData?.user?.email ? loginData?.user?.email : '',
                            vehicle_id: data?.vehicle_id, reservation_id: reservationData.reservationID,
                            discount_amount: facilityLocData?.discount_amount,
                            promocode: facilityLocData?.promocode_discount?.promocode?.promocode,
                            total: faciltyData?.payable_amount,
                            user_id: loggedInUserData()?.user?.id,
                            check_warning: 1,
                            length: Number(totalHoursLength).toFixed(2),
                            verify_prepay: 0
                        }

                        if (faciltyData?.permit_request_id && faciltyData?.permit_request_id != '') {
                            finalPayload.permit_request_id = faciltyData?.permit_request_id
                        }
                        if (events.length > 0) {
                            finalPayload.event_id = selectedEv
                            delete finalPayload.length
                            if (qrcodeId) {
                                finalPayload.qrcode_id = qrcodeId
                            }
                        }
                        if (faciltyData?.reservation_id) {
                            finalPayload.reservation_id = faciltyData?.reservation_id
                        } else if (faciltyData?.pass_id) {
                            finalPayload.pass_id = faciltyData?.pass_id
                        }

                        const isVehicleOversized = isOversizedVehicleRef.current
                        finalPayload.is_vehicle_oversize = isVehicleOversized ? 1 : 0

                        if (selectedPastDate) {
                            finalPayload.start_date = selectedPastDate
                        }

                        if (startDateAPIRes?.current) {
                            finalPayload.lpr_id = startDateAPIRes?.current?.lpr_id
                        }

                        finalPayload.is_fast_track_enabled = isFastTrackChecked ? 1 : 0

                        dispatch(postCardPaymentDetails(finalPayload)).then((res) => {
                            if ((res?.status === 201 || res?.status === 200) && res?.data) {
                                setIsSubmittingForm(false)
                                const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                                localStorage.removeItem('paymentRecipt')
                                localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                                closeApplePaySession('success')
                                setIsSubmittingForm(false)
                                if (finalPaymentData?.ticket_number && finalPaymentData?.ticket_number != '') {
                                    navigate(`/${partner}${URL?.CONFIRMATION}/${finalPaymentData?.ticket_number}`)
                                }
                                setIsTokenApiStart(false)
                            } else {
                                if ((res?.status == 422 && (res?.errors?.detail?.isratemismatch != 1)) || (res?.errors?.message && res?.errors?.message.includes('active parking session'))) {
                                    setIsConfimationModalOpen(true)
                                    setIsSubmittingForm(false)
                                    setActivesessionMessage(res?.errors?.message)
                                } else if (res?.errors?.detail?.isratemismatch) {
                                    setIsSubmittingForm(false)
                                    setIsRateMisMatch(true)
                                    setMismatchRateError(res?.errors?.message)
                                    setActivesessionMessage('')
                                } else {
                                    setActivesessionMessage('')
                                    setIsSubmittingForm(false)
                                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                                    let errObject = {
                                        payload: finalPayload,
                                        error: res,
                                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                                    }
                                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} postCardPaymentDetails-TransientForm.js-1220`))
                                }
                                setIsTokenApiStart(false)
                                // closeApplePaySession('failed')
                            }
                        }).catch((err) => {
                            setIsSubmittingForm(false)
                            // closeApplePaySession('failed')
                            if ((err?.status == 422 && (err?.errors?.detail?.isratemismatch != 1)) || (err?.errors?.message && err?.errors?.message.includes('active parking session'))) {
                                setIsConfimationModalOpen(true)
                            } else if (err?.errors?.detail?.isratemismatch) {
                                setIsRateMisMatch(true)
                                setIsSubmittingForm(false)
                                setMismatchRateError(err?.errors?.message)
                            } else {
                                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                            setIsTokenApiStart(false)
                            let errObject = {
                                payload: finalPayload,
                                error: err,
                                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} postCardPaymentDetails-TransientForm.js-1220`))
                        })
                    } else {
                        setIsSubmittingForm(false)
                        notify('error', 'Please add a Vehicle')
                    }
                } else {
                    const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
                    let finalPayload = {}
                    finalPayload = {
                        facility_id: faciltyData?.facility?.id,
                        license_plate: data?.license_plate,
                        color: data?.color,
                        make: data?.make == 'Others' ? data?.maketext : data?.make,
                        model: data?.model == 'Others' ? data?.modeltext : data?.model,
                        phone: data?.phone,
                        state_id: data?.state,
                        length: Number(totalHoursLength).toFixed(2),
                        discount_amount: facilityLocData?.discount_amount,
                        promocode: facilityLocData?.promocode_discount?.promocode?.promocode,
                        total: faciltyData?.payable_amount,
                        check_warning: 1,
                        reservation_id: reservationData?.reservationID
                    }
                    if (walletButtonShow) {
                        finalPayload.verify_prepay = 0
                    }
                    if (faciltyData?.facility?.is_price_band == 1) {
                        finalPayload.rate_band_id = seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.id : isDisplayRateBand ? '' : undefined
                    }
                    if (faciltyData?.permit_request_id && faciltyData?.permit_request_id != '') {
                        finalPayload.permit_request_id = faciltyData?.permit_request_id
                    }
                    if (faciltyData?.reservation_id) {
                        finalPayload.reservation_id = faciltyData?.reservation_id
                    } else if (faciltyData?.pass_id) {
                        finalPayload.pass_id = faciltyData?.pass_id
                    }
                    if (events.length > 0) {
                        finalPayload.event_id = selectedEv
                        delete finalPayload.length
                        if (qrcodeId) {
                            finalPayload.qrcode_id = qrcodeId
                        }
                    }

                    const isVehicleOversized = isOversizedVehicleRef.current
                    finalPayload.is_vehicle_oversize = isVehicleOversized ? 1 : 0


                    if (selectedPastDate) {
                        finalPayload.start_date = selectedPastDate
                    }

                    if (startDateAPIRes?.current) {
                        finalPayload.lpr_id = startDateAPIRes?.current?.lpr_id
                    }

                    // const isFastTrackEnabled = getValues('is_fast_track_enabled')
                    // finalPayload.is_fast_track_enabled = isFastTrackEnabled ? 1 : 0
                    finalPayload.is_fast_track_enabled = isFastTrackChecked || checkInData?.is_fast_track_enabled == 1 ? 1 : 0

                    dispatch(postCardPaymentDetails(finalPayload)).then((res) => {
                        if ((res?.status === 201 || res?.status === 200) && res?.data) {
                            setIsSubmittingForm(false)
                            if (data?.phone) {
                                localStorage.setItem('phone', data?.phone)
                            }
                            const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                            localStorage.removeItem('paymentRecipt')
                            localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                            closeApplePaySession('success')
                            setIsSubmittingForm(false)
                            if (finalPaymentData?.ticket_number && finalPaymentData?.ticket_number != '') {
                                navigate(`/${partner}${URL?.CONFIRMATION}/${finalPaymentData?.ticket_number}`)
                            }
                            setIsTokenApiStart(false)
                            setActivesessionMessage('')
                            setIsConfimationModalOpen(false)
                        } else {
                            if ((res?.status == 422 && (res?.errors?.detail?.isratemismatch != 1)) || (res?.errors?.message && res?.errors?.message.includes('active parking session'))) {
                                setIsConfimationModalOpen(true)
                                setIsSubmittingForm(false)
                                setActivesessionMessage(res?.errors?.message)
                            } else if (res?.errors?.detail?.isratemismatch) {
                                setIsConfimationModalOpen(false)
                                setActivesessionMessage('')
                                setIsRateMisMatch(true)
                                setIsSubmittingForm(false)
                                setMismatchRateError(res?.errors?.message)
                            } else {
                                setIsConfimationModalOpen(false)
                                setActivesessionMessage('')
                                setIsSubmittingForm(false)
                                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                            setIsTokenApiStart(false)
                            // closeApplePaySession('failed')
                            let errObject = {
                                payload: finalPayload,
                                error: res,
                                errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} postCardPaymentDetails-TransientForm.js-1294`))
                        }
                    }).catch((err) => {
                        // closeApplePaySession('failed')
                        if (err?.errors?.detail?.isratemismatch) {
                            setIsSubmittingForm(false)
                            setIsRateMisMatch(true)
                            setMismatchRateError(err?.errors?.message)
                        } else {
                            setIsSubmittingForm(false)
                            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                        setIsSubmittingForm(false)
                        setIsTokenApiStart(false)
                        let errObject = {
                            payload: finalPayload,
                            error: err,
                            errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} postCardPaymentDetails-TransientForm.js-1294`))
                    })
                }
            }
        } else {
            setIsSubmittingForm(true)
        }

    }

    const handleSubmitAction = (formData) => {
        let data

        if (formData && Object.values(formData).length > 0) {
            data = formData
        } else {
            data = { ...onSubmitData }
        }

        setWarningPark(false)
        setAvalablityAlertIsOpen(false)
        // if (loginData?.access_token || faciltyData?.payable_amount=='0') {
        if (loginData?.access_token) {
            const loginData = loggedInUserData()
            if (loginData) {
                data.vehicle_id = currentSelVehicle?.id ? currentSelVehicle?.id : ''
            }
            finalPaymentToBackend('', data, 1)
        } else {
            // const payload = {
            //     'Account': data?.card_number ? data?.card_number : '',
            //     'ExpirationMonth': data?.expiry ? data?.expiry.substr(0, 2) : '',
            //     'ExpirationYear': data?.expiry ? `20${data?.expiry.substr(2, 5)}` : '',
            //     'CVV': data?.cvv ? data?.cvv : ''
            // }
            // const headers = { 'Authorization': faciltyData?.DATACAP_TOKEN, 'Content-Type': 'application/json', Accept: 'application/json' }
            // axios.post(faciltyData?.DATACAP_OTU_URL, payload, { headers })
            // .then((response) => {
            //     if (response?.data) {
            //         finalPaymentToBackend(response?.data, data)
            //     } else if (response?.Error) {
            //         setIsSubmittingForm(false)
            //         setIsTokenApiStart(false)
            //         notify('error', response?.data ? response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
            //     }
            // }).catch((err) => {
            //     setIsSubmittingForm(false)
            //     setIsTokenApiStart(false)
            //     notify('error', err?.response?.data ? err?.response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
            // })
            if (faciltyData?.facility?.facility_payment_details?.facility_payment_type_id == '3' && cardToken && cardToken.token) {
                // For Fiserv, use cardToken to create payment data
                const card = {
                    name_on_card: data?.name_on_card,
                    card_number: cardToken.token,
                    expiration_date: formatExpiryDate(cardToken.expiry),
                    security_code: '',
                    zip_code: data?.zip_code
                }
                const nonce = encryptionHandler(card)
                finalPaymentToBackend(nonce, data, 1)
            } else if (data?.name_on_card && data?.card_number && data?.expiry && data?.cvv) {
                const card = {
                    name_on_card: data?.name_on_card,
                    card_number: data?.card_number,
                    expiration_date: data?.expiry,
                    security_code: data?.cvv,
                    zip_code: data?.zip_code
                }
                const nonce = encryptionHandler(card)
                finalPaymentToBackend(nonce, data, 1)
            } else {
                finalPaymentToBackend('', data, 1)
            }
        }
    }

    const finalPaymentToBackend = (data, upperData, verify_prepay) => {

        if (loginData?.access_token) {

            setFormData(upperData)
            handleLoggedInUserCheckIn(0, upperData, verify_prepay)
        } else {

            const updatedData = { ...upperData, ...{ nonce: data } }
            setFormData(updatedData)
            handleGuestUserCheckIn(0, updatedData, verify_prepay)
        }
    }

    const handleLoggedInUserCheckIn = (warning, upperData, verify_prepay) => {

        if (!isSubmittingForm) {
            const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
            let finalPayload = {}
            if ((upperData?.vehicle_id && upperData?.vehicle_id != '' && ((currentSelCard?.payment_profile_id && currentSelCard?.payment_profile_id != '') || verify_prepay == 1 || upperData?.walletPay) || (isFastTrackChecked && fastTrackData && Object.keys(fastTrackData).length > 0)) || (isPriceZero && upperData?.vehicle_id && upperData?.vehicle_id != '')) {
                finalPayload = {
                    facility_id: faciltyData?.facility?.id,
                    phone: loginData?.user?.phone_number,
                    email: loginData?.user?.email ? loginData?.user?.email : '',
                    vehicle_id: upperData?.vehicle_id,
                    length: seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.max_stay : totalHoursLength,
                    discount_amount: facilityLocData?.discount_amount,
                    promocode: facilityLocData?.promocode_discount?.promocode?.promocode,
                    total: faciltyData?.payable_amount,
                    payment_profile_id: (upperData?.paymentMethod && upperData?.paymentMethod != '') ? '' : (verify_prepay && (verify_prepay == 'post' || verify_prepay == 1)) ? currentSelCard?.payment_profile_id : '',
                    user_id: loggedInUserData()?.user?.id,
                    card_holder_id: currentSelCard?.card_holder_id ? currentSelCard?.card_holder_id : '',
                    // check_warning: warning,
                    card_last_four: currentSelCard?.card_last_four ? currentSelCard?.card_last_four : '',
                    expiry: currentSelCard?.expiry ? currentSelCard?.expiry : '',
                    walletPay: upperData?.walletPay ? upperData?.walletPay : '',
                    paymentMethods: upperData?.paymentMethod ? upperData?.paymentMethod : '',
                    check_warning: ((verify_prepay && verify_prepay == 'post') && walletButtonShow && warningState) ? 1 : warning ? warning : 0,
                }
                if (walletButtonShow && Number(faciltyData?.payable_amount) > 0) {
                    finalPayload.verify_prepay = ((verify_prepay && verify_prepay == 'post')) ? 0 : 1
                }




                // if(isFastTrackChecked && Object.keys(fastTrackData).length > 0){
                //     finalPayload.is_fast_track_enabled = isFastTrackChecked ? 1 : 0
                //     // finalPayload.payment_profile_id = ''

                // }else 
                if (isFastTrackChecked) {
                    finalPayload.is_fast_track_enabled = isFastTrackChecked ? 1 : 0
                }


                if (facilityLocData && facilityLocData?.new_discount_amount && facilityLocData?.new_discount_amount != '') {
                    finalPayload.new_discount_amount = facilityLocData?.new_discount_amount
                }
                if (faciltyData?.facility?.is_price_band == 1 && is_rate_or_event_show == 2) {
                    finalPayload.rate_band_id = seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.id : isDisplayRateBand ? '' : undefined
                }
                // reverting for price zero
                if (finalPayload.promocode && Number(finalPayload.total) === 0) {
                    finalPayload.payment_profile_id = ''
                }

                if (firstTimeFastTrackEnable && isFastTrackChecked && isPriceZero) {
                    finalPayload.payment_profile_id = (upperData?.paymentMethod && upperData?.paymentMethod != '') ? '' : (verify_prepay && (verify_prepay == 'post' || verify_prepay == 1)) ? currentSelCard?.payment_profile_id : ''
                }
                if ((isPriceZero && upperData?.vehicle_id && upperData?.vehicle_id != '') || (isFastTrackChecked && isFastTrackCard && fastTrackData && Object.keys(fastTrackData).length > 0)) {
                    delete finalPayload.payment_profile_id
                    delete finalPayload.card_last_four
                    delete finalPayload.expiry
                }

                if (faciltyData?.permit_request_id && faciltyData?.permit_request_id != '') {
                    finalPayload.permit_request_id = faciltyData?.permit_request_id
                }
                if (faciltyData?.reservation_id) {
                    finalPayload.reservation_id = faciltyData?.reservation_id
                } else if (faciltyData?.pass_id) {
                    finalPayload.pass_id = faciltyData?.pass_id
                } else if (checkInData?.pass_id) {
                    finalPayload.pass_id = checkInData?.pass_id
                }
                if (events.length > 0 && is_rate_or_event_show == 1) {
                    finalPayload.event_id = selectedEv
                    delete finalPayload.length
                    if (qrcodeId) {
                        finalPayload.qrcode_id = qrcodeId
                    }
                }

                if (Object.hasOwn(checkInData, 'is_vehicle_oversize')) { // Changes for firefox issue
                    finalPayload.is_vehicle_oversize = checkInData?.is_vehicle_oversize ? 0 : 1
                }
                if (selectedPastDate) {
                    finalPayload.start_date = selectedPastDate
                }

                if (startDateAPIRes?.current) {
                    finalPayload.lpr_id = startDateAPIRes?.current?.lpr_id
                }

                finalPayload.is_fast_track_enabled = isFastTrackChecked ? 1 : 0

                dispatch(postCardPaymentDetails(finalPayload)).then((res) => {
                    setVerifyDetails(false)
                    if (res?.status === 201 && res?.data) {
                        setIsSubmittingForm(false)
                        const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                        localStorage.removeItem('paymentRecipt')
                        localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                        if (finalPaymentData?.ticket_number && finalPaymentData?.ticket_number != '') {
                            navigate(`/${partner}${URL?.CONFIRMATION}/${finalPaymentData?.ticket_number}`)
                        }
                        setIsTokenApiStart(false)
                        setIsConfimationModalOpen(false)
                        setActivesessionMessage('')
                        closeApplePaySession('success')
                    } else {
                        if (walletButtonShow) {
                            setVerifyDetails(true)
                            setTermsAndCondion(false)
                            setValue('termsnconds', false)
                        }
                        if ((res?.status == 422 && (res?.errors?.detail?.isratemismatch != 1)) || (res?.errors?.message && res?.errors?.message.includes('active parking session'))) {
                            setIsConfimationModalOpen(true)
                            setIsSubmittingForm(false)
                            setActivesessionMessage(res?.errors?.message)
                        } else if (res?.errors?.detail?.isratemismatch) {
                            setIsRateMisMatch(true)
                            setIsSubmittingForm(false)
                            setMismatchRateError(res?.errors?.message)
                            setIsConfimationModalOpen(false)
                            setActivesessionMessage('')
                        } else {
                            setIsConfimationModalOpen(false)
                            setActivesessionMessage('')
                            setIsSubmittingForm(false)
                            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            let errObject = {
                                payload: finalPayload,
                                error: res,
                                errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} postCardPaymentDetails-TransientForm.js-1439`))
                        }
                        closeApplePaySession('failed')
                        setIsTokenApiStart(false)
                    }
                }).catch((err) => {
                    if (walletButtonShow) {
                        setVerifyDetails(true)
                        setTermsAndCondion(false)
                        setValue('termsnconds', false)
                    }
                    closeApplePaySession('failed')
                    setIsSubmittingForm(false)
                    if ((err?.status == 422 && (err?.errors?.detail?.isratemismatch != 1)) || (err?.errors?.message && err?.errors?.message.includes('active parking session'))) {
                        setIsConfimationModalOpen(true)
                        setIsSubmittingForm(false)
                    } else if (err?.errors?.detail?.isratemismatch) {
                        setIsRateMisMatch(true)
                        setIsSubmittingForm(false)
                        setMismatchRateError(err?.errors?.message)
                    } else {
                        setIsSubmittingForm(false)
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                    setIsTokenApiStart(false)
                    let errObject = {
                        payload: finalPayload,
                        error: err,
                        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} postCardPaymentDetails-TransientForm.js-1439`))
                })
            } else {
                setIsSubmittingForm(false)
                notify('error', `${(isPriceZero && upperData?.vehicle_id && upperData?.vehicle_id != '') ? 'Please add a Vehicle' : (upperData?.vehicle_id && upperData?.vehicle_id != '') ? 'Please add a Card' : (upperData?.card_id && upperData?.card_id != '') ? 'Please add a Vehicle' : 'Please add a Vehicle and Card'}`)
            }
        }
    }
    const handleGuestUserCheckIn = (warning, upperData, verify_prepay) => {
        const email = getValues('email')
        const phone = phoneRef?.current || getValues('phone')
        if ((email && email != '') || (phone && phone != '')) {
            setPhoneEmailError(false)
            if (!isSubmittingForm) {
                // if (upperData?.nonce && upperData?.nonce != '' && upperData?.nonce != null && upperData?.nonce != undefined) {

                const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
                let finalPayload = {}
                finalPayload = {
                    facility_id: faciltyData?.facility?.id,
                    license_plate: upperData?.license_plate,
                    color: upperData?.color,
                    make: upperData?.make == 'Others' ? upperData?.maketext : upperData?.make,
                    model: upperData?.model == 'Others' ? upperData?.modeltext : upperData?.model,
                    phone: (checkInData?.disabled && checkInData?.phone) ? checkInData?.phone : upperData?.phone ? upperData?.phone : getValues('phone'),
                    email: upperData?.email,
                    length: seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.max_stay : totalHoursLength,
                    discount_amount: facilityLocData?.discount_amount,
                    promocode: facilityLocData?.promocode_discount?.promocode?.promocode,
                    total: faciltyData?.payable_amount,
                    walletPay: upperData?.walletPay ? upperData?.walletPay : '',
                    nonce: isPriceZero ? '' : upperData?.nonce,
                    paymentMethods: upperData?.paymentMethod ? upperData?.paymentMethod : '',
                    check_warning: ((verify_prepay && verify_prepay == 'post') && walletButtonShow && warningState) ? 1 : warning ? warning : 0,
                }
                if (walletButtonShow && Number(faciltyData?.payable_amount) > 0) {
                    finalPayload.verify_prepay = ((verify_prepay && verify_prepay == 'post')) ? 0 : 1
                }
                if (facilityLocData && facilityLocData?.new_discount_amount && facilityLocData?.new_discount_amount != '') {
                    finalPayload.new_discount_amount = facilityLocData?.new_discount_amount
                }
                // state ID was sending if there is no option to select
                if (upperData?.make || upperData?.model) {
                    finalPayload.state_id = upperData?.state
                }

                if (faciltyData?.facility?.is_price_band == 1 && is_rate_or_event_show == 2) {
                    finalPayload.rate_band_id = seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.id : isDisplayRateBand ? '' : undefined
                }
                // reverting for price zero
                if (finalPayload.promocode && Number(finalPayload.total) === 0) {
                    finalPayload.nonce = ''
                }

                //If user use first time fasttrack save nonce//PIMS-14760
                if (firstTimeFastTrackEnable && isFastTrackChecked && isPriceZero) {
                    finalPayload.nonce = upperData?.nonce
                }

                if (faciltyData?.permit_request_id && faciltyData?.permit_request_id != '') {
                    finalPayload.permit_request_id = faciltyData?.permit_request_id
                }
                if (faciltyData?.reservation_id) {
                    finalPayload.reservation_id = faciltyData?.reservation_id
                } else if (faciltyData?.pass_id) {
                    finalPayload.pass_id = faciltyData?.pass_id
                } else if (checkInData?.pass_id) {
                    finalPayload.pass_id = checkInData?.pass_id
                }
                if (events.length > 0 && is_rate_or_event_show == 1) {
                    finalPayload.event_id = selectedEv
                    delete finalPayload.length
                    if (qrcodeId) {
                        finalPayload.qrcode_id = qrcodeId
                    }
                }

                if (isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Enable Name Fields - Transient')) {
                    finalPayload.first_name = upperData?.first_name
                    finalPayload.last_name = upperData?.last_name
                }

                if (Object.hasOwn(checkInData, 'is_vehicle_oversize')) { // Changes for firefox issue
                    finalPayload.is_vehicle_oversize = checkInData?.is_vehicle_oversize ? 0 : 1
                }

                if (selectedPastDate) {
                    finalPayload.start_date = selectedPastDate
                }

                if (startDateAPIRes?.current) {
                    finalPayload.lpr_id = startDateAPIRes?.current?.lpr_id
                }

                // const isFastTrackEnabled = getValues('is_fast_track_enabled')

                finalPayload.is_fast_track_enabled = isFastTrackChecked || checkInData?.is_fast_track_enabled == 1 ? 1 : 0


                dispatch(postCardPaymentDetails(finalPayload)).then((res) => {
                    if (res?.status === 201 && res?.data) {
                        setVerifyDetails(false)
                        setIsSubmittingForm(false)
                        const finalPaymentData = { ...res?.data, facility: faciltyData.facility }
                        localStorage.removeItem('paymentRecipt')
                        localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                        closeApplePaySession('success')
                        if (finalPaymentData?.ticket_number && finalPaymentData?.ticket_number != '') {
                            navigate(`/${partner}${URL?.CONFIRMATION}/${finalPaymentData?.ticket_number}`)
                        }
                        setActivesessionMessage('')
                        setIsConfimationModalOpen(false)
                    } else {
                        if (walletButtonShow) {
                            setVerifyDetails(true)
                            setTermsAndCondion(false)
                            setValue('termsnconds', false)
                        }
                        setIsSubmittingForm(false)
                        setIsRateMisMatch(false)
                        if ((res?.status == 422 && (res?.errors?.detail?.isratemismatch != 1)) || (res?.errors?.message && res?.errors?.message.includes('active parking session'))) {
                            setIsConfimationModalOpen(true)
                            setActivesessionMessage(res?.errors?.message)
                            setIsSubmittingForm(false)
                        } else if (res?.errors?.detail?.isratemismatch) {
                            setIsConfimationModalOpen(false)
                            setIsRateMisMatch(true)
                            setIsSubmittingForm(false)
                            setMismatchRateError(res?.errors?.message)
                            setActivesessionMessage('')
                        } else {
                            setIsConfimationModalOpen(false)
                            setActivesessionMessage('')
                            setIsSubmittingForm(false)
                            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            let errObject = {
                                payload: finalPayload,
                                error: res,
                                errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} postCardPaymentDetails-TransientForm.js-1527`))
                        }
                        closeApplePaySession('failed')
                        setIsTokenApiStart(false)
                    }
                }).catch((err) => {
                    if (walletButtonShow) {
                        setVerifyDetails(true)
                        setTermsAndCondion(false)
                        setValue('termsnconds', false)
                    }
                    closeApplePaySession('failed')
                    setIsSubmittingForm(false)
                    setIsTokenApiStart(false)
                    if (err?.errors?.detail?.isratemismatch) {
                        setIsRateMisMatch(true)
                        setMismatchRateError(err?.errors?.message)
                    } else {
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                    let errObject = {
                        payload: finalPayload,
                        error: err,
                        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} postCardPaymentDetails-TransientForm.js-1527`))
                })
                // }
                //  else {
                //     notify('error', errorMessage?.somethingWentWrong)
                // }
            }
        } else {
            setPhoneEmailError(true)
        }
    }

    const handleAddVehilce = () => { setIsVehicleModalOpen(!isVehicleModalOpen) }

    const handlePaymentModal = () => { setIsPaymentModalOpen(!isPaymentModalOpen) }

    const handleCommonListModal = (key) => {
        if (key == 'Card') {
            if (cardData?.length > 0) {
                setCommonModal(!isCommonModalOpen)
                setSelOptionFlag(key)
            } else {
                handlePaymentModal()
            }
        } else {
            if (vehicleData?.length > 0) {
                setCommonModal(!isCommonModalOpen)
                setSelOptionFlag(key)
            } else {
                handleAddVehilce()
            }
        }
    }

    const handleCurrentSelection = (item) => {
        if (selOptionFlag == 'Vehicle') {
            if (walletButtonShow) {
                setVerifyDetails(true)
                setTermsAndCondion(false)
                setValue('termsnconds', false)
            }
            reset(formValues => ({ ...formValues, 'vehicle_id': item?.id }))
            setCurrentVehicle(item)
            if (faciltyData?.facility?.is_price_band == '1') {
                const phone = (loggedInUserData()?.user?.id) ? loggedInUserData()?.user?.phone_number : phoneRef?.current ? phoneRef?.current : getValues('phone')
                const payload = {
                    facility_id: faciltyData?.facility?.id,
                    user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                    license_plate: item?.license_plate_number?.trim(),
                    phone: phone
                }
                if (faciltyData?.promo_category_id && faciltyData?.promo_category_id != '') {
                    payload.promo_category_id = faciltyData?.promo_category_id
                }
                if (selectedPastDate) {
                    payload.start_date = selectedPastDate
                }
                if (Object.hasOwn(checkInData, 'is_vehicle_oversize')) { // Changes for firefox issue
                    payload.is_vehicle_oversize = checkInData?.is_vehicle_oversize ? 0 : 1
                }
                setresetBand(resetBand + 1)
                fetchBands(payload, false, handleChangeReq.current)
            }
            if (faciltyData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1') {
                // setResetPromo(!resetPromo)
                setresetBand(resetBand + 1)
                setselctedDateTime({
                    ...selctedDateTime,
                    active: false,
                    bandActive: false
                })
                const faciData = faciltyData ? JSON.parse(JSON.stringify(faciltyData)) : {}
                faciData.parking_amount = '0.00'
                faciData.CCFee = '0.00'
                faciData.processing_fee = '0.00'
                faciData.tax_rate = '0.00'
                faciData.paid_amount = '0.00'
                faciData.payable_amount = '0.00'
                faciData.display_msg = ''
                faciData.discount_amount = '0'
                faciData.discount_hours = '0'
                if (faciltyData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1') {
                    faciData.surcharge_fee = '0'
                }
                setFaciltyData(faciData)
                setIsPriceZero(true)
                setSelectedEv(null)
                setTotalHoursLength('0.00')
                if (faciltyData?.facility?.facility_configuration?.is_true_start != '1' || (!isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Display Desired Start Date - Ungated') && faciltyData?.facility?.facility_configuration?.is_true_start == '1')) {
                    if (durationSelector == '1') {
                        const e = { target: { 'name': ['day'], 'value': 0, key: 'isStatic' } }
                        handleTimeLength(e, item?.license_plate_number)
                    } else if (durationSelector == '0') {
                        const hour = { target: { 'name': ['hour'], 'value': 0, key: 'isStatic' } }
                        const minute = { target: { 'name': ['minute'], 'value': 0, key: 'isStatic' } }
                        handleTimeLength(hour, item?.license_plate_number)
                        handleTimeLength(minute, item?.license_plate_number)
                    }
                }

            }
            if (isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Display Desired Start Date - Ungated') && faciltyData?.facility?.facility_configuration?.is_true_start == '1') {
                const e = { target: { 'name': ['day'], 'value': 0, key: 'isStatic' } }
                const hour = { target: { 'name': ['hour'], 'value': 0, key: 'isStatic' } }
                const minute = { target: { 'name': ['minute'], 'value': 0, key: 'isStatic' } }
                getStartDateByLicense(item?.license_plate_number?.trim(), faciltyData, true, durationSelector, e, hour, minute)
            }
        } else if (selOptionFlag == 'RateBand') {
            reset(formValues => ({ ...formValues, 'rate_band_id': item?.id }))
            // setCurrentRateBand(item)
            // FETCH FACILITYRATE
            if (facility && facility != undefined && facility != 'undefined') {
                const payload = {
                    promocode: '',
                    user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                    rate_band_id: item?.id,
                    //facility_id: faciltyData?.facility?.id,
                    length_of_stay: '',
                    'encrypt': facility,
                }
                if ((Number(payload?.length) > 0 && payload?.length != 0) || payload?.length == undefined || payload?.length == 'undefined') {
                    deb(payload, true, false, false, currentSelVehicle, facility_loaded, selectedPastDate, selctedDateTime)
                }
            } else {
                notify('error', 'Sorry something went wrong, Please refresh or try again.')
                let errObject = {
                    payload: facility,
                    error: facility,
                    errorMessage: 'Sorry something went wrong, Please refresh or try again.'
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} deb-TransientForm.js-1633`))
            }

        } else {
            reset(formValues => ({ ...formValues, 'card_id': item?.payment_profile_id ? item?.payment_profile_id : item?.card_holder_id }))
            setCurrentCard(item)
        }

    }

    // const handleRateBand = (e) => {
    //     const { name, value } = e.target
    //     const seletedRateBand = rateBandData?.filter((item) => item?.rate_band_description == value[0])
    //     // reset(formValues => ({ ...formValues, 'rate_band_id': seletedRateBand?.[0]?.id }))
    //     // FETCH FACILITYRATE
    //     if (name?.[0] === 'rateBands') {
    //         const payload = {
    //             promocode: '',
    //             user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
    //             rate_band_id: seletedRateBand?.[0]?.id,
    //             //facility_id: faciltyData?.facility?.id,
    //             length_of_stay: '',
    //             'encrypt': facility,
    //         }
    //         // if (payload?.length !== 0) {
    //         // deb(payload, true)
    //         // }
    //     }
    // }



    // rate band

    // const handleRateBandModal = () => {
    //     setSelOptionFlag('RateBand')
    //     // if (rateBandData?.length == 0) {
    //         setIsRateBandModalOpen(true)
    //     // } else {
    //     //     setIsRateBandModalOpen(false)
    //     // }
    // }

    // IF NEED TO DISPLAY THE TIMER OF ACTIVE CHECKIN
    // const getUserActiveCheckins = () => {
    //     const savedFacility = JSON.parse(localStorage.getItem('faclityData'))
    //     const payload = {
    //         facility_id: '',
    //         user_id: loggedInUserData()?.user?.id
    //     }
    //     dispatch(checkActiveSession(payload)).then((res) => {
    //         if ((res?.data?.checkin_details?.is_expired == '0' && !res?.data?.checkin_details?.is_expired)) {
    //             let paymentData = res?.data?.checkin_details
    //             if (res?.data?.checkin_details?.discount_amount && res?.data?.checkin_details?.discount_amount != '') {
    //                 localStorage.setItem('isCouponApplied', true)
    //             }
    //             localStorage.setItem('paymentRecipt', JSON.stringify(res?.data))
    //             if(res?.data?.id == savedFacility?.facility?.id){
    //                 navigate(`/${partner}${URL?.CONFIRMATION}/${finalPaymentData?.ticket_number}`)
    //             }
    //             setActiveSessionData(res?.data)
    //             setIsCheckingActiveSession(false)
    //         } else {
    //             setIsTokenApiStart(false)
    //             setIsCheckingActiveSession(false)
    //         }
    //     }).catch(() => {
    //         setIsTokenApiStart(false)
    //         setIsCheckingActiveSession(false)
    //     })
    // }

    const handleEntryTime = (event) => {
        setIsRateBandSelected(false)
        localStorage.removeItem('seletedRateBand')
        // setEntryDateTime(event)
        setValue('entry_time', event)
        // let currentTime = exitDateTime
        const savedFacility = JSON.parse(localStorage.getItem('faclityData'))
        // const currentTime = moment(new Date().toLocaleString('en-US', { timeZone: savedFacility?.facility?.timezone })).format('MM-DD-YYYY hh:mm A')
        // const currentTime = moment(new Date()).tz(savedFacility?.facility?.timezone ? savedFacility?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD hh:mm:ss')
        const currentTime = selectedPastDate ? new Date(selectedPastDate) : new Date(getConvertedDate(moment(new Date()).tz(savedFacility?.facility?.timezone ? savedFacility?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
        // const eventTime = new Date(getConvertedDate(moment(event).tz(savedFacility?.facility?.timezone ? savedFacility?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
        let hours = diff_hours(event, currentTime)
        // notify('success', hours)
        if (facility && facility != undefined && facility != 'undefined') {
            const payload = { 'encrypt': facility, length: hours, rate_band_id: '' }
            if ((Number(payload?.length) > 0 && payload?.length != 0) || payload?.length == undefined || payload?.length == 'undefined') {
                deb(payload, false, true, false, currentSelVehicle, facility_loaded, selectedPastDate, selctedDateTime)
            }
        } else {
            notify('error', 'Sorry something went wrong, Please refresh or try again.')
            let errObject = {
                payload: facility,
                error: facility,
                errorMessage: 'Sorry something went wrong, Please refresh or try again.'
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} deb-TransientForm.js-1731`))
        }
    }
    // handle Past Date Selecter
    const handlePastDateSelecter = (selectedDate) => {
        // setOnClickPastDate(event)
        if (!checkInData?.disabled) {
            handleChangeDeb('start_date', currentSelVehicle, faciltyData, selectedDate, false, [], totalHoursLength, {})
        }
    }
    // end 

    const diff_hours = (endTime, startTime) => {
        // let start = moment(new Date(getConvertedDate(new Date(startTime)))).format('MM/DD/YYYY HH:mm:ss') //moment(startTime)?.format('MM/DD/YYYY HH:mm:ss')
        // let end = moment(new Date(getConvertedDate(new Date(endTime)))).format('MM/DD/YYYY HH:mm:ss') //moment(endTime)?.format('MM/DD/YYYY HH:mm:ss')
        // let start= getConvertedDate(moment(startTime)?.format('MM/DD/YYYY HH:mm:ss'))
        let start = new Date(getConvertedDate(moment(startTime)?.format('YYYY-MM-DD HH:mm'))).getTime()
        let end = new Date(getConvertedDate(moment(endTime)?.format('YYYY-MM-DD HH:mm'))).getTime()
        var diff = moment(end).diff(start, 'minutes')
        // var d = Math.floor(diff / (3600*24))
        // var h = Math.floor(diff % (3600*24) / 3600)
        // var m = Math.floor(diff % 3600 / 60)
        // const startDate = new Date(start)
        // const endDate = new Date(end)
        let timeDiff
        if (!isNaN(start) && !isNaN(end)) {
            // const timeDifferenceInMilliseconds = endDate - start
            var hours = Math.floor(diff / 60)
            var minutes = Math.floor(diff % 60)
            // return hours + " hours and " + minutes + " minutes";

            // const timeDifferenceInMilliseconds = endDate - startDate
            // const hours = Math.floor(timeDifferenceInMilliseconds / 3600000)
            // const minutes = Math.floor(
            //     (timeDifferenceInMilliseconds % 3600000) / 60000
            // )
            timeDiff = `${hours}.${minutes < 10 ? '0' + minutes : minutes}`
            // timeDiff = ((d*24) + h) + '.' + (m<10 ? '0'+(m+1) : (m+1))
        } else {
            timeDiff = 'Invalid Time'
        }

        setTotalHoursLength(timeDiff)
        return timeDiff
    }
    const getHoursIndate = (hours) => {
        let dt = getHoursIndayFormat(hours, false)
        return `${Number(dt?.day) > 1 ? dt.day + ' Days ' : Number(dt?.day) == 1 ? dt.day + ' Day ' : ''}
            ${Number(dt?.hour) > 1 ? dt.hour + ' Hours' : Number(dt?.hour) == 1 ? dt.hour + ' Hour' : ''}
            ${Number(dt?.minute) > 1 ? dt.minute + ' Minutes' : Number(dt?.minute) == 1 ? dt.minute + ' Minute' : ''}`
        // if (Number(hours) > 0) {
        //     const day = Math.floor(Number(hours) / 24)
        //     if (Number(hours) % 24 === 0) {
        //         return `${day} ${day === 1 ? 'Day' : 'Days'}`
        //     }

        //     return (Number(hours) < 1) ? convertTimeToDoubleDig(hours) + ' MM' : (Number(hours) === 1) ? convertTimeToDoubleDig(hours) + ' HR' : convertTimeToDoubleDig(hours) + ' HRS'
        // }
    }

    const getDateFormatToshow = (dt) => {
        return moment(dt).format('MMM DD, YYYY hh:mm A')
    }

    const openDateCalendar = (self = true, forced = false) => {
        if (selctedDateTime.active) {
            let hitAPI = faciltyData?.checkout_time && Number(totalHoursLength) > 0
            const updDtTime = {
                ...selctedDateTime,
                active: false,
                bandActive: false,
            }
            if (faciltyData?.facility?.facility_configuration?.is_facility_hotel_type == '1') {
                updDtTime.price = null
            }
            if ((self && !hitAPI) || forced) {
                setVerifyDetails(true)
                setselctedDateTime(updDtTime)
                const faciData = faciltyData ? JSON.parse(JSON.stringify(faciltyData)) : {}
                faciData.parking_amount = '0.00'
                faciData.CCFee = '0.00'
                faciData.processing_fee = '0.00'
                faciData.tax_rate = '0.00'
                faciData.paid_amount = '0.00'
                faciData.payable_amount = '0.00'
                faciData.display_msg = ''
                faciData.discount_amount = '0'
                faciData.discount_hours = '0'
                if (faciltyData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1') {
                    faciData.surcharge_fee = '0'
                }

                // Set Valid Till Updated Value
                faciData.valid_till = selectedPastDateRef.current ? selectedPastDateRef.current : moment(new Date())


                setFaciltyData(faciData)
                setIsPriceZero(true)
                setSelectedEv(null)
                setTotalHoursLength('0.00')
            }

        } else {
            setIsScrollCalendarModal(true)
        }
    }

    // for the custom date for past 
    const handleDataSelect = () => {
        setPastCalenderOpen(!pastCalenderOpen)
        // if (selctedDateTime.active) {
        //     setselctedDateTime( )
        // } else {
        //     setPastCalenderOpen(true)
        // }
    }
    // end

    const handlePermitReservation = (option) => {
        const partnerSlug = partnerDetailsRef?.current?.partner_slug ? partnerDetailsRef?.current?.partner_slug : partner
        if (option == 'permit') {
            if (loggedInUserData()?.access_token && loggedInUserData()?.refresh_token) {
                window.open(`${window?.location?.toString()?.includes('pci') ? getConfigDetails()?.portalURLPCI : window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revportalURL : window?.location?.toString()?.includes('breeze') ? getConfigDetails()?.portalURLPCI : getConfigDetails()?.portalURL}/navigating/${loggedInUserData()?.access_token}/${loggedInUserData()?.refresh_token}/0/${facility}/${partnerSlug}`, '_self')
            } else {
                window.open(`${window?.location?.toString()?.includes('pci') ? getConfigDetails()?.portalURLPCI : window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revportalURL : window?.location?.toString()?.includes('breeze') ? getConfigDetails()?.portalURLPCI : getConfigDetails()?.portalURL}/navigating/0/0/0/${facility}/${partnerSlug}`, '_self')
            }
        } else if (option == 'reservation') {
            if (loggedInUserData()?.access_token && loggedInUserData()?.refresh_token) {
                window.open(`${window?.location?.toString()?.includes('pci') ? getConfigDetails()?.portalURLPCI : window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revportalURL : window?.location?.toString()?.includes('breeze') ? getConfigDetails()?.portalURLPCI : getConfigDetails()?.portalURL}/${partnerSlug}/book-reservation/${faciltyData?.facility?.id}`, '_self')
            } else {
                window.open(`${window?.location?.toString()?.includes('pci') ? getConfigDetails()?.portalURLPCI : window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revportalURL : window?.location?.toString()?.includes('breeze') ? getConfigDetails()?.portalURLPCI : getConfigDetails()?.portalURL}/${partnerSlug}/book-reservation/${faciltyData?.facility?.id}`, '_self')
            }
        }


    }

    const handleRateDetail = () => {
        if (!rateObj.loader) {
            setRateObj({
                ...rateObj,
                loader: true
            })
            dispatch(fetchRateDetailData(faciltyData?.facility?.id)).then((res) => {
                if (res.data) {
                    setRateObj({
                        ...rateObj,
                        data: res?.data,
                        loader: false
                    })
                    setRateDetailModal({ ...rateDetailModal, modal: true })
                } else {
                    notify('error', 'Details not found.')
                    setRateObj({
                        ...rateObj,
                        loader: false
                    })
                }
            })
        }

    }

    const reFetchFacilityParkingData = () => {

        setIsTokenApiStart(true)
        fetchRates(rateFetchPayload)

    }

    const fetchRates = (finalPayload) => {
        const fetchPayload = { ...finalPayload }
        delete fetchPayload.fetchByRate
        delete fetchPayload.checkoutWithTime
        delete fetchPayload.fromDatePicker
        const license_plate = (loggedInUserData()?.user?.id) ? currentSelVehicle?.license_plate_number : getValues('license_plate')
        fetchPayload.license_plate = license_plate

        const isVehicleOversized = isOversizedVehicleRef.current
        fetchPayload.is_vehicle_oversize = isVehicleOversized ? 1 : 0

        if (selectedPastDate) {
            fetchPayload.start_date = selectedPastDate
        }

        dispatch(getFaciltyData(fetchPayload)).then((res) => {
            setIsTokenApiStart(false)
            if (res?.data) {
                if (res?.data?.facility?.facility_configuration?.enable_facility_close == '1') {
                    setBandMsge(res?.data?.facility?.facility_configuration?.facility_close_msg)
                }
                setIsRateMisMatch(false)
                setMismatchRateError('')
                setUpdatedFacilityDate(res.data?.facility)
                if ((res?.data?.availability != null && res?.data?.availability_msg != null && Number(res?.data?.availability) === 0 && res?.data?.availability_msg !== '')) {
                    handleGarageInventory(res?.data)
                } else {
                    if ((res?.data?.permit_request_id && res?.data?.permit_request_id != '') || res?.data?.qrcode_id || (Object.hasOwn(res?.data, 'payable_amount') && Number(res?.data?.payable_amount) == 0)) {
                        setIsPriceZero(true)
                        setVerifyDetails(false)
                    } else {
                        setIsPriceZero(false)
                        setVerifyDetails(true)
                        setTermsAndCondion(false)
                        setValue('termsnconds', false)
                    }
                    if (res?.data?.qrcode_id) {
                        setQrcodeId(res.data.qrcode_id)
                    }
                    // const listItem = [{ 'headerName': 'Parking Amount', 'val': `$${res?.data?.parking_amount ? res?.data?.parking_amount : '0.00'}` }, { 'headerName': 'Tax', 'val': `$${res?.data?.tax_rate ? res?.data?.tax_rate : '0.00'}` }, { 'headerName': 'Processing Fee', 'val': `$${res?.data?.processing_fee ? res?.data?.processing_fee : '0.00'}` }]
                    if (finalPayload?.fromDatePicker) {
                        setselctedDateTime({ ...selctedDateTime, bandActive: true, active: true, price: res.data?.parking_amount, dateUntill: res.data?.checkout_time, daysHrs: getHoursIndate(finalPayload.length) })
                    }
                    const data = res?.data
                    data.default_length = data?.default_length?.toString()
                    localStorage.setItem('faclityData', JSON.stringify(data))


                    const dcap = {
                        DATACAP_OTU_URL: data?.DATACAP_OTU_URL,
                        DATACAP_SCRIPT_URL: data?.DATACAP_SCRIPT_URL,
                        DATACAP_TOKEN: data?.DATACAP_TOKEN,
                    }
                    localStorage.setItem('dcap', JSON.stringify(dcap))
                    setStateList(res?.data?.states)

                    // rate band start 
                    if (finalPayload?.fetchByRate) {
                        const rateDataFectched = { ...faciltyData, ...res?.data }
                        setFaciltyData(rateDataFectched)
                    } else {
                        setFaciltyData(res?.data)
                    }

                    // rate band end 
                    const geoState = res?.data?.facility?.geolocations?.state?.trim()
                    const filteredState = res?.data?.states?.filter((item) => (item?.state_code === geoState || item?.name === geoState) ? item : 0)

                    setValue('state', getValues('state') ? getValues('state') : filteredState[0]?.id ? filteredState[0]?.id : getValues('state'))


                    // let local_ticket = JSON.parse(localStorage.getItem('local_ticket'))
                    let local_ticket = localTicketRef?.current ? localTicketRef?.current : localTicket
                    // FETCH RATE BANDS API DETAILS
                    const license_plate = (loggedInUserData()?.user?.id) ? currentSelVehicle?.license_plate_number : getValues('license_plate')
                    const phone = phoneRef?.current ? phoneRef?.current : getValues('phone')
                    const payload = {
                        facility_id: res?.data?.facility?.id,
                        user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
                        license_plate: license_plate?.trim(),
                        phone: phone
                    }
                    if (faciltyData?.promo_category_id && faciltyData?.promo_category_id != '') {
                        payload.promo_category_id = faciltyData?.promo_category_id
                    }
                    if (selectedPastDate) {
                        payload.start_date = selectedPastDate
                    }
                    const aboveResponse = res?.data
                    dispatch(fetchRateBands(payload)).then((res) => {
                        setOversizeLoader(false)
                        if (res?.data) {
                            if (aboveResponse?.facility?.facility_configuration?.enable_facility_close == '1') {
                                if (res?.data?.ongoing_events?.length === 0 && res?.data?.price_band?.length === 0) {
                                    setBandMsge(res?.data?.error_msg ? res?.data?.error_msg : '')
                                } else {
                                    setBandMsge('')
                                }
                            }
                            let responsData = JSON.stringify(res?.data)
                            // SET Events if exists
                            if (res?.data?.ongoing_events?.length > 0) {
                                setEvents(res.data.ongoing_events)
                                if (res?.data?.ongoing_events?.length > 1) {
                                    setEventMessage('')
                                }
                            } else {
                                setEvents(EMPTY_ARRAY)
                                setEventMessage('')
                            }
                            if (data?.facility?.is_price_band == '1') {
                                // SET RATE BAND TRUE
                                setIsDisplayRateBand(true)
                                if (local_ticket?.is_checkin == '0' && local_ticket?.is_checkout == '0' && !isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Display Desired Start Date - Ungated')) {
                                    // setIsRateBandSelected(false)
                                    const currentTime = new Date(getConvertedDate(moment(new Date()).tz(local_ticket?.facility?.timezone ? local_ticket?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
                                    const checkinTime = new Date(getConvertedDate(moment(new Date(local_ticket?.checkin_time)).format('YYYY-MM-DD HH:mm:ss')))
                                    const totalHours = moment(currentTime).diff(checkinTime, 'minutes')
                                    const timeRemain = TimeConversionInHours(totalHours)
                                    let correctRates = JSON.parse(responsData).price_band.filter((item) => {
                                        if (Number(item.max_stay) > Number(timeRemain)) {
                                            return true
                                        }
                                        return false
                                    })
                                    if (!correctRates?.length) {
                                        correctRates = res?.data?.price_band
                                    }
                                    setRateBandData(correctRates)
                                    const rateBandsForSelection = correctRates.map((item) => item?.rate_band_description)
                                    const priceForRateBrands = correctRates.map((item) => item?.price)
                                    // const defaultRateBand = [
                                    //     'Select Rate Band'
                                    // ]
                                    const rateBandsRef = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                                    setRateBands(rateBandsRef)
                                    setIsReloadRates({ ...isReloadRates, check: true })
                                } else {
                                    // SET RATE BANDS DATA
                                    if (ticketDetails && ticketDetails?.is_checkin != '0' && ticketDetails?.is_checkout != '0') {
                                        setRateBandData(res?.data?.price_band)
                                        const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                                        const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                                        // const defaultRateBand = [
                                        //     'Select Rate Band'
                                        // ]
                                        const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                                        setRateBands(rateBands)
                                    }
                                }
                            }
                        } else {
                            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            let errObject = {
                                payload: payload,
                                error: res,
                                errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-1887`))
                            if (!isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Allow Entry for Valid Pass Holders') && faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                                setBandMsge(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                        }
                    }).catch((err) => {
                        setOversizeLoader(false)
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        if (!isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Allow Entry for Valid Pass Holders') && faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                            setBandMsge(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                        let errObject = {
                            payload: payload,
                            error: err,
                            errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-1887`))
                    })

                    if (loggedInUserData()?.access_token) {
                        const payload = {
                            facility_id: res?.data?.facility?.id,
                            user_id: loggedInUserData()?.user?.id
                        }
                        setIsCheckingActiveSession(true)
                        dispatch(checkActiveSession(payload)).then((res) => {
                            if ((res?.data?.checkin_details?.is_expired == '0' && !res?.data?.checkin_details?.is_expired)) {
                                let paymentData = res?.data?.checkin_details
                                if (res?.data?.checkin_details?.discount_amount && res?.data?.checkin_details?.discount_amount != '') {
                                    localStorage.setItem('isCouponApplied', true)
                                }

                                delete res?.data?.checkin_details
                                const facility = res?.data
                                const finalPaymentData = { ...paymentData, facility: facility }
                                localStorage.removeItem('paymentRecipt')
                                localStorage.setItem('paymentRecipt', JSON.stringify(finalPaymentData))
                                if (finalPaymentData?.ticket_number && finalPaymentData?.ticket_number != '') {
                                    navigate(`/${partner}${URL?.CONFIRMATION}/${finalPaymentData?.ticket_number}`)
                                }
                                setIsCheckingActiveSession(false)
                            } else {
                                setIsTokenApiStart(false)
                                setIsCheckingActiveSession(false)
                            }
                        }).catch((err) => {
                            setIsTokenApiStart(false)
                            setIsCheckingActiveSession(false)
                            let errObject = {
                                payload: payload,
                                error: err,
                                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} checkActiveSession-TransientForm.js-1958`))
                            // notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        })
                    } else {
                        setIsCheckingActiveSession(false)
                        setIsTokenApiStart(false)
                    }

                    if (finalPayload?.checkoutWithTime) {
                        const currentTime = new Date(getConvertedDate(moment(new Date(res?.data?.current_time)).format('YYYY-MM-DD HH:mm:ss')))
                        const checkoutTime = new Date(getConvertedDate(moment(new Date(res?.data?.checkout_time)).format('YYYY-MM-DD HH:mm:ss')))
                        const totalHours = moment(checkoutTime).diff(currentTime, 'minutes')
                        const timeRemain = TimeConversionInHours(totalHours)
                        setTotalHoursLength(timeRemain)
                    }
                }
            } else {
                setFaciltyData(null)
                setIsCheckingActiveSession(false)
                setIsTokenApiStart(false)
                setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                if (res?.errors?.message == 'Garage is currently closed.') {
                    setAvalablityAlertIsOpen(true)
                    setAvalablityMessage(res?.errors?.message)
                } else if (res?.errors?.message == 'The Facility is not operational at this moment.') {
                    setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsCheckingActiveSession(false)
                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                }
                let errObject = {
                    payload: fetchPayload,
                    error: res,
                    errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getFaciltyData-TransientForm.js-1831`))
            }
        }).catch((err) => {
            setFaciltyData(null)
            setIsCheckingActiveSession(false)
            setIsTokenApiStart(false)
            setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            if (err?.errors?.message == 'Garage is currently closed.') {
                setAvalablityAlertIsOpen(true)
                setAvalablityMessage(err?.errors?.message)
            } else if (err?.errors?.message == 'The Facility is not operational at this moment.') {
                setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                setIsCheckingActiveSession(false)
            } else {
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            }
            let errObject = {
                payload: fetchPayload,
                error: err,
                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getFaciltyData-TransientForm.js-1831`))
        })
    }

    const handleScroll = () => {
        if (targetRef.current) {
            targetRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const handleBlur = async (e, removeErr = false) => {
        const { name } = e.target
        // Trigger validation on blur for the phone input field
        const isValid = await trigger(name)
        if (removeErr) {
            setError(name, {
                type: 'manual',
                message: '',
            })
        }
        if (!isValid) {
            if (name == 'phone') {
                setError(name, {
                    type: 'manual',
                    message: 'Please enter a valid phone number',
                })
            } else if (name == 'license_plate') {
                setError(name, {
                    type: 'manual',
                    message: 'Please enter a valid license plate',
                })
            }
        }
    }

    const handlePostSubmission = (data) => {
        const formData = (data && (Object.values(data)?.length > 0)) ? data : getValues()
        formData.phone = data.phone ? data.phone : phoneRef?.current
        let paymentData = formData
        if (faciltyData?.facility?.facility_payment_details?.facility_payment_type_id == '3' && !(formData?.paymentMethod == 'GPAY' || formData?.paymentMethod == 'APL'))
            paymentData = { ...formData, card_number: cardToken.token, expiry: formatExpiryDate(cardToken.expiry), cvv: '' }
        else paymentData = formData
        const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
        const minHours = facilityLocData?.minmum_length ? parseFloat(facilityLocData?.minmum_length) : 0
        const length_of_stay = seletedRateBand?.[0]?.id ? seletedRateBand?.[0]?.max_stay : totalHoursLength
        if ((totalHoursLength == '0' || totalHoursLength == '0:00' || totalHoursLength == '0.00')) {
            setIsSubmittingForm(false)
            notify('error', timeValidationConversion(updatedFacilityDate))
            setIsTokenApiStart(false)
        } else if (isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Display Desired Start Date - Ungated') && !selectedPastDate) {
            notify('error', errorMessage?.errorInStartDate)
        } else if (facilityLocData?.minmum_length && (minHours > parseFloat(length_of_stay))) {
            let timeToShow = getFormattedTime(facilityLocData?.minmum_length)
            setIsSubmittingForm(false)
            notify('error', 'Please select minimum duration ' + timeToShow + ' hours')
            setIsTokenApiStart(false)
        } else {
            setIsSubmittingForm(true)
            setVerifyDetails(false)
            if (paymentData?.paymentMethod == 'GPAY' || paymentData?.paymentMethod == 'APL') {
                finalPaymentToBackend('', paymentData, 'post')
            } else {
                if (paymentData?.card_number && paymentData?.expiry) {
                    const card = {
                        name_on_card: paymentData?.name_on_card,
                        card_number: paymentData?.card_number,
                        expiration_date: paymentData?.expiry,
                        security_code: paymentData?.cvv,
                        zip_code: paymentData?.zip_code
                    }
                    const nonce = encryptionHandler(card)
                    finalPaymentToBackend(nonce, paymentData, 'post')
                } else {
                    finalPaymentToBackend(0, paymentData, 'post')
                }
            }
        }

    }

    const resetBandDurations = () => {
        setTimeDuration(() => {
            return { days: '0', hours: '0', minutes: '0' }
        })
        setSelectedEv(() => {
            return null
        })
        setTotalHoursLength(() => {
            return '0.00'
        })
        setSeletedRateBand(() => {
            return ''
        })
    }


    const fetchBands = (payload, from_pass = false, changeRef = 0) => {
        let local_ticket = localTicketRef?.current ? localTicketRef?.current : {}
        dispatch(fetchRateBands(payload)).then((res) => {
            setOversizeLoader(false)
            if (handleChangeReq.current == changeRef) {
                setCustomeLoaderForRateBand(false)
                if (res?.data) {
                    bandRef.current = res?.data?.price_band
                    if (faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                        if (res?.data?.ongoing_events?.length === 0 && res?.data?.price_band?.length === 0) {
                            setBandMsge(res?.data?.error_msg ? res?.data?.error_msg : '')
                        } else {
                            setBandMsge('')
                        }
                    }
                    if (from_pass && isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Allow Entry for Valid Pass Holders')) {
                        const obj = {
                            ...checkInData,
                            'license_plate': res?.data?.pass?.license_plate,
                            'phone': res?.data?.pass?.phone,
                            'disabled': true,
                            'pass_id': res?.data?.pass?.id
                        }
                        if (res?.data?.pass?.pass_code) {
                            obj.pass_code = res?.data?.pass?.pass_code
                        } else if (res?.data?.pass?.permit_code) {
                            obj.permit_code = res?.data?.pass?.permit_code
                        }
                        setCheckInData(obj)
                        setValue('license_plate', res?.data?.pass?.license_plate)
                        setValue('phone', res?.data?.pass?.phone)
                    }
                    let responsData = JSON.stringify(res?.data)
                    // SET Events if exists
                    if (res?.data?.ongoing_events?.length > 0) {
                        setEvents(res?.data?.ongoing_events)
                        if (res?.data?.ongoing_events?.length > 1) {
                            setEventMessage('')
                        }
                    } else {
                        setEvents(EMPTY_ARRAY)
                        setEventMessage('')
                    }

                    // SET RATE BAND TRUE
                    setIsDisplayRateBand(true)
                    if (local_ticket?.is_checkin == '0' && local_ticket?.is_checkout == '0' && !isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Display Desired Start Date - Ungated')) {
                        // setIsRateBandSelected(false)
                        const currentTime = new Date(getConvertedDate(moment(new Date()).tz(local_ticket?.facility?.timezone ? local_ticket?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
                        const checkinTime = new Date(getConvertedDate(moment(new Date(local_ticket?.checkin_time)).format('YYYY-MM-DD HH:mm:ss')))
                        const totalHours = moment(currentTime).diff(checkinTime, 'minutes')
                        const timeRemain = TimeConversionInHours(totalHours)
                        let correctRates = JSON.parse(responsData).price_band.filter((item) => {
                            if (Number(item.max_stay) > Number(timeRemain)) {
                                return true
                            }
                            return false
                        })
                        if (!correctRates?.length) {
                            correctRates = res?.data?.price_band
                        }
                        setRateBandData(correctRates)
                        const rateBandsForSelection = correctRates.map((item) => item?.rate_band_description)
                        const priceForRateBrands = correctRates.map((item) => item?.price)
                        // const defaultRateBand = [
                        //     'Select Rate Band'
                        // ]
                        const rateBandsRef = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                        setRateBands(rateBandsRef)
                        setIsReloadRates({ ...isReloadRates, check: true })
                    } else {
                        // SET RATE BANDS DATA
                        setRateBandData(res?.data?.price_band)
                        const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                        const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                        // const defaultRateBand = [
                        //     'Select Rate Band'
                        // ]
                        const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                        setRateBands(rateBands)
                    }

                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    if (!isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Allow Entry for Valid Pass Holders') && faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                        setBandMsge(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                    let errObject = {
                        payload: payload,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-462`))
                }
            }
        }).catch((err) => {
            setOversizeLoader(false)
            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            if (!isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Allow Entry for Valid Pass Holders') && faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') {
                setBandMsge(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            }
            setCustomeLoaderForRateBand(false)
            let errObject = {
                payload: payload,
                error: err,
                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-TransientForm.js-462`))
        })
    }


    const handlePassCheck = () => {
        if (!passEntryCheck?.type) {
            notify('error', 'Please choose a detail.')
        } else if (passEntryCheck?.type != '2' && !errors?.pass_code && !passEntryCheck?.pass_code) {
            setError('pass_code', {
                type: 'manual',
                message: 'This field is required',
            })
        } else if ((passEntryCheck?.type == '2' && !errors?.pass_code_phone && !passEntryCheck?.pass_code_phone)) {
            setError('pass_code_phone', {
                type: 'manual',
                message: 'This field is required',
            })
        } else if ((passEntryCheck?.type != '2' && errors?.pass_code) || (passEntryCheck?.type == '2' && errors?.pass_code_phone)) {
            return false
        } else {
            const payload = {
                facility_id: faciltyData?.facility?.id,
                'user_id': '',
                'type': passEntryCheck?.type,
                'pass_code': passEntryCheck?.type == '2' ? passEntryCheck?.pass_code_phone : passEntryCheck?.pass_code
            }
            if (passEntryCheck?.type == '3') {
                payload.permit_code = passEntryCheck?.pass_code
                delete payload.pass_code
            }
            fetchBands(payload, true, handleChangeReq.current)
        }
    }
    const handlePassRadio = (e) => {
        const { name, value } = e.target
        if (name == 'passRadio') {
            if (passEntryCheck?.type == null) {
                setPassEntryCheck({
                    ...passEntryCheck,
                    type: value
                })
            } else {
                setPassEntryCheck({
                    ...passEntryCheck,
                    type: value,
                    pass_code: '',
                    pass_code_phone: ''
                })
            }
        }
    }
    const handleEntryPass = (e) => {
        const { name, value } = e.target
        if (name == 'pass_code') {
            setPassEntryCheck({
                ...passEntryCheck,
                pass_code: value.trim()
            })
        } else if (name == 'pass_code_phone') {
            setPassEntryCheck({
                ...passEntryCheck,
                pass_code_phone: value.trim(),
            })
        }
    }

    const handleGarageInventory = (markerPayload) => {
        if (Number(markerPayload?.warning_on_reservation) === 1 && markerPayload?.facility_hours_of_operation?.length > 0) {
            setWarningPark(!warningMessageSchdule)
            setWarningMessage(markerPayload?.warning_on_reservation_msg)
            setHoursOfOper(markerPayload?.facility_hours_of_operation)
            const selData = markerPayload?.facility_hours_of_operation?.filter((item) => item?.formatted_close_time == '12:00 am (midnight next day)')
            setShowMidnightNote(selData.length > 0 ? true : false)
            setIsSubmittingForm(false)
            setAvalablityAlertIsOpen(false)
        } else if ((Number(markerPayload?.availability) === 0 && markerPayload?.availability_msg !== '')) {
            setAvalablityAlertIsOpen(true)
            // setAvalablityAlertIsOpen(!avalablityAlert)
            setAvalablityMessage(markerPayload?.availability_msg)
            setIsSubmittingForm(false)
        } else if (markerPayload?.Error) {
            setAvalablityAlertIsOpen(false)
            setIsSubmittingForm(false)
            notify('error', markerPayload ? markerPayload?.Errors?.[0] : errorMessage?.somethingWentWrong)
            let errObject = {
                payload: markerPayload,
                error: markerPayload,
                errorMessage: markerPayload?.errors?.message ? markerPayload?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} faciltyOnMarker-TransientForm.js-955`))
        } else {
            //    Do Nothing
        }
    }

    const resetFormRates = () => {
        let localFacData = faciltyData
        localFacData.payable_amount = 0
        localFacData.is_price_applicable = '0'
        localFacData.parking_amount = 0
        localFacData.processing_fee = 0
        localFacData.tax_rate = 0
        localFacData.tax_fee = 0
        localFacData.base_amount = 0
        localFacData.discount_amount = 0
        localFacData.discount_hours = 0
        localFacData.main_ticket = null
        localFacData.new_price = 0
        localFacData.default_length = '0.00'

        if (faciltyData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1') {
            localFacData.surcharge_fee = 0
        }
        setFaciltyData(localFacData)
        setAvalablityAlertIsOpen(false)
        setWarningPark(false)
        setResetDuration(resetDuration + 1)
        setTotalHoursLength('0.00')
        setTimeDuration({ days: '0', hours: '0', minutes: '0' })
        setselctedDateTime({
            active: false,
            price: null,
            daysHrs: null,
            dateUntill: null,
            bandActive: false
        })
    }

    const handleChangeFastTrackCard = () => {
        // setIsFastTrackCard(false)
        setIsFastTrackCard(!isFastTrackCard)
    }




    return (
        isFetchingPartner ? null :
            <div className={'Pave main'}>
                <MiniHeader title={'PARKING DETAILS'} loginData={loginData} partnerdetails={partnerdetails} />
                {(isValidPartner) ? isWelcomePopup == '1' ? <Modal isOpen={true} backdrop="static" keyboard={false} centered>
                    <ModalHeader className="justify-content-center border-0 pb-0" toggle={null}>
                        <div className="d-flex justify-content-center w-100">
                            <img
                                src={
                                    partnerdetails?.brand_setting?.logo && partnerdetails?.brand_setting?.logourl
                                        ? partnerdetails.brand_setting.logourl
                                        : 'https://engageos.parkengage.com/assets/logos-l6iB66-K.svg'
                                }
                                alt="Partner Logo"
                                style={{ maxHeight: 48, maxWidth: 112, objectFit: 'contain' }}
                            />
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <div className="text-center">
                            <h5 className="fw-bold mb-2">Welcome!</h5>
                            <p className="mb-3" style={{ whiteSpace: 'pre-line' }}>
                                {faciltyData?.facility?.facility_configuration?.welcome_popup_msg
                                    || `Welcome to ${faciltyData?.facility?.short_name} !`}
                            </p>
                        </div>
                        <div className="text-center">
                            <button
                                type="button"
                                className='btn text-primary w-100 border-primary'
                                onClick={() => custDispatch({ type: CONSTANTS.IS_WELCOME_POPUP, data: '2' })}
                            >
                                OK
                            </button>
                        </div>
                    </ModalBody>
                </Modal> :
                    ((loader && totalHoursLength == '0.00' && !(getValues()?.promo != '' || getValues()?.promo != 'undefined' || getValues()?.promo != undefined)) || (isCheckingActiveSession && totalHoursLength == '0.00')) ?
                        <div className='d-flex align-items-center justify-content-center'><Loader /></div> :
                        (faciltyData && faciltyData?.facility?.full_name && (faciltyData?.facility?.owner_id == partnerdetails?.id)) ?
                            <div>

                                {((isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Main Menu'), 'Permit Purchase') && (!faciltyData?.facility?.facility_configuration || faciltyData?.facility?.facility_configuration?.is_pemit_qrcode == 1))
                                    || isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Third Party Reservation') && (!faciltyData?.facility?.facility_configuration || faciltyData?.facility?.facility_configuration?.display_third_party_reservation == 1)
                                    || isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Display Reservation Button - Transient') && (!faciltyData?.facility?.facility_configuration || faciltyData?.facility?.facility_configuration?.display_reservation_button_transient == 1)) ? <div className="p-3 text-center">
                                    <div className='d-flex gap-3 mb-2'>
                                        {(isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Main Menu'), 'Permit Purchase') && (!faciltyData?.facility?.facility_configuration || faciltyData?.facility?.facility_configuration?.is_pemit_qrcode == 1)) ? <button
                                            className="btn bg-primary text-white w-100"
                                            onClick={() => handlePermitReservation('permit')}
                                        >
                                            Purchase Monthly Permit
                                        </button> : null}
                                        {(isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Third Party Reservation') && (!faciltyData?.facility?.facility_configuration || faciltyData?.facility?.facility_configuration?.display_third_party_reservation == 1)) ? <button
                                            className="btn bg-primary text-white w-100"
                                            onClick={() => setResetModalOpen(true)}
                                        >
                                            Reservations
                                        </button> : (isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Display Reservation Button - Transient') && (!faciltyData?.facility?.facility_configuration || faciltyData?.facility?.facility_configuration?.display_reservation_button_transient == 1)) ? <button
                                            className="btn bg-primary text-white w-100"
                                            onClick={() => handlePermitReservation('reservation')}
                                        >
                                            Reservations
                                        </button> : null}
                                    </div>
                                    <h3>OR</h3>
                                    <p className="text-primary mb-2">Check-in Using Below</p>
                                    <i className="fa fa-chevron-circle-down text-muted fa-2x" aria-hidden="true"></i>
                                </div> : null}
                                <Modal isOpen={isResetModalOpen} toggle={toggle}>
                                    <ModalHeader toggle={toggle}>Enter Reservation ID</ModalHeader>
                                    <ModalBody>
                                        <ReservationWithID toggle={toggle} setFaciltyData={setFaciltyData} faciltyData={faciltyData} setTotalHoursLength={setTotalHoursLength} setReservationData={setReservationData} reservationData={reservationData} notify={notify} />
                                    </ModalBody>
                                    {/* <ModalFooter>
                                        <Button className='modalButton' color="secondary" onClick={toggle}> Cancel </Button>
                                    </ModalFooter> */}
                                </Modal>

                                <UpperHeader faciltyData={faciltyData} totalHoursLength={totalHoursLength?.toString()} key='main' reservationData={reservationData} partnerDetails={partnerDetails} screen="home" />
                                {faciltyData?.facility?.facility_configuration?.enable_facility_close != '1' ? <Container>
                                    <div className='mt-4'>
                                        {(loginData?.access_token) ?
                                            <>
                                                <span className='VehilceLables d-flex justify-content-between align-items-start cursor'>Vehicle Details {!isVehicleLimitExceeded(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), vehicleDataList, partnerdetails?.max_vehicle) ? <span onClick={handleAddVehilce}><i className='fa fa-plus small'></i> Add New Vehicle</span> : null}</span>
                                                <ListGroup className='cursor' as="ol" onClick={() => handleCommonListModal('Vehicle')}>
                                                    <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                                                        {/* <Image src={carImage} /> */}
                                                        <span style={{ height: '23px', width: '23px' }}>{getSvgIcon('Car', 'var(--bs-primary)')}</span>
                                                        <div className="ms-2 me-auto listVehicleGroupItem">{currentSelVehicle?.license_plate_number}</div>
                                                        <i className='fa fa-caret-down mt-1' style={{ fontSize: '13px' }}></i>
                                                    </ListGroup.Item>
                                                </ListGroup>

                                                {/* <Controller
                                                name='vehicle_id'
                                                id='vehicle_id'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field }) => <Form.Select aria-label="Default select example" {...field}>
                                                    <option value=''>Please Select</option>
                                                    {vehicleDataList?.map((item, index) => <option key={index} value={item?.id}>{item?.model}</option>)}
                                                </Form.Select>}
                                            />
                                            {errors?.vehicle_id?.type === 'required' && <Form.Text className="text-danger">This field is required</Form.Text>} */}
                                            </>
                                            : (events?.length === 0 && rateBands?.rateBands?.length === 0 && bandMsge) ? '' : <>
                                                {isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Enable Name Fields - Transient') ? <Row className="mb-2">
                                                    <Col className='col-6'>
                                                        <Form.Group>
                                                            <Form.Label className='text-primary styleLables'>Guest Name {durationSelector == 1 ? <span className='text-danger'>*</span> : ''}</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                id='first_name'
                                                                placeholder="First Name"
                                                                name='first_name'
                                                                // maxLength='10'
                                                                // autoCapitalize="characters"
                                                                // defaultValue={'123'}
                                                                {...register('first_name', {
                                                                    required: { value: durationSelector == 1 ? true : false, message: 'This field is required' },
                                                                    onChange: (e) => handleChange(e),
                                                                    onBlur: (e) => handleBlur(e)
                                                                })}
                                                            />
                                                        </Form.Group>
                                                        {errors?.first_name && <Form.Text className="text-danger header-s">{errors?.first_name?.message}</Form.Text>}
                                                    </Col>
                                                    <Col className='col-6'>
                                                        <Form.Group>
                                                            <Form.Label className='text-primary styleLables'>&nbsp;</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                id='last_name'
                                                                placeholder="Last Name"
                                                                name='last_name'
                                                                // maxLength='10'
                                                                // autoCapitalize="characters"
                                                                // defaultValue={'123'}
                                                                {...register('last_name', {
                                                                    required: { value: durationSelector == 1 ? true : false, message: 'This field is required' },
                                                                    onChange: (e) => handleChange(e),
                                                                    onBlur: (e) => handleBlur(e)
                                                                })}
                                                            />
                                                        </Form.Group>
                                                        {errors?.last_name && <Form.Text className="text-danger header-s">{errors?.last_name?.message}</Form.Text>}
                                                    </Col>
                                                </Row> : ''}
                                                <Row>
                                                    <Col className='col-6'>
                                                        <Form.Group>
                                                            <Form.Label className='text-primary  styleLables'>Mobile Number {(reservationData.reservationID === null) && <span className='text-danger'>*</span>}</Form.Label>
                                                            <InputGroup className='form-control p-0'>
                                                                <InputGroup.Text className='small'>(+1)</InputGroup.Text>
                                                                <Controller
                                                                    name="phone"
                                                                    type="text"
                                                                    id="phone"
                                                                    control={control}
                                                                    defaultValue=''
                                                                    inputmode="numeric"
                                                                    ref={(e) => { ref(e) }}
                                                                    value={checkInData?.phone}
                                                                    disabled={(isSubmittingForm || checkInData?.disabled) ? true : false}
                                                                    rules={{
                                                                        required: !isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Enable Email Fields - Transient')
                                                                            ? 'This field is required'
                                                                            : false,
                                                                        minLength: { value: 10, message: 'Please enter a valid mobile number' },
                                                                        maxLength: { value: 10, message: 'Please enter a valid mobile number' },
                                                                    }}
                                                                    render={({ field }) => <MaskedInput
                                                                        maskGenerator={phoneMaskGenerator}
                                                                        className="border-0"
                                                                        {...field}
                                                                        id="phone"
                                                                        inputMode="numeric"
                                                                        maxLength={14}
                                                                        onChange={(e) => { field.onChange(e); handleChange(getFieldValue('phone', e)) }}
                                                                        onBlur={(e) => handleBlur(e)}
                                                                        title="Please enter a valid phone number"
                                                                        onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                                                        onInput={e => e.target.setCustomValidity('')}
                                                                        placeholder="(123)-555-1234"
                                                                        disabled={(isSubmittingForm || checkInData?.disabled) ? true : false}
                                                                    />
                                                                    }
                                                                />
                                                            </InputGroup>
                                                        </Form.Group>
                                                        {(errors?.phone || phoneEmailError) && <Form.Text className="text-danger header-s">{errors?.phone?.message || 'This field is required'}</Form.Text>}
                                                    </Col>
                                                    {partner === 'parkingpayments' && <Col>
                                                        <Form.Group>
                                                            <Form.Label className='text-primary  styleLables'>License Plate No.P <span className='text-danger'>*</span></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                id='license_plate'
                                                                placeholder="License Plate No."
                                                                name='license_plate'
                                                                maxLength='10'
                                                                value={checkInData?.license_plate}
                                                                disabled={checkInData?.disabled ? true : false}
                                                                autoCapitalize="characters"
                                                                // defaultValue={'123'}
                                                                {...register('license_plate', {
                                                                    required: { value: true, message: 'This field is required' },
                                                                    minLength: { value: 2, message: 'Minimum 2 characters allowed' },
                                                                    maxLength: { value: 10, message: 'Maximum 10 characters allowed' },
                                                                    pattern: {
                                                                        value: /^[A-Za-z0-9]+$/,
                                                                        message: 'Only letters and numbers allowed',
                                                                    },
                                                                    onBlur: (e) => handleBlur(e),
                                                                    onChange: (e) => handleChange(e)
                                                                })}
                                                            />
                                                        </Form.Group>
                                                        {errors?.license_plate && <Form.Text className="text-danger header-s">{errors?.license_plate?.message}</Form.Text>}
                                                    </Col>}

                                                    {/* {!ticketDetails?.ticket_number && <Col> */}
                                                    {/* {partner !== 'parkingpayments' && <Col> */}
                                                    {<Col className='col-6 d-none'>
                                                        <Form.Group>
                                                            <Form.Label className='text-primary  styleLables'>State</Form.Label>
                                                            <Controller
                                                                name='state'
                                                                id='state'
                                                                control={control}
                                                                // rules={{required: { value: true, message: 'This field is required' }}}
                                                                render={({ field }) => <Form.Select className="form-select selectPalceholdr" name='no_of_days' defaultValue={field.value} {...field}>
                                                                    <option>Please Select</option>
                                                                    {stateList?.map((item, itemIndex) => <option key={itemIndex} value={item?.id}>{item?.state_code}</option>)}
                                                                </Form.Select>}
                                                            />
                                                        </Form.Group>
                                                        {/* {errors?.state && <Form.Text className="text-danger">{errors?.state?.message}</Form.Text>} */}
                                                    </Col>}
                                                    {partner == 'demo-parkengage' && <Col>
                                                        <Form.Group>
                                                            <Form.Label className='text-primary  styleLables'>Zone</Form.Label>
                                                            <Controller
                                                                name='zone'
                                                                id='zone'
                                                                control={control}
                                                                // rules={{required: { value: true, message: 'This field is required' }}}
                                                                render={({ field }) => <Form.Select className="form-select selectPalceholdr" name='no_of_days' defaultValue={field.value} {...field}>
                                                                    {zoneList?.map((item, itemIndex) => <option key={itemIndex} value={item?.val}>{item?.name}</option>)}
                                                                </Form.Select>}
                                                            />
                                                        </Form.Group>
                                                        {/* {errors?.state && <Form.Text className="text-danger">{errors?.state?.message}</Form.Text>} */}
                                                    </Col>}
                                                    {/* </Row>
                                            {partner !== 'parkingpayments' && <Row className='row-cols-2  row-cols-sm-3 row-cols-md-3'> */}
                                                    {partner !== 'parkingpayments' ? <Col className="col-6" >
                                                        <Form.Group>
                                                            <Form.Label className='text-primary  styleLables'>License Plate No. <span className='text-danger'>*</span></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                id='license_plate'
                                                                placeholder="License Plate No."
                                                                name='license_plate'
                                                                autoCapitalize="characters"
                                                                maxLength='10'
                                                                value={checkInData?.license_plate}
                                                                disabled={checkInData?.disabled ? true : false}
                                                                {...register('license_plate', {
                                                                    required: { value: true, message: 'This field is required' },
                                                                    minLength: { value: 2, message: 'Minimum 2 characters allowed' },
                                                                    maxLength: { value: 10, message: 'Maximum 10 characters allowed' },
                                                                    onBlur: (e) => handleBlur(e),
                                                                    onChange: (e) => handleChange(e)
                                                                })}
                                                            />
                                                        </Form.Group>
                                                        {errors?.license_plate && <Form.Text className="text-danger header-s">{errors?.license_plate?.message}</Form.Text>}
                                                    </Col> : null}
                                                    <span className='header-s text-danger'>Supports US Numbers Only</span>
                                                    {isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Enable Email Fields - Transient') ? <Col className='col-12'>
                                                        <Form.Group>
                                                            <Form.Label className='text-primary  styleLables'>Email Id {(reservationData?.reservationID === null) && <span className='text-danger'>*</span>}</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                id='email'
                                                                placeholder="Please Enter Your Email ID"
                                                                name='email'
                                                                {...register('email', {
                                                                    pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'Invalid email address' },
                                                                    onChange: (e) => handleChange(e)
                                                                })}
                                                            />
                                                        </Form.Group>
                                                        {(errors?.email || phoneEmailError) && <Form.Text className="text-danger header-s">{errors?.email?.message || 'Mobile number or email is required.'}</Form.Text>}
                                                    </Col> : null}
                                                    {isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Enable Email Fields - Transient') ? <span className='header-s text-danger'>**Mobile is preferred for real-time parking notifications.</span> : null}


                                                    <Col className='d-none'>
                                                        {/* <Form.Group>
                                                        <Form.Label className='text-primary  styleLables'>Color</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            id='color'
                                                            placeholder="Color"
                                                            name='color'
                                                            maxLength='10'
                                                            {...register('color', {
                                                                // required: { value: true, message: 'This field is required' },
                                                                // minLength: { value: 3, message: 'Minimum 3 characters allowed' },
                                                                // maxLength: { value: 15, message: 'Maximum 15 characters allowed' },
                                                                onBlur: (e) => handleActiveCheckInCheck(e),
                                                                onChange: (e) => handleChange(e)
                                                            })}
                                                        />
                                                    </Form.Group> */}
                                                        <Form.Group>
                                                            <Form.Label className='text-primary  styleLables'>Vehicle Make</Form.Label>
                                                            <Controller
                                                                name='make'
                                                                id='make'
                                                                control={control}
                                                                // rules={{required: { value: true, message: 'This field is required' }}}
                                                                render={({ field }) => <Form.Select className="form-select selectPalceholdr" name='make' {...field} onChange={(e) => { field.onChange(e); handleChange(e) }} defaultValue={field?.make}>
                                                                    <option>Please Select</option>
                                                                    {vehicleMakeList?.map((item, itemIndex) => <option key={itemIndex} value={item?.id}>{item?.name}</option>)}
                                                                </Form.Select>}
                                                            />
                                                        </Form.Group>
                                                        {/* {errors?.color && <Form.Text className="text-danger header-s">{errors?.color?.message}</Form.Text>} */}
                                                    </Col>
                                                    {othermake ? <Col className='d-none'>
                                                        <Form.Group>
                                                            <Form.Label className='text-primary  styleLables'>Make</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                id='maketext'
                                                                placeholder="Vehicle Make"
                                                                name='maketext'
                                                                maxLength='10'
                                                                {...register('maketext', {
                                                                    // required: { value: true, message: 'This field is required' },
                                                                    // minLength: { value: 3, message: 'Minimum 3 characters allowed' },
                                                                    // maxLength: { value: 15, message: 'Maximum 15 characters allowed' },
                                                                    // onBlur: (e) => handleActiveCheckInCheck(e),
                                                                    onChange: (e) => handleChange(e)
                                                                })}
                                                            />
                                                        </Form.Group>
                                                    </Col> : ''}
                                                    {!othermake ? <Col className='d-none'>
                                                        <Form.Group>
                                                            <Form.Label className='text-primary  styleLables'>Vehicle Model</Form.Label>
                                                            <Controller
                                                                name='model'
                                                                id='model'
                                                                control={control}
                                                                // rules={{required: { value: true, message: 'This field is required' }}}
                                                                render={({ field }) => <Form.Select className="form-select selectPalceholdr"  {...field} onChange={(e) => handleChange(e)} name='model' defaultValue={field.model}>
                                                                    <option>Please Select</option>
                                                                    {(vehicleModelList?.length > 0) && vehicleModelList?.map((item, itemIndex) => <option key={itemIndex} value={item?.name}>{item?.name}</option>)}
                                                                </Form.Select>}
                                                            />
                                                        </Form.Group>

                                                        {/* {errors?.make && <Form.Text className="text-danger header-s">{errors?.make?.message}</Form.Text>} */}
                                                    </Col> : ''}
                                                    {(othermake || othermodel) ? <Col className='d-none'>
                                                        <Form.Group>
                                                            <Form.Label className='text-primary  styleLables'>Model</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                id='modeltext'
                                                                placeholder="Vehicle Model"
                                                                name='modeltext'
                                                                maxLength='10'
                                                                {...register('modeltext', {
                                                                    // required: { value: true, message: 'This field is required' },
                                                                    // minLength: { value: 3, message: 'Minimum 3 characters allowed' },
                                                                    // maxLength: { value: 15, message: 'Maximum 15 characters allowed' },
                                                                    // onBlur: (e) => handleActiveCheckInCheck(e),
                                                                    onChange: (e) => handleChange(e)
                                                                })}
                                                            />
                                                        </Form.Group>
                                                    </Col> : ''}
                                                    <Col className='d-none'>
                                                        <Form.Group>
                                                            <Form.Label className='text-primary  styleLables'>Color</Form.Label>
                                                            <Controller
                                                                name='color'
                                                                id='color'
                                                                control={control}
                                                                // rules={{required: { value: true, message: 'This field is required' }}}
                                                                render={({ field }) => <Form.Select className="form-select selectPalceholdr" onChange={(e) => handleChange(e)} name='color' defaultValue={field.color} {...field}>
                                                                    <option>Please Select</option>
                                                                    {(vehicleDetailsList?.color?.length > 0) && vehicleDetailsList?.color?.map((item, itemIndex) => <option key={itemIndex} value={item?.id}>{item?.name}</option>)}
                                                                </Form.Select>}
                                                            />
                                                        </Form.Group>
                                                        {/* {errors?.model && <Form.Text className="text-danger header-s">{errors?.model?.message}</Form.Text>} */}
                                                    </Col>
                                                </Row>
                                            </>
                                        }
                                        {/* for the custome Calender */}
                                        {(isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Display Desired Start Date - Ungated') && !bandMsge) ?
                                            <Col className='col-12'>
                                                <div className='p-0 m-0 d-flex justify-content-center align-items-center row'>
                                                    <div className={'border border-2 rounded m-2 pb-2 pt-2'} onClick={handleDataSelect}>
                                                        <div className='pb-1 pt-1 d-flex justify-content-between align-items-center'>
                                                            <div className='lh-sm small'>{'Select Date/Time'}</div>
                                                            <span className='small'>{(selectedPastDate) ? <>{moment(selectedPastDate, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm A')}</> : '--'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='text-danger small lh-sm'>** If you wish to pay for your past session, please choose an earlier date.</div>
                                                <PastDatePicker
                                                    isPastCalenderOpenModal={pastCalenderOpen}
                                                    setPastCalenderOpenModal={setPastCalenderOpen}
                                                    setSelectedPastDate={setSelectedPastDate}
                                                    handlePastDateSelecter={(e) => handlePastDateSelecter(e)}
                                                    selectedPastDate={selectedPastDate}
                                                    isDateShow={false}
                                                    openDateCalendar={openDateCalendar}
                                                    selctedDateTime={selctedDateTime}
                                                    selectedPastDateRef={selectedPastDateRef}
                                                    partnerdetails={partnerdetails}
                                                    setselctedDateTime={setselctedDateTime}
                                                />
                                            </Col> : null}
                                        {isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Enable Fast-Track Checkin') && (faciltyData?.facility?.facility_configuration?.enable_fast_track == '1') ? <div
                                            className={`w-full my-2 rounded w-100 fast-track-animated-container ${checkInData?.is_fast_track_enabled == 1 || isFastTrackChecked ? 'fast-track-checked' : ''}`}
                                        >
                                            <Form.Group className="d-flex gap-2 form-check">
                                                <input
                                                    type="checkbox"
                                                    id='is_fast_track_enabled'
                                                    name='is_fast_track_enabled'
                                                    // {...register('is_fast_track_enabled', {
                                                    //     checked: isFastTrackChecked,
                                                    //     onChange: (e) => handleChange(e)
                                                    // }
                                                    // )}
                                                    // checked={checkInData?.is_fast_track_enabled == 1 || isFastTrackChecked}
                                                    checked={isFastTrackChecked}
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                    }}
                                                    disabled={(isSubmittingForm || (fetchRateLoader && durationSelector == 0))}
                                                    className='form-check-input'
                                                    style={{ width: '20px', height: '20px' }}
                                                />

                                                <Form.Label className='d-flex flex-column'>Fast Track
                                                    <small style={{ fontSize: '12px', fontWeight: '400' }} className='text-muted'>
                                                        {isFastTrackChecked
                                                            ? ' (If you want to opt-out, please uncheck the checkbox.)'
                                                            : ' (If you want to opt-in, please check the checkbox.)'}
                                                    </small>
                                                </Form.Label>
                                            </Form.Group>
                                        </div> : null}
                                    </div>
                                </Container> : null}



                                <Container>
                                    <div>
                                        {(((ticketDetails?.is_checkout == '0') || !ticketDetails?.ticket_number) && reservationData.reservationID === null) && <Row>
                                            <Col>

                                                {isDisplayRateBand ?
                                                    <>
                                                        <div className='mb-3 mt-3'>
                                                            {rateBands?.rateBands?.length > 0 && <>
                                                                {(!selctedDateTime?.bandActive && faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') ? <Form.Label className='text-primary mb-0 pb-0 styleLables'>Rate Band <span className='text-danger'>*</span></Form.Label> : ''}
                                                                {!bandMsge ? <ReactMobiltySpinner
                                                                    handleTimeLength={(e) => handleTimeLength(e)}
                                                                    isRateBand={true}
                                                                    currDays={Number(timeDuration?.days)}
                                                                    currHour={Number(timeDuration?.hours)}
                                                                    currMin={Number(timeDuration?.minutes)}
                                                                    rateBands={rateBands}
                                                                    isRateBandSelected={isRateBandSelected}
                                                                    setIsRateBandSelected={setIsRateBandSelected}
                                                                    setselctedDateTime={setselctedDateTime}
                                                                    selctedDateTime={selctedDateTime}
                                                                    setRateBandData={setRateBandData}
                                                                    rateBandData={rateBandData}
                                                                    events={events}
                                                                    setFacilityData={setFaciltyData}
                                                                    facilityData={faciltyData}
                                                                    setSelectedEv={setSelectedEv}
                                                                    setIndexForCalc={setIndexForCalc}
                                                                    indexForCalc={indexForCalc}
                                                                    setSeletedRateBand={setSeletedRateBand}
                                                                    setTotalHoursLength={setTotalHoursLength}
                                                                    totalHoursLength={totalHoursLength?.toString()}
                                                                    customeLoaderForRateBand={customeLoaderForRateBand}
                                                                    setCustomeLoaderForRateBand={setCustomeLoaderForRateBand}
                                                                    partnerdetails={partnerdetails}
                                                                    pageOnLoad={pageOnLoad}
                                                                    setIsRateChangedWithPromo={setIsRateChangedWithPromo}
                                                                    setIsPriceZero={setIsPriceZero}
                                                                    setResetPromo={setResetPromo}
                                                                    durationSelector={durationSelector}
                                                                    setDurationSelector={setDurationSelector}
                                                                    handleBlur={handleBlur}
                                                                    hotel_type={faciltyData?.facility?.facility_configuration?.is_facility_hotel_type}
                                                                    openDateCalendar={openDateCalendar}
                                                                    currentSelVehicle={currentSelVehicle}
                                                                    setEventMessage={setEventMessage}
                                                                    eventMessage={eventMessage}
                                                                    screen='home'
                                                                    priceBreakAPI={() => { }}
                                                                    // for the event and rate
                                                                    setIsRateOrEventShow={setIsRateOrEventShow}
                                                                    is_rate_or_event_show={is_rate_or_event_show}
                                                                    resetBand={resetBand}
                                                                    curRateBandRef={curRateBandRef}
                                                                    oversizeLoader={oversizeLoader}
                                                                    disableRates={disableRates}
                                                                    ticketDetails={EMPTY_OBJECT}
                                                                    dataOnLoad={EMPTY_OBJECT}
                                                                    page='home'
                                                                    setVerifyDetails={setVerifyDetails}
                                                                /> : null}
                                                                {(eventMessage && !priceBandLoad && faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') ? <div className='p-0'><p className='small'>You are checkin against event <span className='fw-bold'>{eventMessage}</span></p></div> : ''}


                                                                {(partner !== 'parkingpayments' && events.length == 0 && faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') && <>
                                                                    <div className={`${updatedFacilityDate?.is_custom_picker_enabled == '1' ? '' : 'mb-2 '}text-end d-flex align-items-center justify-content-end`}>
                                                                        {rateObj.loader && <><div><Loader color='grey' hideMargin size='16' /></div><span>&nbsp;</span></>}
                                                                        {updatedFacilityDate?.facility_configuration?.show_rate_detail == '1' ? <span className={`p-0 btn btn-link btn-sm mt-0${rateObj.loader ? ' disabled' : ''}`} onClick={handleRateDetail}>Rate Detail</span> : null}
                                                                    </div>
                                                                    <RateDetailsModal rateDetailModal={rateDetailModal} setRateDetailModal={setRateDetailModal} rateObj={rateObj} />
                                                                </>}
                                                            </>
                                                            }
                                                            {bandMsge ? <div className={`${faciltyData?.facility?.facility_configuration?.enable_facility_close == '1' ? 'mt-4 ' : ''}pb-3`}>
                                                                <p style={{ 'textWrap': 'balance' }} className={`${faciltyData?.facility?.facility_configuration?.enable_facility_close == '1' ? 'py-4 mb-0 fw-bold ' : isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Allow Entry for Valid Pass Holders') ? 'mb-3' : 'mb-0'} text-center alert alert-danger`}>{bandMsge} {(isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Allow Entry for Valid Pass Holders') && faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') ? 'If you have a valid pass, please provide any of the following details' : ''}</p>
                                                                {(isPermissionExist(sortPortalPermissionByKey(partnerDetailsRef?.current, 'Restricted Permissions'), 'Allow Entry for Valid Pass Holders') && faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') ? <>
                                                                    {/* <p className='text-center mt-5 mb-3'>If you have a valid pass, please provide any of the following details</p> */}
                                                                    <div className='btn-group align-items-center flex-wrap w-100 my-2 gap-2' role='group' aria-label='Small button group'>
                                                                        <div>
                                                                            <input type='radio' className='form-check-input' checked={passEntryCheck?.type == '0'} name='passRadio' id='passradio1' autoComplete='off' value='0' onChange={handlePassRadio} />
                                                                            <label htmlFor='passradio1' className='ms-1 fw-normal'>Pass</label>
                                                                        </div>
                                                                        <div>
                                                                            <input type='radio' className='form-check-input' checked={passEntryCheck?.type == '3'} name='passRadio' id='passradio4' autoComplete='off' value='3' onChange={handlePassRadio} />
                                                                            <label htmlFor='passradio4' className='ms-1 fw-normal'>Permit</label>
                                                                        </div>
                                                                        <div>
                                                                            <input type='radio' className='form-check-input' checked={passEntryCheck?.type == '1'} name='passRadio' id='passradio2' autoComplete='off' value='1' onChange={handlePassRadio} />
                                                                            <label htmlFor="passradio2" className='ms-1 fw-normal'>License Plate</label>
                                                                        </div>
                                                                        <div>
                                                                            <input type='radio' className='form-check-input' checked={passEntryCheck?.type == '2'} name='passRadio' id='passradio3' autoComplete='off' value='2' onChange={handlePassRadio} />
                                                                            <label htmlFor="passradio3" className='ms-1 fw-normal'>Mobile Number</label>
                                                                        </div>
                                                                    </div>
                                                                    {passEntryCheck?.type != '2' ? <Form.Group>
                                                                        <Form.Control
                                                                            type={passEntryCheck?.type == '2' ? 'tel' : 'text'}
                                                                            id='pass_code'
                                                                            placeholder={passEntryCheck?.type == '0' ? 'Enter Pass' : passEntryCheck?.type == '1' ? 'Enter License Plate' : passEntryCheck?.type == '3' ? 'Enter Permit' : ''}
                                                                            name='pass_code'
                                                                            maxLength='10'
                                                                            autoCapitalize="characters"
                                                                            value={passEntryCheck?.pass_code}
                                                                            // defaultValue={'123'}
                                                                            {...register('pass_code', {
                                                                                required: { value: true, message: 'This field is required' },
                                                                                minLength: { value: 2, message: 'Minimum 2 characters allowed' },
                                                                                maxLength: { value: 10, message: 'Maximum 10 characters allowed' },
                                                                                onBlur: (e) => handleBlur(e),
                                                                                onChange: (e) => handleEntryPass(e)
                                                                            })}
                                                                        />
                                                                        {errors?.pass_code && <Form.Text className="text-danger header-s">{errors?.pass_code?.message}</Form.Text>}
                                                                    </Form.Group> : ''}
                                                                    {passEntryCheck?.type == '2' ? <Form.Group>
                                                                        <Controller
                                                                            name="pass_code_phone"
                                                                            type="text"
                                                                            id="pass_code_phone"
                                                                            control={control}
                                                                            defaultValue=''
                                                                            inputmode="numeric"
                                                                            value={passEntryCheck?.pass_code_phone}
                                                                            rules={{
                                                                                required: { value: reservationData.reservationID ? false : true, message: 'This field is required' },
                                                                                minLength: { value: 10, message: 'Please enter valid number' },
                                                                                maxLength: { value: 10, message: 'Please enter valid number' },
                                                                            }}
                                                                            render={({ field }) => <MaskedInput
                                                                                maskGenerator={phoneMaskGenerator}
                                                                                className="form-control"
                                                                                {...field}
                                                                                id="pass_code_phone"
                                                                                inputMode="numeric"
                                                                                maxLength={14}
                                                                                value={passEntryCheck?.pass_code_phone}
                                                                                onChange={(e) => { field.onChange(e); handleEntryPass(getFieldValue('pass_code_phone', e)) }}
                                                                                // onChange={(e) => { field.onChange(e); handleChange(getFieldValue('phone', e)) }}
                                                                                onBlur={(e) => handleBlur(e)}
                                                                                title="Please enter a valid phone number"
                                                                                onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                                                                onInput={e => e.target.setCustomValidity('')}
                                                                                placeholder="(123)-555-1234"
                                                                            />
                                                                            }
                                                                        />
                                                                        {errors?.pass_code_phone && <Form.Text className="text-danger header-s">{errors?.pass_code_phone?.message}</Form.Text>}
                                                                    </Form.Group> : ''}
                                                                    <button type="submit" name="submit" className="btn w-100 text-white bg-primary mt-2" style={{ opacity: (isSubmittingForm ? true : loader) ? '0.8' : '1' }} onClick={handlePassCheck} disabled={(isSubmittingForm) ? true : loader} >
                                                                        <div className='d-flex justify-content-center align-items-center'>
                                                                            Submit
                                                                            {(isSubmittingForm ? true : false) ? <span className='ms-2'><Circles
                                                                                height="20"
                                                                                width="20"
                                                                                style={{ display: 'inline-block' }}
                                                                                color="#ffffff"
                                                                                ariaLabel="circles-loading"
                                                                                visible={true}
                                                                            /> </span> : null}
                                                                        </div>
                                                                    </button>
                                                                </> : ''}
                                                            </div> : ''}
                                                            {(updatedFacilityDate?.is_custom_picker_enabled == '1' && events?.length == 0 && !bandMsge) && <div className='p-0 m-0 d-flex justify-content-center align-items-center row'>
                                                                <div className={`${selctedDateTime?.bandActive ? '' : isRateBandSelected ? 'd-none' : ''} border border-2 rounded m-2 pb-2 pt-2`} onClick={() => openDateCalendar(true, selctedDateTime?.bandActive)} style={
                                                                    (partnerdetails?.brand_setting?.color && selctedDateTime?.bandActive) ? { backgroundColor: partnerdetails?.brand_setting?.color, color: '#fff' } : {}
                                                                }>
                                                                    <div className='pb-1 pt-1 d-flex justify-content-between align-items-center'>
                                                                        <div className='lh-sm'>{(selctedDateTime?.active && !isRateBandSelected) ? selctedDateTime?.daysHrs : 'Custom Date & Time'}<div className={`sub-label small ${selctedDateTime?.bandActive ? '' : 'text-muted'}`}><small>{(selctedDateTime?.active && !isRateBandSelected) ? 'Until ' + getDateFormatToshow(selctedDateTime?.dateUntill) : 'Select Date & Time'}</small></div></div>
                                                                        <span>{(selctedDateTime?.active && !isRateBandSelected) ? '$' + Number(selctedDateTime?.price).toFixed(2) : '--'}</span>
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                        </div>
                                                        {/* {entryDateTime} */}
                                                        {/* <div className='mt-3 mb-3'>
                                                <Form.Group>
                                                        <Form.Label className='text-primary  styleLables'>Pick Date & Time</Form.Label>
                                                        <Controller
                                                            name='entry_time'
                                                            id='entry_time'
                                                            control={control}
                                                            // rules={{required: { value: true, message: 'This field is required' }}}
                                                            render={({ field }) =>  <DatePicker
                                                            {...field}
                                                            selected={entryDateTime}
                                                            onChange={(date) => handleEntryTime(date)}
                                                            className="form-control specialBorder borderFix " 
                                                            autoComplete="off"
                                                            id="entry_time"
                                                            name='entry_time'
                                                            showTimeSelect
                                                            timeIntervals={5}
                                                            dateFormat="MMMM d, yyyy h:mm aa"
                                                        />}
                                                        />
                                                    </Form.Group>
                                                </div> */}
                                                        {/* <div className='mt-3 mb-3'>
                                                    <Form.Label className='text-primary  styleLables'>Pick Date & Time</Form.Label>
                                                    <Form.Group>
                                                        <Controller
                                                            name="phone"
                                                            type="text"
                                                            id="phone"
                                                            control={control}
                                                            inputMode="numeric"
                                                            defaultValue=''
                                                            autoFocus={false}
                                                            render={({ field }) => <MaskedInput
                                                                className="form-control"
                                                                {...field}
                                                                id="loginInputSingup"
                                                                maxLength={14}
                                                                inputMode="numeric"
                                                                // onChange={(e) => { field.onChange(e) handleChange(getFieldValue('phone', e)) }}
                                                                // onBlur={() => handleActiveCheckInCheck()}
                                                                onClick={openDateCalendar}
                                                                title="Please enter a valid phone number"
                                                                placeholder="Select Date"
                                                                value={entryDateTime}
                                                            />
                                                            }
                                                        />
                                                    </Form.Group>
                                                    <button className='form-control text-left' onClick={openDateCalendar}>{entryDateTime}</button>
                                                </div> */}
                                                    </>


                                                    : bandMsge ? <div className='py-3'><p style={{ 'textWrap': 'balance' }} className={`${faciltyData?.facility?.facility_configuration?.enable_facility_close == '1' ? 'py-4 mb-0 fw-bold ' : ''}text-center alert alert-danger mb-0`}>{bandMsge}</p></div> : <div className='mt-3'>
                                                        {(faciltyData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1' && !bandMsge) ? <Form.Label className='text-primary mb-0 pb-0 styleLables'>{events?.length > 0 ? 'Event Rates' : 'Stay Duration'} <span className='text-danger'>*</span></Form.Label> : ''}
                                                        <ReactMobiltySpinner
                                                            handleTimeLength={(e) => handleTimeLength(e)}
                                                            currDays={Number(timeDuration?.days)}
                                                            currHour={Number(timeDuration?.hours)}
                                                            currMin={Number(timeDuration?.minutes)}
                                                            isMultiParking={faciltyData?.facility?.is_multiday_parking != 0}
                                                            setIsRateBandSelected={setIsRateBandSelected}
                                                            setselctedDateTime={setselctedDateTime}
                                                            selctedDateTime={selctedDateTime}
                                                            setRateBandData={setRateBandData}
                                                            rateBandData={rateBandData}
                                                            events={events}
                                                            setIndexForCalc={setIndexForCalc}
                                                            indexForCalc={indexForCalc}
                                                            setSeletedRateBand={setSeletedRateBand}
                                                            customeLoaderForRateBand={customeLoaderForRateBand}
                                                            setCustomeLoaderForRateBand={setCustomeLoaderForRateBand}
                                                            partnerdetails={partnerdetails}
                                                            pageOnLoad={pageOnLoad}
                                                            setIsRateChangedWithPromo={setIsRateChangedWithPromo}
                                                            setFacilityData={setFaciltyData}
                                                            setIsPriceZero={setIsPriceZero}
                                                            isRateBandSelected={isRateBandSelected}
                                                            facilityData={faciltyData}
                                                            setTotalHoursLength={setTotalHoursLength}
                                                            totalHoursLength={totalHoursLength?.toString()}
                                                            setResetPromo={setResetPromo}
                                                            durationSelector={durationSelector}
                                                            setDurationSelector={setDurationSelector}
                                                            handleBlur={handleBlur}
                                                            hotel_type={faciltyData?.facility?.facility_configuration?.is_facility_hotel_type}
                                                            openDateCalendar={openDateCalendar}
                                                            currentSelVehicle={currentSelVehicle}
                                                            setEventMessage={setEventMessage}
                                                            eventMessage={eventMessage}
                                                            screen='home'
                                                            isRateBand={faciltyData?.facility?.is_price_band == '1'}
                                                            priceBreakAPI={() => { }}
                                                            // for the event and rate
                                                            setIsRateOrEventShow={setIsRateOrEventShow}
                                                            is_rate_or_event_show={is_rate_or_event_show}
                                                            resetBand={resetBand}
                                                            curRateBandRef={curRateBandRef}
                                                            oversizeLoader={oversizeLoader}
                                                            disableRates={disableRates}
                                                            ticketDetails={EMPTY_OBJECT}
                                                            dataOnLoad={EMPTY_OBJECT}
                                                            page='home'
                                                            setVerifyDetails={setVerifyDetails}
                                                        />
                                                        {(eventMessage && !priceBandLoad) ? <div className='p-0'><p className='small'>You are checkin against event <span className='fw-bold'>{eventMessage}</span></p></div> : ''}
                                                    </div>
                                                }
                                            </Col>
                                        </Row>}
                                    </div>
                                </Container>

                                {/*  section for Listing Data */}
                                {/* {!ticketDetails?.ticket_number && <div className="d-block border-bottom border-top py-3">
                                <ListingDataComp loader={loader} listData={listData} />
                            </div>}*/}

                                {/* PromoCode ---- */}
                                {/* {partner !== 'intrapark' && */}
                                {(isPromoValidateButton(faciltyData, ['1', '3']) && reservationData.reservationID === null && (!faciltyData?.permit_request_id || faciltyData?.permit_request_id == '') && !bandMsge) &&
                                    <PromoCode
                                        facility={facility}
                                        length={totalHoursLength}
                                        setStateList={setStateList}
                                        setFaciltyData={setFaciltyData}
                                        setValue={setValue}
                                        getValues={getValues}
                                        setPromoCode={setPromoCode}
                                        promoCode={promoCode}
                                        notify={notify}
                                        setErrorMessageLocal={setErrorMessageLocal}
                                        screen='transientForm'
                                        ticketDetails={faciltyData}
                                        setIsPriceZero={setIsPriceZero}
                                        discountAvailed='9'
                                        checkPromoWithLicense={faciltyData?.promocode_discount?.promocode?.promocode}
                                        checkPromo={checkPromo}
                                        event_id={selectedEv}
                                        setIsSubmittingForm={setIsSubmittingForm}
                                        isRateChangedWithPromo={isRateChangedWithPromo}
                                        setIsRateChangedWithPromo={setIsRateChangedWithPromo}
                                        setCustomeLoaderForRateBand={setCustomeLoaderForRateBand}
                                        isPromoCodeAppiled={isPromoCodeAppiled}
                                        setIsPromoCodeApplied={setIsPromoCodeApplied}
                                        setResetPromo={setResetPromo}
                                        resetPromo={resetPromo}
                                        selectedPastDate={selectedPastDate}
                                        setselctedDateTime={setselctedDateTime}
                                        selctedDateTime={selctedDateTime}
                                        durationSelector={durationSelector}
                                        getHoursIndate={getHoursIndate}
                                        reqIDcurr={getfacilityAPI}
                                    // NOTE:- faciltyData?.paid_type === '9' means ticket is not validated except from this restrict promocode:- condition from @Vikrant
                                    />
                                }
                                {/* {isPromoValidateButton(faciltyData, ['1', '3']) && walletButtonShow && !bandMsge ? <Container>
                                <div className='text-danger small lh-sm'>{errorMessage?.promoApplicableDisclaimer}</div>
                            </Container> : null} */}


                                {(faciltyData?.facility?.facility_configuration?.is_oversize_enabled && faciltyData?.facility?.facility_configuration?.is_oversize_enabled == 1 && !bandMsge) ? <Container className="my-2">
                                    <Form.Group className="d-flex">
                                        <input
                                            type="checkbox"
                                            id='is_vehicle_oversize'
                                            name='is_vehicle_oversize'
                                            {...register('is_vehicle_oversize', {
                                                onChange: (e) => handleChange(e)
                                            }
                                            )}
                                            disabled={(oversizeLoader || customeLoaderForRateBand || loader || isSubmittingForm || (fetchRateLoader && durationSelector == 0) || (faciltyData?.facility?.is_price_band == 1 && fetchRateLoader))}
                                            className='me-2'
                                            style={{ 'width': 'auto' }}
                                        />
                                        <Form.Label htmlFor='is_vehicle_oversize' className='d-flex align-items-center text-primary fw-bold mb-0 styleLables'>Oversized vehicle?</Form.Label>
                                    </Form.Group>

                                </Container> : null}

                                {(((ticketDetails?.is_checkout == '0') || !ticketDetails?.ticket_number) && !bandMsge) ? <>
                                    {reservationData.reservationID === null ? <div className="container pt-3 pb-5 overflow-hidden no-ticket-view">
                                        {isPriceZero && (faciltyData?.display_msg) ? <div className='container'><p className='small mb-1'>{faciltyData.display_msg}</p></div> : ''}
                                        <div className={(!priceGreaterOrNot(faciltyData) && !loader) ? 'card shadow rounded-lg receiptCard no-view' : 'card shadow rounded-lg receiptCard'}>
                                            {/* {(priceGreaterOrNot(faciltyData) && !loader) && <p className='text-primary fw-semibold py-3 px-2 mx-3 mb-2 bg-opacity-10 custom-dashed-border' >Price Breakdown</p>} */}

                                            <PaymentBreakUpDetails
                                                loader={((customeLoaderForRateBand || loader) && !isSubmittingForm)}
                                                isSubmittingForm={isSubmittingForm}
                                                // faciltyData={faciltyData}
                                                paymentData={faciltyData}
                                                className='py-2 d-flex'
                                                sectionKey={(faciltyData?.payable_amount) ? '' : 'paymantResponse'}
                                                isDisplayDetails={true}
                                                setIsDisplayDetails={setIsDisplayDetails}
                                            />
                                            <div className="card-footer">
                                                {((customeLoaderForRateBand || loader) && !isSubmittingForm) ? null : <AmountPaid
                                                    className='py-2 pb-3 px-2'
                                                    paymentData={faciltyData}
                                                    paybleText="Amount Due"
                                                    hideTaxIncluded={(faciltyData?.payable_amount > 0 && (((faciltyData?.tax_fee && faciltyData?.tax_fee != '0.00') || (faciltyData?.tax_rate && faciltyData?.tax_rate != '0.00')))) ? false : true}
                                                    setIsDisplayDetails={setIsDisplayDetails}
                                                    isInfo
                                                    sectionKey={'payableAmount'}
                                                    isTokenApiStarts={isTokenApiStarts}
                                                    cardInside
                                                />}
                                            </div>
                                        </div>
                                    </div> : ''} </> : ''
                                }
                                {((ticketDetails?.is_checkout == '0') || !ticketDetails?.ticket_number) ? '' : <Container>
                                    <Col>
                                        <Form.Group>
                                            <p className='textColorText small mt-3'>
                                                {errorMessage?.activeCheckinMessage}
                                            </p>
                                        </Form.Group>
                                    </Col>
                                </Container>}
                                {(((ticketDetails?.is_checkout == '0') || !ticketDetails?.ticket_number) && (((faciltyData?.facility?.facility_configuration?.terms_condition_content && faciltyData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '')) && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox')) && faciltyData?.facility?.facility_configuration?.enable_facility_close != '1') ? <Col className="m-2">
                                    {/* <Form.Group className="d-flex">
                                            <input
                                                type="checkbox"
                                                id='termsnconds'
                                                name='termsnconds'
                                                {...register('termsnconds', {
                                                    required: { value: (((faciltyData?.facility?.facility_configuration?.terms_condition_content && faciltyData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '')) && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox')) ? true : false, message: 'Please accept the Terms and Conditions' },
                                                })}
                                                className='me-2'
                                                style={{ 'width': 'auto' }}
                                                onChange={() => termsChangeHandler()}
                                            />
                                            <Form.Label className='small fw-normal mb-0'>I have read and agreed to the <span className="fw-bold text-primary" onClick={() => { handleScroll() }}> Terms and Conditions</span> <span className='text-danger'>*</span></Form.Label>

                                    </Form.Group> */}
                                    <Form.Check>
                                        <Form.Check.Input
                                            type="checkbox"
                                            id="termsnconds"
                                            name='termsnconds'
                                            checked={getValues('termsnconds') ? true : false}
                                            disabled={isSubmittingForm || loader}
                                            {...register('termsnconds', {
                                                required: { value: (((faciltyData?.facility?.facility_configuration?.terms_condition_content && faciltyData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '')) && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox')) ? true : false, message: 'Please accept the Terms and Conditions' },
                                                onChange: (e) => termsChangeHandler(e)
                                            })}
                                        />
                                        <Form.Check.Label className='fw-normal small'>
                                            I have read and agreed to the <span className="fw-bold text-primary" onClick={() => { handleScroll() }}> Terms and Conditions</span> <span className='text-danger'>*</span>
                                        </Form.Check.Label>
                                    </Form.Check>
                                    {errors?.termsnconds && <Form.Text className="text-danger header-s">{errors?.termsnconds?.message}</Form.Text>}
                                </Col> : null
                                }
                                {bandMsge ? '' : <div>
                                    {((ticketDetails?.is_checkout == '0') || !ticketDetails?.ticket_number) ?
                                        /* new payment gateway */
                                        (verifyDetails && walletButtonShow) ? <div className='m-2 p-2'>
                                            <button type="submit" name="submit" className="btn w-100 text-white bg-primary" style={{ opacity: (isSubmittingForm ? true : loader) ? '0.7' : '1' }} onClick={detailsVerification} disabled={(isSubmittingForm) ? true : loader} >
                                                <div className='d-flex justify-content-center align-items-center'>
                                                    <h5 className='mb-0 fw-bold'>{isPriceZero ? 'Start Parking' : 'Proceed to Pay'}</h5> <span className='ms-2'>
                                                        {((isSubmittingForm) ? true : false) ? <Circles
                                                            height="20"
                                                            width="20"
                                                            style={{ display: 'inline-block' }}
                                                            color="#ffffff"
                                                            ariaLabel="circles-loading"
                                                            visible={true}
                                                        /> : null}
                                                    </span>
                                                </div>
                                            </button>
                                        </div> :
                                            <>
                                                {(reservationData.reservationID === null) ? <div className={(!isPriceZero && !verifyDetails) ? 'p-4 pb-0' : 'card m-2 paymentCardRadious p-2'}>
                                                    {(loginData?.access_token) ?
                                                        <>
                                                            {/* Display Fast Track Enable Message and Card Associated with and Remove Option, When Removed display Existing Cards */}
                                                            {
                                                                Number(faciltyData?.payable_amount) > 0 && fastTrackData && Object.keys(fastTrackData).length > 0 && isFastTrackChecked && isFastTrackCard ?

                                                                    <Card className='m-2 paymentCardRadious p-2'><Card style={{ outline: '3px solid  #26a8e066' }} className='border bg-info bg-opacity-10 border-info mb-6 p-3 '>
                                                                        <span className='text-primary small'>
                                                                            You dont need to enter payment details, since Fast Track is enabled for your License Plate, Card associated is ending with <b>{fastTrackData?.card_last_four}</b>.
                                                                            <a className='btn btn-link text-primary p-0 d-block text-start mt-2 ' onClick={() => handleChangeFastTrackCard()}>Wants to change your Card?</a>
                                                                        </span>

                                                                    </Card></Card> :
                                                                    Number(faciltyData?.payable_amount) > 0 ? <Card>

                                                                        <span className='VehilceLables d-flex justify-content-between align-items-start cursor'>Enter Payment Details <span onClick={handlePaymentModal}><i className='fa fa-plus small'></i> Add New Card</span></span>
                                                                        <ListGroup as="ol" onClick={() => handleCommonListModal('Card')} className='mt-2'>
                                                                            <ListGroup.Item as="li" className="ps-1 d-flex justify-content-between align-items-start">
                                                                                {/* <Image className='img-10' src={card_top_image} /> */}
                                                                                <span style={{ height: '25px', width: '25px' }}>{getSvgIcon('Credit_card', 'var(--bs-primary)')}</span>
                                                                                <div className="ms-2 me-auto text-secondary">Payment Method</div>
                                                                                {(currentSelCard?.card_last_four) ? <div className='ms-2' style={{ marginTop: '-1px', marginRight: '3px' }}><Image src={getCardIcon(currentSelCard?.card_type)} style={{ height: '1.1rem', 'marginTop': '-0.2rem' }} /> <span className='text-primary fw-semibold me-1' >{currentSelCard?.card_last_four}</span></div> : <i className="fa fa-credit-card mr-2" style={{ marginRight: '0.5rem', marginTop: '4px' }} ></i>}
                                                                                <i className='fa fa-caret-down mt-1' style={{ fontSize: '13px' }}></i>
                                                                            </ListGroup.Item>
                                                                        </ListGroup>

                                                                        {fastTrackData && Object.keys(fastTrackData).length > 0 && isFastTrackChecked && !isFastTrackCard ? <button
                                                                            type='button'
                                                                            className='btn btn-danger btn-sm'
                                                                            onClick={() => handleChangeFastTrackCard()}
                                                                        >Cancel</button> : ''}
                                                                    </Card> : ''}
                                                        </>
                                                        :
                                                        <Card className='m-2 paymentCardRadious p-2'>
                                                            <PaymentGateDc
                                                                faciltyData={faciltyData}
                                                                loader={loader}
                                                                isSubmittingForm={isSubmittingForm}
                                                                errors={errors}
                                                                register={register}
                                                                control={control}
                                                                onSubmit={handleSubmit(walletButtonShow ? handlePostSubmission : onSubmit)}
                                                                isTokenApiStarts={isTokenApiStarts}
                                                                isInScreen
                                                                setFocus={setFocus}
                                                                isPriceZero={isPriceZero}
                                                                isFastTrackChecked={isFastTrackChecked}
                                                                fastTrackData={fastTrackData}
                                                                restrictedPermission={sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions')}
                                                                setCardToken={setCardToken}
                                                                handleChangeFastTrackCard={handleChangeFastTrackCard}
                                                                isFastTrackCard={isFastTrackCard}
                                                                multiPaymentWithWallet={!isPriceZero && !verifyDetails}
                                                                paybyCard={true}
                                                                firstTimeFastTrackEnable={firstTimeFastTrackEnable}
                                                                setFirstTimeFastTrackEnable={setFirstTimeFastTrackEnable}

                                                            />
                                                        </Card>
                                                    }
                                                </div> : ''}
                                                {(loginData?.access_token || reservationData.reservationID) && <div className="ms-2 mb-2 me-2 mt-4">
                                                    <button type="submit" name="submit" className="btn w-100 text-white bg-primary" style={{ opacity: (isSubmittingForm ? true : loader) ? '0.7' : '1' }} onClick={handleSubmit(walletButtonShow ? handlePostSubmission : onSubmit)} disabled={(isSubmittingForm) ? true : loader} >
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            <h5 className='mb-0 fw-bold'>Start Parking</h5> <span className='ms-2'>
                                                                {((isSubmittingForm) ? true : false) ? <Circles
                                                                    height="20"
                                                                    width="20"
                                                                    style={{ display: 'inline-block' }}
                                                                    color="#ffffff"
                                                                    ariaLabel="circles-loading"
                                                                    visible={true}
                                                                /> : null}
                                                            </span>
                                                        </div>
                                                    </button>
                                                </div>}
                                                {(!isPriceZero && !verifyDetails && walletButtonShow && ((((faciltyData?.facility?.facility_configuration?.terms_condition_content && faciltyData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '')) && termsAndCondition && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox')) || !isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox'))) ?
                                                    <WalletButtons paybyCard={true} faciltyData={faciltyData} getValues={getValues} onSubmit={handlePostSubmission} setIsSubmittingForm={setIsSubmittingForm} isSubmittingForm={isSubmittingForm} isIOSDevice={isIOSDevice} applePaySessionRef={applePaySessionRef} />
                                                    : null}
                                            </> : <Container><Link to={`/${partner}${URL?.TICKET_DETAILS}`} className="btn w-100 my-4 fw-bold text-white bg-primary">Check Details</Link></Container>
                                    }
                                </div>}
                                {(partner == 'usmparking' || partner == 'usm') ? <div className='container'><a href='https://usm.maine.edu/parking-services/' target='_blank' rel="noopener noreferrer" style={{ color: 'blue' }} className="small m-0"><i className='fa fa-link'></i> Access Options/Where to Park/Rules </a></div> : ''}
                                {(faciltyData?.facility?.facility_configuration?.terms_condition_content && faciltyData?.facility?.facility_configuration?.terms_condition_content != '' && isHtmlRenderingVisibleContent(faciltyData?.facility?.facility_configuration?.terms_condition_content)) || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '' && isHtmlRenderingVisibleContent(partnerDetails?.brand_setting?.terms_condition_content)) ?
                                    <Container>
                                        <div ref={targetRef} className="m-2 p-2 card" dangerouslySetInnerHTML={{ __html: faciltyData?.facility?.facility_configuration?.terms_condition_content ? faciltyData?.facility?.facility_configuration?.terms_condition_content : partnerDetails?.brand_setting?.terms_condition_content }} />
                                    </Container> :
                                    null}
                            </div>
                            :
                            <NoData message={(errorMessageLocal) ? errorMessageLocal : errorMessage?.invalidFacility} />
                    : <NoData message={errorMessage?.invalidPartner} />}

                <PaymentBreakUpDetails
                    loader={((customeLoaderForRateBand || loader) && !isSubmittingForm)}
                    // faciltyData={faciltyData}
                    isSubmittingForm={isSubmittingForm}
                    paymentData={faciltyData}
                    className='py-2'
                    sectionKey={(faciltyData?.payable_amount) ? '' : 'paymantResponse'}
                    isDisplayDetails={isDisplayDetails}
                    setIsDisplayDetails={setIsDisplayDetails}
                />
                <VehicleHod isVehicleModalOpen={isVehicleModalOpen} setIsVehicleModalOpen={setIsVehicleModalOpen} notify={notify} isInTransient vehicleModel={vehicleModel} />
                <PaymentModal isPaymentModalOpen={isPaymentModalOpen} setIsPaymentModalOpen={setIsPaymentModalOpen} notify={notify} isInScreen />
                <CommonListModal setCommonModal={setCommonModal} isCommonModalOpen={isCommonModalOpen} listData={(selOptionFlag === 'Vehicle') ? vehicleDataList : cards} isThisVehicleModal={(selOptionFlag === 'Vehicle') ? true : false} register={register} handleCurrentSelection={handleCurrentSelection} currentSelVehicle={currentSelVehicle} currentSelCard={currentSelCard} />
                <ScrollCalendar
                    isScrollCalendarModal={isScrollCalendarModal}
                    setIsScrollCalendarModal={setIsScrollCalendarModal}
                    setEntryDateTime={setEntryDateTime}
                    handleEntryTime={handleEntryTime}
                    entryDateTime={entryDateTime}
                    isDateShow={false}
                    setSeletedRateBand={setSeletedRateBand}
                    hotel_type={faciltyData?.facility?.facility_configuration?.is_facility_hotel_type}
                    partnerdetails={partnerdetails}
                    startDate={(selectedPastDate) ? moment(selectedPastDate, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm A') : ''}
                    selectedPastDate={selectedPastDate}
                    ticketDetails={EMPTY_OBJECT}
                />
                {/* rate band modal*/}
                <RateBandDropDownList setIsRateBandModal={setIsRateBandModalOpen} isRateBandModal={isRateBandModalOpen} listData={rateBandData} register={register} handleCurrentSelection={handleCurrentSelection} />
                {/* IF NEED TO DISPLAY THE TIMER OF ACTIVE CHECKIN */}
                {/* <ActiveSession activeSessionData={activeSessionData}/> */}
                {/* <Footer /> */}
                <ConfirmationTerms
                    isConfimationModalOpen={isConfimationModalOpen}
                    setIsConfimationModalOpen={setIsConfimationModalOpen}
                    setIsSubmittingForm={setIsSubmittingForm}
                    isSubmittingForm={isSubmittingForm}
                    Message={activesessionMessage}
                    cancelButton={true}
                    SubmitButton={false}
                    isHandleSubmit
                    cancelButtonLabel='No'
                    SubmitButtonLable='Yes'
                    SubmitButtonColor='text-primary'
                    handleSubmit={loginData?.access_token ? handleLoggedInUserCheckIn : handleGuestUserCheckIn}
                    warning='1'
                    data={formData}
                    setWarningState={setWarningState}
                />

                <ParkingSchModal
                    isModalOpen={warningMessageSchdule}
                    setIsModalOpen={setWarningPark}
                    setIsSubmittingForm={setIsSubmittingForm}
                    Message={warningMessage}
                    data={hoursOfOper}
                    midnighNote={midnighNote}
                    isHandleSubmit
                    cancelButton={true}
                    SubmitButton={false}
                    cancelButtonLabel='No'
                    SubmitButtonLable='Yes'
                    SubmitButtonColor='text-primary'
                    handleSubmit={handleSubmitAction}
                />

                <ConfirmationTerms
                    setIsSubmittingForm={setIsSubmittingForm}
                    isConfimationModalOpen={avalablityAlert}
                    setIsConfimationModalOpen={resetFormRates}
                    Message={availabilityMessage}
                    cancelButton={true}
                    cancelButtonLabel='OK'
                    cancleButtonColor='text-primary'
                />
                <ConfirmationModalCommon
                    isConfimationModalOpen={isModalFastTrackOpen}
                    setIsConfimationModalOpen={setIsModalFastTrackOpen}
                    finalAction={handelFastracModel}
                    message='Are you sure you want to disable the Fast Track option?'
                />
                {isRateMisMatch ? <div className='h-100 w-100 zIndexHigh position-fixed'>
                    <div className='h-100 opacity-50 bg-secondary w-100'>

                    </div>
                    <div className='bg-white p-2 rounded m-2 position-fixed top-40'>
                        <p>{mismatchRateError}</p>
                        <p className="text-end m-0 p-0">
                            <button
                                type="button"
                                className='btn text-white bg-primary'
                                onClick={() => reFetchFacilityParkingData()}
                            ><div className='d-flex justify-content-center align-items-center'>
                                    <span>Refresh</span><span className='ms-2'>
                                        {(loader) ? <Circles
                                            height="20"
                                            width="20"
                                            style={{ display: 'inline-block' }}
                                            color="#ffffff"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        /> : null}
                                    </span>
                                </div></button>
                        </p>
                    </div>
                </div> : null}
                {/* <Modal isOpen={isReloadRates.modal} toggle={toggleRevisedPrice}>
                <ModalHeader toggle={toggleRevisedPrice}>Revised rates</ModalHeader>
                <ModalBody>
                    We have revised your rates based on your entry time.
                </ModalBody>
            </Modal> */}
                {isReloadRates?.modal && <div className='h-100 w-100 zIndexHigh position-fixed'>
                    <div className='h-100 opacity-50 bg-secondary w-100'>

                    </div>
                    <div className='bg-white p-2 rounded position-fixed top-40 ratesPopup'>
                        <p>We have revised your rates based on your entry time.</p>
                        <p className="text-end m-0 p-0">
                            <button
                                type="button"
                                className='btn text-white bg-primary'
                                onClick={() => toggleRevisedPrice()}
                            ><div className='d-flex justify-content-center align-items-center'>
                                    <span>Close</span>
                                </div></button>
                        </p>
                    </div>
                </div>}
            </div>
    )


}

TransientForm.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    notify: PropTypes.func,
    cards: PropTypes.array,
    vehicleDataList: PropTypes.array,
    isFetchingPartner: PropTypes.bool,
    partnerDetails: PropTypes.object,
    facility_loaded: PropTypes.bool,
    priceBandLoad: PropTypes.bool,
    fetchRateLoader: PropTypes.bool,
    isWelcomePopup: PropTypes.string
}

TransientForm.defaulProps = {
    dispatch: noop,
    loader: true,
    isFetching: true,
    notify: noop,
    cards: EMPTY_ARRAY,
    vehicleDataList: EMPTY_ARRAY,
    isFetchingPartner: true,
    partnerDetails: EMPTY_OBJECT,
    facility_loaded: false,
    priceBandLoad: false,
    fetchRateLoader: false,
    isWelcomePopup: undefined
}

function mapStateToProps({ transientReducer, PaymentReducer, VehilceReducer, userDetailsReducer }) {
    const { data } = VehilceReducer

    const { isWelcomePopup, priceBandAPI, fetchRateLoader, loader } = transientReducer
    return {
        loader: loader,
        isFetching: loader,
        fetchRateLoader: fetchRateLoader,
        cards: PaymentReducer?.data?.data?.payments,
        vehicleDataList: data?.data?.data,
        isFetchingPartner: userDetailsReducer?.isFetching,
        priceBandLoad: priceBandAPI,
        isWelcomePopup
    }
}

export default connect(mapStateToProps)(TransientForm)